import { jsx as e, jsxs as l, Fragment as le } from "react/jsx-runtime";
import { Button as fe, Flex as U, Box as u, defineStyleConfig as L, createMultiStyleConfigHelpers as Ce, defineStyle as Y, extendTheme as Be, Text as p, Stack as se, useTheme as tt, FormControl as je, InputGroup as xe, InputLeftElement as Lt, Image as Fe, Input as He, FormLabel as rt, FormHelperText as Mt, FormErrorMessage as Ue, HStack as J, Skeleton as Oe, VStack as ne, Badge as ht, Divider as ve, Radio as ze, Select as rr, useDisclosure as or, RadioGroup as nr, AlertDialog as ar, AlertDialogOverlay as ir, AlertDialogContent as lr, AlertDialogHeader as sr, AlertDialogBody as dr, AlertDialogFooter as cr, useBreakpointValue as Tt, Heading as ft, IconButton as Ft, Spinner as br, Modal as pr, ModalOverlay as gr, ModalContent as ur, ModalCloseButton as mr, ModalBody as hr, ModalFooter as fr } from "@chakra-ui/react";
import yt, { createContext as Fr, useContext as yr, useState as P, useEffect as X, useRef as Q, useMemo as Z, useCallback as M, forwardRef as $e, useId as xr } from "react";
import { checkboxAnatomy as ke } from "@chakra-ui/anatomy";
import { AnimatePresence as We, motion as Se } from "framer-motion";
import { createPortal as Pt } from "react-dom";
import { CloseIcon as Ve, ChevronDownIcon as Nt, AddIcon as vr, ChevronRightIcon as xt, ChevronLeftIcon as Sr, SearchIcon as Cr, StarIcon as Br } from "@chakra-ui/icons";
import { formatPrice as oe } from "@getjust/commons";
import { Controller as Yt } from "react-hook-form";
import vt from "currency.js";
import kr from "react-phone-number-input";
import { useDebouncedCallback as wr } from "use-debounce";
const Re = ({
  label: t,
  variant: r,
  onClick: a,
  Icon: o,
  imageProps: n,
  trackingId: d,
  ...s
}) => {
  const c = r === "aurora";
  return /* @__PURE__ */ e(
    fe,
    {
      variant: r,
      onClick: a,
      gap: 1.5,
      p: r === "aurora" ? "2px" : 0,
      ...s,
      className: "loading-container",
      "data-ph-capture-attribute-tracking-id": d,
      children: /* @__PURE__ */ l(
        U,
        {
          bgColor: c ? "var(--card-bg, #FFF)" : "transparent",
          borderRadius: c ? "28px" : "none",
          w: "full",
          h: "full",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.375rem",
          children: [
            o ? yt.isValidElement(o) ? o : yt.createElement(o) : null,
            t,
            r === "skeleton" && /* @__PURE__ */ e(u, { className: "loading-bar", animation: "loadingAnimation 1800ms 0ms infinite" })
          ]
        }
      )
    }
  );
};
Re.defaultProps = {
  border: "md",
  variant: "primary",
  isLoading: !1
};
const Er = L({
  // The styles all Box have in common
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "gray.601",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    color: "black.900"
  },
  // The default variant value
  defaultProps: {
    variant: "primary"
  }
}), Ir = L({
  // The styles all Buttons have in common
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite classic', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "gray.601",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    borderRadius: "6rem"
  },
  variants: {
    primary: {
      color: "white",
      backgroundColor: "buttonBlack.900",
      _hover: {
        backgroundColor: "buttonBlack.500"
      },
      _active: {
        backgroundColor: "buttonBlack.900"
      },
      _loading: {
        backgroundColor: "buttonBlack.900 !important",
        fontSize: "1.5rem",
        color: "#FFF !important"
      }
    },
    secondary: {
      color: "gray.701",
      backgroundColor: "gray.602",
      _hover: {
        backgroundColor: "gray.602"
      },
      _active: {
        backgroundColor: "gray.602"
      },
      _loading: {
        backgroundColor: "gray.602 !important",
        color: "#FFF !important"
      }
    },
    disabled: {
      color: "gray.603",
      backgroundColor: "gray.601",
      _hover: {
        backgroundColor: "gray.601"
      },
      _active: {
        backgroundColor: "gray.601"
      },
      _loading: {
        backgroundColor: "gray.601 !important",
        color: "#FFF !important"
      }
    },
    aurora: {
      fontSize: "18px",
      color: "#1C1C1C",
      borderRadius: "28px",
      background: "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
      _hover: {
        backgroundColor: "buttonBlack.500"
      },
      _active: {
        backgroundColor: "buttonBlack.900"
      },
      _loading: {
        backgroundColor: "buttonBlack.900 !important",
        fontSize: "1.5rem",
        color: "#FFF !important"
      }
    }
  },
  // The default variant value
  defaultProps: {
    variant: "primary"
  }
}), { definePartsStyle: Xe, defineMultiStyleConfig: _r } = Ce(ke.keys), Ar = {
  md: Xe({
    control: Y({
      h: "20px",
      w: "20px"
    }),
    label: Y({
      fontSize: "sm",
      fontWeight: 400,
      lineHeight: "20px"
    })
  }),
  sm: Xe({
    control: Y({
      h: "16px",
      w: "16px"
    }),
    label: Y({
      fontSize: "xs",
      fontWeight: 350,
      lineHeight: 5
    })
  })
}, Dr = Xe({
  label: {
    color: "#8F8F8F",
    fontSize: "sm",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  control: {
    borderRadius: "4px",
    borderWidth: "1px",
    alignSelf: "flex-start",
    marginTop: "2px",
    _checked: {
      bg: "#585858",
      borderColor: "#585858",
      _hover: {
        bg: "#585858",
        borderColor: "#585858"
      }
    }
  }
}), zr = _r({ baseStyle: Dr, sizes: Ar }), Wr = Y({
  borderWidth: "1px",
  borderStyle: "dashed"
}), jr = L({
  variants: { dashed: Wr }
}), St = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(-0.02rem)",
  fontSize: "sm"
}, be = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(0.25rem)",
  fontSize: "sm"
}, Hr = L({
  variants: {
    floating: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...be
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...be,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          fontWeight: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontsize: "md"
        }
      }
    },
    floatingWithIcon: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...St
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...St,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 10,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "inherit !important",
          fontsize: "md"
        }
      }
    },
    mobileSelect: {
      //@ts-expect-error ts error
      container: {
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...be
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...be,
          display: "flex"
        },
        label: {
          transform: "scale(0.75) translateY(-0.5rem)",
          fontSize: "sm",
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    },
    baseSelect: {
      //@ts-expect-error ts error
      container: {
        bg: "transparent",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...be
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...be,
          display: "flex"
        },
        label: {
          bg: "transparent",
          fontSize: "md",
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    }
  },
  defaultProps: {
    variant: "floating"
  }
}), Ur = {
  border: "1px solid",
  borderColor: "gray.602",
  color: "fullBlack.900",
  borderRadius: "1.875rem",
  h: "14",
  pt: "3"
}, ot = {
  p: "1px",
  borderRadius: "1.875rem"
}, nt = {
  bgGradient: "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
  bg: ""
}, at = {
  bg: "danger.main !important",
  bgGradient: ""
}, it = {
  bg: "gray.602 !important",
  bgGradient: ""
}, lt = {
  bg: "gray.602 !important",
  bgGradient: ""
}, st = {
  bgGradient: "linear-gradient(90deg, rgba(141, 230, 144, 0.10) 2.08%, rgba(165, 240, 163, 0.10) 18.23%, rgba(166, 236, 215, 0.10) 33.33%, rgba(151, 218, 218, 0.10) 51.56%, rgba(179, 218, 231, 0.10) 67.71%, rgba(182, 201, 236, 0.10) 83.33%, rgba(135, 154, 203, 0.10) 100%), var(--input-bg, #FFF) !important",
  bg: ""
}, dt = {
  bg: "var(--input-bg, #FFF) !important",
  bgGradient: ""
}, ct = {
  bg: "var(--input-bg, #FFF)",
  bgGradient: ""
}, bt = {
  bg: "var(--input-bg, #FFF)",
  bgGradient: ""
}, qt = {
  bg: "var(--input-bg, #FFF) !important",
  opacity: 1,
  color: "gray.701 !important"
}, $r = {
  bg: "var(--input-bg, #FFF)"
}, pt = {
  borderRadius: "1.875rem",
  filter: "blur(4px)",
  content: '""',
  position: "absolute",
  top: "-1px",
  right: "-1px",
  bottom: "-1px",
  left: "-1px",
  bgImage: "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
  bgClip: "border-box"
}, Rr = {
  boxShadow: "0 0 0 30px #F5FBFB inset !important",
  WebkitBoxShadow: "0 0 0 30px #F5FBFB inset !important",
  MozBoxShadow: "0 0 0 30px #F5FBFB inset !important"
}, Ct = {
  ...Ur,
  _disabled: qt,
  _focusVisible: $r,
  _autofill: Rr
}, Gr = L({
  variants: {
    just: {
      field: {
        ...Ct
      }
    },
    justUnstyled: {
      field: {
        ...Ct,
        _focusVisible: {
          boxShadow: "transprarent !important",
          bgGradient: "transprarent !important",
          bg: "#FFF !important"
        },
        _invalid: {
          boxShadow: "#FFF !important",
          bgGradient: "#FFF !important",
          bg: "#FFF !important"
        },
        border: "#FFF !important",
        bgGradient: "#FFF !important",
        bg: "#FFF !important"
      }
    }
  },
  // The default variant value
  defaultProps: {
    variant: "just"
  }
}), Lr = L({
  sizes: {
    lg: {
      control: { w: "5", h: "5" },
      label: { fontSize: "md", width: "full" }
    }
  }
}), Ot = Be({
  fonts: {
    heading: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    span: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    p: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    just: "0px 6px 10px rgba(0, 0, 0, 0.08), 0px 1px 18px rgba(0, 0, 0, 0.06), 0px 3px 5px rgba(0, 0, 0, 0.1)"
  },
  components: {
    Button: Ir,
    Divider: jr,
    Form: Hr,
    Input: Gr,
    Radio: Lr,
    Box: Er,
    Checkbox: zr
  },
  themedClasses: {
    inputBackgroundDisabledStyle: dt,
    inputBackgroundEmptyStyle: ct,
    inputBackgroundGradientStyle: st,
    inputBackgroundInvalidStyle: bt,
    inputBorderDisabledStyle: lt,
    inputBorderEmptyStyle: it,
    inputBorderGradientStyle: nt,
    inputBorderInvalidStyle: at,
    inputBorderStyle: ot,
    inputBoxShadowGradientStyle: pt
  },
  colors: {
    brand: {
      yellow: "#FFA908",
      green: "#A1FB86",
      fushia: "#EDBFFB"
    },
    fullBlack: {
      50: "#282525",
      500: "#262323",
      900: "#1C1C1C"
    },
    buttonBlack: {
      50: "#8F8F8F",
      500: "#1C1C1C",
      900: "#050505"
    },
    yellowScheme: {
      50: "#FFD587",
      500: "#FFD587",
      900: "#FFA908"
    },
    gray: {
      601: "#F7F7F7",
      602: "#E0E0E0",
      603: "#8F8F8F",
      701: "#585858",
      801: "#1C1C1C"
    },
    danger: {
      main: "#EE5829",
      text: "#EE5829"
    },
    focus: {
      main: "#0F4C8F",
      error: "#E9553A"
    }
  }
}), Mr = L({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#3D3D3D",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    color: "white"
  },
  defaultProps: {
    variant: "primary"
  }
}), Tr = L({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite classic', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#3D3D3D",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    borderRadius: "6rem"
  },
  variants: {
    primary: {
      color: "#1C1C1C",
      background: "#FFFFFF",
      _hover: {
        opacity: 0.9
      },
      _active: {
        opacity: 0.8
      },
      _loading: {
        background: "#FFFFFF !important",
        fontSize: "1.5rem",
        color: "#1C1C1C !important"
      }
    },
    secondary: {
      color: "#FFFFFF",
      backgroundColor: "#585858",
      _hover: {
        backgroundColor: "#6B6B6B"
      },
      _active: {
        backgroundColor: "#4A4A4A"
      },
      _loading: {
        backgroundColor: "#585858 !important",
        color: "#FFFFFF !important"
      }
    },
    disabled: {
      color: "#8F8F8F",
      backgroundColor: "#3D3D3D",
      _hover: {
        backgroundColor: "#3D3D3D"
      },
      _active: {
        backgroundColor: "#3D3D3D"
      },
      _loading: {
        backgroundColor: "#3D3D3D !important",
        color: "#8F8F8F !important"
      }
    },
    aurora: {
      fontSize: "18px",
      color: "#1C1C1C",
      borderRadius: "28px",
      background: "#FFFFFF",
      _hover: {
        opacity: 0.9
      },
      _active: {
        opacity: 0.8
      },
      _loading: {
        background: "#FFFFFF !important",
        fontSize: "1.5rem",
        color: "#1C1C1C !important"
      }
    }
  },
  defaultProps: {
    variant: "primary"
  }
}), { definePartsStyle: Ke, defineMultiStyleConfig: Pr } = Ce(ke.keys), Nr = {
  md: Ke({
    control: Y({
      h: "20px",
      w: "20px"
    }),
    label: Y({
      fontSize: "sm",
      fontWeight: 400,
      lineHeight: "20px"
    })
  }),
  sm: Ke({
    control: Y({
      h: "16px",
      w: "16px"
    }),
    label: Y({
      fontSize: "xs",
      fontWeight: 350,
      lineHeight: 5
    })
  })
}, Yr = Ke({
  label: {
    color: "#B0B0B0",
    fontSize: "sm",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  control: {
    borderRadius: "4px",
    borderWidth: "1px",
    borderColor: "#585858",
    bg: "transparent",
    alignSelf: "flex-start",
    marginTop: "2px",
    _checked: {
      bg: "#FFFFFF",
      borderColor: "#FFFFFF",
      color: "#1C1C1C",
      _hover: {
        bg: "#E0E0E0",
        borderColor: "#E0E0E0"
      }
    }
  }
}), qr = Pr({ baseStyle: Yr, sizes: Nr }), Or = Y({
  borderWidth: "1px",
  borderStyle: "dashed",
  borderColor: "#585858"
}), Vr = L({
  baseStyle: {
    borderColor: "#585858"
  },
  variants: { dashed: Or }
}), Bt = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(-0.02rem)",
  fontSize: "sm"
}, pe = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(0.25rem)",
  fontSize: "sm"
}, Xr = L({
  variants: {
    floating: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#B0B0B0",
        _hover: {
          label: {
            color: "#B0B0B0"
          }
        },
        _focusWithin: {
          label: {
            ...pe
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...pe,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#8F8F8F"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          fontWeight: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#262323",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontsize: "md"
        }
      }
    },
    floatingWithIcon: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#B0B0B0",
        _hover: {
          label: {
            color: "#B0B0B0"
          }
        },
        _focusWithin: {
          label: {
            ...Bt
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...Bt,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#8F8F8F"
          },
          textAlign: "left",
          top: 4,
          left: 10,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#262323",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "inherit !important",
          fontsize: "md"
        }
      }
    },
    mobileSelect: {
      //@ts-expect-error ts error
      container: {
        color: "#B0B0B0",
        _hover: {
          label: {
            color: "#B0B0B0"
          }
        },
        _focusWithin: {
          label: {
            ...pe
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...pe,
          display: "flex"
        },
        label: {
          transform: "scale(0.75) translateY(-0.5rem)",
          fontSize: "sm",
          _disabled: {
            color: "#8F8F8F"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#262323",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    },
    baseSelect: {
      //@ts-expect-error ts error
      container: {
        bg: "transparent",
        color: "#B0B0B0",
        _hover: {
          label: {
            color: "#B0B0B0"
          }
        },
        _focusWithin: {
          label: {
            ...pe
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...pe,
          display: "flex"
        },
        label: {
          bg: "transparent",
          fontSize: "md",
          _disabled: {
            color: "#8F8F8F"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#262323",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    }
  },
  defaultProps: {
    variant: "floating"
  }
}), Kr = {
  border: "1px solid",
  borderColor: "gray.700",
  color: "#FFFFFF",
  borderRadius: "1.875rem",
  h: "14",
  pt: "3",
  bg: "#262323"
}, Jr = {
  p: "1px",
  borderRadius: "1.875rem"
}, Zr = {
  bg: "#585858",
  bgGradient: ""
}, Qr = {
  bg: "danger.main !important",
  bgGradient: ""
}, eo = {
  bg: "#585858 !important",
  bgGradient: ""
}, to = {
  bg: "#3D3D3D !important",
  bgGradient: ""
}, ro = {
  bg: "#262323 !important",
  bgGradient: ""
}, oo = {
  bg: "#1C1C1C !important",
  bgGradient: ""
}, no = {
  bg: "#262323",
  bgGradient: ""
}, ao = {
  bg: "#262323",
  bgGradient: ""
}, io = {
  bg: "#1C1C1C !important",
  opacity: 0.6,
  color: "#8F8F8F !important"
}, lo = {
  bg: "#262323",
  borderColor: "#FFFFFF"
}, so = {
  borderRadius: "1.875rem",
  filter: "blur(4px)",
  content: '""',
  position: "absolute",
  top: "-1px",
  right: "-1px",
  bottom: "-1px",
  left: "-1px",
  bg: "rgba(255, 255, 255, 0.3)",
  bgClip: "border-box"
}, co = {
  boxShadow: "0 0 0 30px #262323 inset !important",
  WebkitBoxShadow: "0 0 0 30px #262323 inset !important",
  MozBoxShadow: "0 0 0 30px #262323 inset !important",
  WebkitTextFillColor: "#FFFFFF !important"
}, kt = {
  ...Kr,
  _disabled: io,
  _focusVisible: lo,
  _autofill: co
}, bo = L({
  variants: {
    just: {
      field: {
        ...kt
      }
    },
    justUnstyled: {
      field: {
        ...kt,
        _focusVisible: {
          boxShadow: "transparent !important",
          bgGradient: "transparent !important",
          bg: "#262323 !important"
        },
        _invalid: {
          boxShadow: "#262323 !important",
          bgGradient: "#262323 !important",
          bg: "#262323 !important"
        },
        border: "#262323 !important",
        bgGradient: "#262323 !important",
        bg: "#262323 !important"
      }
    }
  },
  defaultProps: {
    variant: "just"
  }
}), po = L({
  baseStyle: {
    control: {
      borderColor: "#585858",
      _checked: {
        bg: "#FFFFFF",
        borderColor: "#FFFFFF",
        color: "#1C1C1C",
        _before: {
          bg: "#1C1C1C"
        },
        _hover: {
          bg: "#E0E0E0",
          borderColor: "#E0E0E0"
        }
      }
    },
    label: {
      color: "#FFFFFF"
    }
  },
  sizes: {
    lg: {
      control: { w: "5", h: "5" },
      label: { fontSize: "md", width: "full" }
    }
  }
}), go = Be({
  fonts: {
    heading: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    span: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    p: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    just: "0px 6px 10px rgba(0, 0, 0, 0.3), 0px 1px 18px rgba(0, 0, 0, 0.2), 0px 3px 5px rgba(0, 0, 0, 0.25)"
  },
  components: {
    Button: Tr,
    Divider: Vr,
    Form: Xr,
    Input: bo,
    Radio: po,
    Box: Mr,
    Checkbox: qr
  },
  themedClasses: {
    inputBackgroundDisabledStyle: oo,
    inputBackgroundEmptyStyle: no,
    inputBackgroundGradientStyle: ro,
    inputBackgroundInvalidStyle: ao,
    inputBorderDisabledStyle: to,
    inputBorderEmptyStyle: eo,
    inputBorderGradientStyle: Zr,
    inputBorderInvalidStyle: Qr,
    inputBorderStyle: Jr,
    inputBoxShadowGradientStyle: so
  },
  colors: {
    brand: {
      yellow: "#FFA908",
      green: "#A1FB86",
      fushia: "#EDBFFB"
    },
    fullBlack: {
      50: "#3D3D3D",
      500: "#262323",
      900: "#1C1C1C"
    },
    buttonBlack: {
      50: "#8F8F8F",
      500: "#1C1C1C",
      900: "#050505"
    },
    yellowScheme: {
      50: "#FFD587",
      500: "#FFD587",
      900: "#FFA908"
    },
    gray: {
      601: "#3D3D3D",
      602: "#585858",
      603: "#8F8F8F",
      700: "#585858",
      701: "#B0B0B0",
      801: "#FFFFFF"
    },
    danger: {
      main: "#FF6B6B",
      text: "#FF6B6B"
    },
    focus: {
      main: "#6BB3FF",
      error: "#FF6B6B"
    },
    // Theme-specific semantic colors
    background: {
      primary: "#1C1C1C",
      secondary: "#262323",
      card: "#262323"
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#B0B0B0",
      muted: "#8F8F8F"
    }
  },
  styles: {
    global: {
      body: {
        bg: "#1C1C1C",
        color: "#FFFFFF"
      }
    }
  }
}), uo = L({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#E0E0E0",
      color: "#999999"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    color: "#000000"
  },
  defaultProps: {
    variant: "primary"
  }
}), mo = L({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite classic', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#E0E0E0",
      color: "#999999"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    borderRadius: "6rem"
  },
  variants: {
    primary: {
      color: "#555555",
      background: "#E0E0E0",
      border: "1px solid #E0E0E0",
      _hover: {
        background: "#000000",
        color: "#FFFFFF",
        borderColor: "#000000"
      },
      _active: {
        background: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        background: "#E0E0E0 !important",
        fontSize: "1.5rem",
        color: "#555555 !important"
      }
    },
    secondary: {
      color: "#000000",
      backgroundColor: "#E0E0E0",
      border: "1px solid #E0E0E0",
      _hover: {
        backgroundColor: "#000000",
        color: "#FFFFFF"
      },
      _active: {
        backgroundColor: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        backgroundColor: "#E0E0E0 !important",
        color: "#000000 !important"
      }
    },
    disabled: {
      color: "#999999",
      backgroundColor: "#E0E0E0",
      _hover: {
        backgroundColor: "#E0E0E0"
      },
      _active: {
        backgroundColor: "#E0E0E0"
      },
      _loading: {
        backgroundColor: "#E0E0E0 !important",
        color: "#999999 !important"
      }
    },
    aurora: {
      fontSize: "18px",
      color: "#555555",
      borderRadius: "28px",
      background: "#E0E0E0",
      border: "1px solid #E0E0E0",
      _hover: {
        background: "#000000",
        color: "#FFFFFF"
      },
      _active: {
        background: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        background: "#E0E0E0 !important",
        fontSize: "1.5rem",
        color: "#555555 !important"
      }
    }
  },
  defaultProps: {
    variant: "primary"
  }
}), { definePartsStyle: Je, defineMultiStyleConfig: ho } = Ce(ke.keys), fo = {
  md: Je({
    control: Y({
      h: "20px",
      w: "20px"
    }),
    label: Y({
      fontSize: "sm",
      fontWeight: 400,
      lineHeight: "20px"
    })
  }),
  sm: Je({
    control: Y({
      h: "16px",
      w: "16px"
    }),
    label: Y({
      fontSize: "xs",
      fontWeight: 350,
      lineHeight: 5
    })
  })
}, Fo = Je({
  label: {
    color: "#666666",
    fontSize: "sm",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  control: {
    borderRadius: "4px",
    borderWidth: "1.5px",
    borderColor: "#E0E0E0",
    bg: "transparent",
    alignSelf: "flex-start",
    marginTop: "2px",
    _checked: {
      bg: "var(--button-active-bg, #000000)",
      borderColor: "var(--button-active-bg, #000000)",
      color: "var(--button-active-text, #FFFFFF)",
      _hover: {
        bg: "var(--button-active-bg, #333333)",
        borderColor: "var(--button-active-bg, #333333)"
      }
    }
  }
}), yo = ho({ baseStyle: Fo, sizes: fo }), xo = Y({
  borderWidth: "1px",
  borderStyle: "dashed",
  borderColor: "#E0E0E0"
}), vo = Y({
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "#000000"
}), So = L({
  baseStyle: {
    borderWidth: "1px",
    borderColor: "#000000"
  },
  variants: { dashed: xo, solid: vo }
}), wt = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(-0.02rem)",
  fontSize: "sm"
}, ge = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(0.25rem)",
  fontSize: "sm"
}, Co = L({
  variants: {
    floating: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#999999",
        _hover: {
          label: {
            color: "#999999"
          }
        },
        _focusWithin: {
          label: {
            ...ge
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ge,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#999999"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          fontWeight: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#FFFFFF",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontsize: "md"
        }
      }
    },
    floatingWithIcon: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#999999",
        _hover: {
          label: {
            color: "#999999"
          }
        },
        _focusWithin: {
          label: {
            ...wt
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...wt,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#999999"
          },
          textAlign: "left",
          top: 4,
          left: 10,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#FFFFFF",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "inherit !important",
          fontsize: "md"
        }
      }
    },
    mobileSelect: {
      //@ts-expect-error ts error
      container: {
        color: "#999999",
        _hover: {
          label: {
            color: "#999999"
          }
        },
        _focusWithin: {
          label: {
            ...ge
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ge,
          display: "flex"
        },
        label: {
          transform: "scale(0.75) translateY(-0.5rem)",
          fontSize: "sm",
          _disabled: {
            color: "#999999"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#FFFFFF",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    },
    baseSelect: {
      //@ts-expect-error ts error
      container: {
        bg: "transparent",
        color: "#999999",
        _hover: {
          label: {
            color: "#999999"
          }
        },
        _focusWithin: {
          label: {
            ...ge
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ge,
          display: "flex"
        },
        label: {
          bg: "transparent",
          fontSize: "md",
          _disabled: {
            color: "#999999"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#FFFFFF",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    }
  },
  defaultProps: {
    variant: "floating"
  }
}), Bo = {
  border: "1px solid",
  borderColor: "#E0E0E0",
  color: "#000000",
  borderRadius: "1.875rem",
  h: "14",
  pt: "3",
  bg: "#FFFFFF"
}, ko = {
  p: "1px",
  borderRadius: "1.875rem"
}, wo = {
  bg: "#000000",
  bgGradient: ""
}, Eo = {
  bg: "danger.main !important",
  bgGradient: ""
}, Io = {
  bg: "#E0E0E0 !important",
  bgGradient: ""
}, _o = {
  bg: "#E0E0E0 !important",
  bgGradient: ""
}, Ao = {
  bg: "#FFFFFF !important",
  bgGradient: ""
}, Do = {
  bg: "#F5F5F5 !important",
  bgGradient: ""
}, zo = {
  bg: "#FFFFFF",
  bgGradient: ""
}, Wo = {
  bg: "#FFFFFF",
  bgGradient: ""
}, jo = {
  bg: "#F5F5F5 !important",
  opacity: 0.6,
  color: "#999999 !important"
}, Ho = {
  bg: "#FFFFFF",
  borderColor: "#999999"
}, Uo = {
  borderRadius: "1.875rem",
  filter: "var(--input-focus-blur, blur(4px))",
  content: '""',
  position: "absolute",
  top: "-1px",
  right: "-1px",
  bottom: "-1px",
  left: "-1px",
  bg: "var(--input-focus-shadow-bg, rgba(0, 0, 0, 0.15))",
  bgClip: "border-box"
}, $o = {
  boxShadow: "0 0 0 30px #FFFFFF inset !important",
  WebkitBoxShadow: "0 0 0 30px #FFFFFF inset !important",
  MozBoxShadow: "0 0 0 30px #FFFFFF inset !important",
  WebkitTextFillColor: "#000000 !important"
}, Et = {
  ...Bo,
  _disabled: jo,
  _focusVisible: Ho,
  _autofill: $o
}, Ro = L({
  variants: {
    just: {
      field: {
        ...Et
      }
    },
    justUnstyled: {
      field: {
        ...Et,
        _focusVisible: {
          boxShadow: "transparent !important",
          bgGradient: "transparent !important",
          bg: "#FFFFFF !important"
        },
        _invalid: {
          boxShadow: "#FFFFFF !important",
          bgGradient: "#FFFFFF !important",
          bg: "#FFFFFF !important"
        },
        border: "#FFFFFF !important",
        bgGradient: "#FFFFFF !important",
        bg: "#FFFFFF !important"
      }
    }
  },
  defaultProps: {
    variant: "just"
  }
}), Go = L({
  baseStyle: {
    control: {
      borderColor: "#E0E0E0",
      _checked: {
        bg: "#000000",
        borderColor: "#000000",
        color: "#FFFFFF",
        _before: {
          bg: "#FFFFFF"
        },
        _hover: {
          bg: "#333333",
          borderColor: "#333333"
        }
      }
    },
    label: {
      color: "#000000"
    }
  },
  sizes: {
    lg: {
      control: { w: "5", h: "5" },
      label: { fontSize: "md", width: "full" }
    }
  }
}), It = Be({
  fonts: {
    heading: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    span: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    p: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    just: "0px 6px 10px rgba(0, 0, 0, 0.08), 0px 1px 18px rgba(0, 0, 0, 0.06), 0px 3px 5px rgba(0, 0, 0, 0.1)"
  },
  components: {
    Button: mo,
    Divider: So,
    Form: Co,
    Input: Ro,
    Radio: Go,
    Box: uo,
    Checkbox: yo
  },
  themedClasses: {
    inputBackgroundDisabledStyle: Do,
    inputBackgroundEmptyStyle: zo,
    inputBackgroundGradientStyle: Ao,
    inputBackgroundInvalidStyle: Wo,
    inputBorderDisabledStyle: _o,
    inputBorderEmptyStyle: Io,
    inputBorderGradientStyle: wo,
    inputBorderInvalidStyle: Eo,
    inputBorderStyle: ko,
    inputBoxShadowGradientStyle: Uo
  },
  colors: {
    brand: {
      yellow: "#FFA908",
      green: "#A1FB86",
      fushia: "#EDBFFB"
    },
    fullBlack: {
      50: "#F5F5F5",
      500: "#E0E0E0",
      900: "#000000"
    },
    buttonBlack: {
      50: "#999999",
      500: "#E0E0E0",
      900: "#000000"
    },
    yellowScheme: {
      50: "#FFD587",
      500: "#FFD587",
      900: "#FFA908"
    },
    gray: {
      601: "#F5F5F5",
      602: "#E0E0E0",
      603: "#999999",
      700: "#000000",
      701: "#666666",
      801: "#000000"
    },
    danger: {
      main: "#EE5829",
      text: "#C74931"
    },
    focus: {
      main: "#000000",
      error: "#EE5829"
    },
    // Theme-specific semantic colors
    background: {
      primary: "#FFFFFF",
      secondary: "#F5F5F5",
      card: "#FFFFFF"
    },
    text: {
      primary: "#000000",
      secondary: "#666666",
      muted: "#999999"
    }
  },
  styles: {
    global: {
      body: {
        bg: "#FFFFFF",
        color: "#000000"
      }
    }
  }
}), Lo = L({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "rgba(247, 247, 247, 0.6)",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    color: "#1C1C1C"
  },
  defaultProps: {
    variant: "primary"
  }
}), Mo = L({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite classic', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "rgba(247, 247, 247, 0.6)",
      color: "#8F8F8F"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    borderRadius: "6rem"
  },
  variants: {
    primary: {
      color: "white",
      backgroundColor: "rgba(28, 28, 28, 0.9)",
      boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.18)",
      _hover: {
        backgroundColor: "rgba(28, 28, 28, 0.8)"
      },
      _active: {
        backgroundColor: "rgba(28, 28, 28, 1)"
      },
      _loading: {
        backgroundColor: "rgba(28, 28, 28, 0.9) !important",
        fontSize: "1.5rem",
        color: "#FFF !important"
      }
    },
    secondary: {
      color: "gray.701",
      backgroundColor: "rgba(224, 224, 224, 0.6)",
      boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.55)",
      _hover: {
        backgroundColor: "rgba(224, 224, 224, 0.8)"
      },
      _active: {
        backgroundColor: "rgba(224, 224, 224, 0.7)"
      },
      _loading: {
        backgroundColor: "rgba(224, 224, 224, 0.6) !important",
        color: "#585858 !important"
      }
    },
    disabled: {
      color: "gray.603",
      backgroundColor: "rgba(247, 247, 247, 0.6)",
      _hover: {
        backgroundColor: "rgba(247, 247, 247, 0.6)"
      },
      _active: {
        backgroundColor: "rgba(247, 247, 247, 0.6)"
      },
      _loading: {
        backgroundColor: "rgba(247, 247, 247, 0.6) !important",
        color: "#8F8F8F !important"
      }
    },
    aurora: {
      fontSize: "18px",
      color: "#1C1C1C",
      borderRadius: "28px",
      background: "linear-gradient(90deg, rgba(141, 230, 144, 0.8) 2.08%, rgba(165, 240, 163, 0.8) 18.23%, rgba(166, 236, 215, 0.8) 33.33%, rgba(151, 218, 218, 0.8) 51.56%, rgba(179, 218, 231, 0.8) 67.71%, rgba(182, 201, 236, 0.8) 83.33%, rgba(135, 154, 203, 0.8) 100%)",
      boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.35)",
      _hover: {
        opacity: 0.9
      },
      _active: {
        opacity: 0.8
      },
      _loading: {
        background: "linear-gradient(90deg, rgba(141, 230, 144, 0.8) 2.08%, rgba(165, 240, 163, 0.8) 18.23%, rgba(166, 236, 215, 0.8) 33.33%, rgba(151, 218, 218, 0.8) 51.56%, rgba(179, 218, 231, 0.8) 67.71%, rgba(182, 201, 236, 0.8) 83.33%, rgba(135, 154, 203, 0.8) 100%) !important",
        fontSize: "1.5rem",
        color: "#1C1C1C !important"
      }
    }
  },
  defaultProps: {
    variant: "primary"
  }
}), { definePartsStyle: Ze, defineMultiStyleConfig: To } = Ce(ke.keys), Po = {
  md: Ze({
    control: Y({
      h: "20px",
      w: "20px"
    }),
    label: Y({
      fontSize: "sm",
      fontWeight: 400,
      lineHeight: "20px"
    })
  }),
  sm: Ze({
    control: Y({
      h: "16px",
      w: "16px"
    }),
    label: Y({
      fontSize: "xs",
      fontWeight: 350,
      lineHeight: 5
    })
  })
}, No = Ze({
  label: {
    color: "#585858",
    fontSize: "sm",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  control: {
    borderRadius: "4px",
    borderWidth: "1px",
    borderColor: "rgba(224, 224, 224, 0.8)",
    bg: "rgba(255, 255, 255, 0.5)",
    alignSelf: "flex-start",
    marginTop: "2px",
    _checked: {
      bg: "rgba(88, 88, 88, 0.9)",
      borderColor: "rgba(88, 88, 88, 0.9)",
      _hover: {
        bg: "rgba(88, 88, 88, 0.8)",
        borderColor: "rgba(88, 88, 88, 0.8)"
      }
    }
  }
}), Yo = To({ baseStyle: No, sizes: Po }), qo = Y({
  borderWidth: "1px",
  borderStyle: "dashed",
  borderColor: "rgba(224, 224, 224, 0.6)"
}), Oo = L({
  baseStyle: {
    borderColor: "rgba(224, 224, 224, 0.6)",
    boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.35)"
  },
  variants: { dashed: qo }
}), _t = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(-0.02rem)",
  fontSize: "sm"
}, ue = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(0.25rem)",
  fontSize: "sm"
}, Vo = L({
  variants: {
    floating: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...ue
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ue,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          fontWeight: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontsize: "md",
          borderRadius: "4px",
          px: "2px"
        }
      }
    },
    floatingWithIcon: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ..._t
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ..._t,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 10,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "inherit !important",
          fontsize: "md",
          borderRadius: "4px",
          px: "2px"
        }
      }
    },
    mobileSelect: {
      //@ts-expect-error ts error
      container: {
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...ue
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ue,
          display: "flex"
        },
        label: {
          transform: "scale(0.75) translateY(-0.5rem)",
          fontSize: "sm",
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium",
          borderRadius: "4px",
          px: "2px"
        }
      }
    },
    baseSelect: {
      //@ts-expect-error ts error
      container: {
        bg: "transparent",
        color: "gray.603",
        _hover: {
          label: {
            color: "gray.603"
          }
        },
        _focusWithin: {
          label: {
            ...ue
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...ue,
          display: "flex"
        },
        label: {
          bg: "transparent",
          fontSize: "md",
          _disabled: {
            color: "gray.603"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium",
          borderRadius: "4px",
          px: "2px"
        }
      }
    }
  },
  defaultProps: {
    variant: "floating"
  }
}), Xo = {
  border: "1px solid",
  borderColor: "rgba(224, 224, 224, 0.6)",
  color: "fullBlack.900",
  borderRadius: "1.875rem",
  h: "14",
  pt: "3",
  bg: "rgba(255, 255, 255, 0.7)",
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
  boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.55)"
}, Ko = {
  p: "1px",
  borderRadius: "1.875rem"
}, Jo = {
  bg: "rgba(224, 224, 224, 0.6)",
  bgGradient: ""
}, Zo = {
  bg: "danger.main !important",
  bgGradient: ""
}, Qo = {
  bg: "rgba(224, 224, 224, 0.6) !important",
  bgGradient: ""
}, en = {
  bg: "rgba(224, 224, 224, 0.4) !important",
  bgGradient: ""
}, tn = {
  bg: "rgba(255, 255, 255, 0.85) !important",
  bgGradient: "",
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
  boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.55)"
}, rn = {
  bg: "rgba(255, 255, 255, 0.5) !important",
  bgGradient: ""
}, on = {
  bg: "rgba(255, 255, 255, 0.7)",
  bgGradient: ""
}, nn = {
  bg: "rgba(255, 255, 255, 0.7)",
  bgGradient: ""
}, an = {
  bg: "rgba(255, 255, 255, 0.5) !important",
  opacity: 0.8,
  color: "gray.701 !important"
}, ln = {
  bg: "rgba(255, 255, 255, 0.9)",
  boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.6)"
}, sn = {
  borderRadius: "1.875rem",
  filter: "blur(8px)",
  content: '""',
  position: "absolute",
  top: "-2px",
  right: "-2px",
  bottom: "-2px",
  left: "-2px",
  bg: "rgba(255, 255, 255, 0.4)",
  bgClip: "border-box"
}, dn = {
  boxShadow: "0 0 0 30px rgba(255, 255, 255, 0.7) inset !important",
  WebkitBoxShadow: "0 0 0 30px rgba(255, 255, 255, 0.7) inset !important",
  MozBoxShadow: "0 0 0 30px rgba(255, 255, 255, 0.7) inset !important"
}, At = {
  ...Xo,
  _disabled: an,
  _focusVisible: ln,
  _autofill: dn
}, cn = L({
  variants: {
    just: {
      field: {
        ...At
      }
    },
    justUnstyled: {
      field: {
        ...At,
        _focusVisible: {
          boxShadow: "transparent !important",
          bgGradient: "transparent !important",
          bg: "rgba(255, 255, 255, 0.7) !important"
        },
        _invalid: {
          boxShadow: "transparent !important",
          bgGradient: "transparent !important",
          bg: "rgba(255, 255, 255, 0.7) !important"
        },
        border: "transparent !important",
        bgGradient: "transparent !important",
        bg: "rgba(255, 255, 255, 0.7) !important"
      }
    }
  },
  defaultProps: {
    variant: "just"
  }
}), bn = L({
  baseStyle: {
    control: {
      borderColor: "rgba(224, 224, 224, 0.8)",
      bg: "rgba(255, 255, 255, 0.5)",
      backdropFilter: "blur(12px)",
      WebkitBackdropFilter: "blur(12px)",
      _checked: {
        bg: "rgba(88, 88, 88, 0.9)",
        borderColor: "rgba(88, 88, 88, 0.9)",
        _before: {
          w: "calc(50% + 1px)",
          h: "calc(50% + 1px)"
        },
        _hover: {
          bg: "rgba(88, 88, 88, 0.8)",
          borderColor: "rgba(88, 88, 88, 0.8)"
        }
      }
    },
    label: {
      color: "#1C1C1C"
    }
  },
  sizes: {
    lg: {
      control: { w: "5", h: "5" },
      label: { fontSize: "md", width: "full" }
    }
  }
}), pn = Be({
  fonts: {
    heading: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    span: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    p: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    just: "0px 4px 6px rgba(0, 0, 0, 0.05), 0px 1px 12px rgba(0, 0, 0, 0.04), 0px 2px 4px rgba(0, 0, 0, 0.06)"
  },
  components: {
    Button: Mo,
    Divider: Oo,
    Form: Vo,
    Input: cn,
    Radio: bn,
    Box: Lo,
    Checkbox: Yo
  },
  themedClasses: {
    inputBackgroundDisabledStyle: rn,
    inputBackgroundEmptyStyle: on,
    inputBackgroundGradientStyle: tn,
    inputBackgroundInvalidStyle: nn,
    inputBorderDisabledStyle: en,
    inputBorderEmptyStyle: Qo,
    inputBorderGradientStyle: Jo,
    inputBorderInvalidStyle: Zo,
    inputBorderStyle: Ko,
    inputBoxShadowGradientStyle: sn
  },
  colors: {
    brand: {
      yellow: "#FFA908",
      green: "#A1FB86",
      fushia: "#EDBFFB"
    },
    fullBlack: {
      50: "#282525",
      500: "#262323",
      900: "#1C1C1C"
    },
    buttonBlack: {
      50: "#8F8F8F",
      500: "#1C1C1C",
      900: "#050505"
    },
    yellowScheme: {
      50: "#FFD587",
      500: "#FFD587",
      900: "#FFA908"
    },
    gray: {
      601: "rgba(247, 247, 247, 0.8)",
      602: "rgba(224, 224, 224, 0.6)",
      // Increase contrast for glassy (avoid "grey on grey")
      603: "#5F5F5F",
      701: "#2F2F2F",
      801: "#111111"
    },
    danger: {
      main: "#EE5829",
      text: "#EE5829"
    },
    focus: {
      main: "#0F4C8F",
      error: "#E9553A"
    },
    // Theme-specific semantic colors
    background: {
      primary: "transparent",
      secondary: "rgba(255, 255, 255, 0.7)",
      card: "rgba(255, 255, 255, 0.7)"
    },
    text: {
      primary: "#111111",
      secondary: "#2F2F2F",
      muted: "#5F5F5F"
    }
  },
  styles: {
    global: {
      body: {
        bg: "transparent",
        color: "#111111"
      }
    }
  }
}), gn = L({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#F0F0F0",
      color: "#888888"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    color: "#000000"
  },
  defaultProps: {
    variant: "primary"
  }
}), un = L({
  baseStyle: {
    display: "flex",
    alignItems: "center",
    fontFamily: `'Beausite classic', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    _disabled: {
      backgroundColor: "#F0F0F0",
      color: "#888888"
    },
    fontWeight: "semibold",
    lineHeight: "6",
    fontSize: "lg",
    fontStyle: "normal",
    borderRadius: "6rem"
  },
  variants: {
    primary: {
      color: "#888888",
      background: "#F0F0F0",
      border: "1px solid #E0E0E0",
      _hover: {
        background: "#000000",
        color: "#FFFFFF",
        borderColor: "#000000"
      },
      _active: {
        background: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        background: "#F0F0F0 !important",
        fontSize: "1.5rem",
        color: "#888888 !important"
      }
    },
    secondary: {
      color: "#000000",
      backgroundColor: "#F0F0F0",
      border: "1px solid #E0E0E0",
      _hover: {
        backgroundColor: "#000000",
        color: "#FFFFFF"
      },
      _active: {
        backgroundColor: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        backgroundColor: "#F0F0F0 !important",
        color: "#000000 !important"
      }
    },
    disabled: {
      color: "#888888",
      backgroundColor: "#F0F0F0",
      _hover: {
        backgroundColor: "#F0F0F0"
      },
      _active: {
        backgroundColor: "#F0F0F0"
      },
      _loading: {
        backgroundColor: "#F0F0F0 !important",
        color: "#888888 !important"
      }
    },
    aurora: {
      fontSize: "18px",
      color: "#888888",
      borderRadius: "28px",
      background: "#F0F0F0",
      border: "1px solid #E0E0E0",
      _hover: {
        background: "#000000",
        color: "#FFFFFF"
      },
      _active: {
        background: "#1C1C1C",
        color: "#FFFFFF"
      },
      _loading: {
        background: "#F0F0F0 !important",
        fontSize: "1.5rem",
        color: "#888888 !important"
      }
    }
  },
  defaultProps: {
    variant: "primary"
  }
}), { definePartsStyle: Qe, defineMultiStyleConfig: mn } = Ce(ke.keys), hn = {
  md: Qe({
    control: Y({
      h: "20px",
      w: "20px"
    }),
    label: Y({
      fontSize: "sm",
      fontWeight: 400,
      lineHeight: "20px"
    })
  }),
  sm: Qe({
    control: Y({
      h: "16px",
      w: "16px"
    }),
    label: Y({
      fontSize: "xs",
      fontWeight: 350,
      lineHeight: 5
    })
  })
}, fn = Qe({
  label: {
    color: "#555555",
    fontSize: "sm",
    fontFamily: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  control: {
    borderRadius: "4px",
    borderWidth: "1.5px",
    borderColor: "#D0D0D0",
    bg: "transparent",
    alignSelf: "flex-start",
    marginTop: "2px",
    _checked: {
      bg: "#000000",
      borderColor: "#000000",
      color: "#FFFFFF",
      _hover: {
        bg: "#333333",
        borderColor: "#333333"
      }
    }
  }
}), Fn = mn({ baseStyle: fn, sizes: hn }), yn = Y({
  borderWidth: "1px",
  borderStyle: "dashed",
  borderColor: "#eeeeee"
}), xn = Y({
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "#eeeeee"
}), vn = L({
  baseStyle: {
    borderWidth: "1px",
    borderColor: "#eeeeee"
  },
  variants: { dashed: yn, solid: xn }
}), Dt = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(-0.02rem)",
  fontSize: "sm"
}, me = {
  transform: "scale(0.75) translateY(-0.88rem) translateX(0.25rem)",
  fontSize: "sm"
}, Sn = L({
  variants: {
    floating: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#888888",
        _hover: {
          label: {
            color: "#888888"
          }
        },
        _focusWithin: {
          label: {
            ...me
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...me,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#888888"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          fontWeight: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#F0F0F0",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontsize: "md"
        }
      }
    },
    floatingWithIcon: {
      //@ts-expect-error ts error
      container: {
        fontWeight: "350",
        color: "#888888",
        _hover: {
          label: {
            color: "#888888"
          }
        },
        _focusWithin: {
          label: {
            ...Dt
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...Dt,
          display: "flex"
        },
        label: {
          _disabled: {
            color: "#888888"
          },
          textAlign: "left",
          top: 4,
          left: 10,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#F0F0F0",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "inherit !important",
          fontsize: "md"
        }
      }
    },
    mobileSelect: {
      //@ts-expect-error ts error
      container: {
        color: "#888888",
        _hover: {
          label: {
            color: "#888888"
          }
        },
        _focusWithin: {
          label: {
            ...me
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...me,
          display: "flex"
        },
        label: {
          transform: "scale(0.75) translateY(-0.5rem)",
          fontSize: "sm",
          _disabled: {
            color: "#888888"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#F0F0F0",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    },
    baseSelect: {
      //@ts-expect-error ts error
      container: {
        bg: "transparent",
        color: "#888888",
        _hover: {
          label: {
            color: "#888888"
          }
        },
        _focusWithin: {
          label: {
            ...me
          }
        },
        "input:not(:placeholder-shown):not(:focus-visible) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown):not(:focus-visible) ~ label": {
          ...me,
          display: "flex"
        },
        label: {
          bg: "transparent",
          fontSize: "md",
          _disabled: {
            color: "#888888"
          },
          textAlign: "left",
          top: 4,
          left: 4,
          whiteSpace: "nowrap",
          color: "inherit !important",
          zIndex: 2,
          position: "absolute",
          backgroundColor: "#F0F0F0",
          pointerEvents: "none",
          my: 0,
          transformOrigin: "left top",
          fontWeight: "medium"
        }
      }
    }
  },
  defaultProps: {
    variant: "floating"
  }
}), Cn = {
  border: "1.5px solid",
  borderColor: "#E0E0E0",
  color: "#000000",
  borderRadius: "1.875rem",
  h: "14",
  pt: "3",
  bg: "#F0F0F0"
}, Bn = {
  p: "1px",
  borderRadius: "1.875rem"
}, kn = {
  bg: "#BEBBB4",
  bgGradient: ""
}, wn = {
  bg: "danger.main !important",
  bgGradient: ""
}, En = {
  bg: "#E0E0E0 !important",
  bgGradient: ""
}, In = {
  bg: "#E0E0E0 !important",
  bgGradient: ""
}, _n = {
  bg: "#F0F0F0 !important",
  bgGradient: ""
}, An = {
  bg: "#F7F7F7 !important",
  bgGradient: ""
}, Dn = {
  bg: "#F0F0F0",
  bgGradient: ""
}, zn = {
  bg: "#F0F0F0",
  bgGradient: ""
}, Wn = {
  bg: "#F7F7F7 !important",
  opacity: 0.6,
  color: "#888888 !important"
}, jn = {
  bg: "#F0F0F0",
  borderColor: "#BEBBB4"
}, Hn = {
  borderRadius: "1.875rem",
  filter: "blur(4px)",
  content: '""',
  position: "absolute",
  top: "-1px",
  right: "-1px",
  bottom: "-1px",
  left: "-1px",
  bg: "rgba(190, 187, 180, 0.3)",
  bgClip: "border-box"
}, Un = {
  boxShadow: "0 0 0 30px #F0F0F0 inset !important",
  WebkitBoxShadow: "0 0 0 30px #F0F0F0 inset !important",
  MozBoxShadow: "0 0 0 30px #F0F0F0 inset !important",
  WebkitTextFillColor: "#000000 !important"
}, zt = {
  ...Cn,
  _disabled: Wn,
  _focusVisible: jn,
  _autofill: Un
}, $n = L({
  variants: {
    just: {
      field: {
        ...zt
      }
    },
    justUnstyled: {
      field: {
        ...zt,
        _focusVisible: {
          boxShadow: "transparent !important",
          bgGradient: "transparent !important",
          bg: "#F0F0F0 !important"
        },
        _invalid: {
          boxShadow: "#F0F0F0 !important",
          bgGradient: "#F0F0F0 !important",
          bg: "#F0F0F0 !important"
        },
        border: "#F0F0F0 !important",
        bgGradient: "#F0F0F0 !important",
        bg: "#F0F0F0 !important"
      }
    }
  },
  defaultProps: {
    variant: "just"
  }
}), Rn = L({
  baseStyle: {
    control: {
      borderColor: "#BEBBB4",
      _checked: {
        bg: "#000000",
        borderColor: "#000000",
        color: "#FFFFFF",
        _before: {
          bg: "#FFFFFF"
        },
        _hover: {
          bg: "#333333",
          borderColor: "#333333"
        }
      }
    },
    label: {
      color: "#000000"
    }
  },
  sizes: {
    lg: {
      control: { w: "5", h: "5" },
      label: { fontSize: "md", width: "full" }
    }
  }
}), Gn = Be({
  fonts: {
    heading: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    span: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    p: `'Beausite', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },
  shadows: {
    just: "0px 6px 10px rgba(0, 0, 0, 0.08), 0px 1px 18px rgba(0, 0, 0, 0.06), 0px 3px 5px rgba(0, 0, 0, 0.1)"
  },
  components: {
    Button: un,
    Divider: vn,
    Form: Sn,
    Input: $n,
    Radio: Rn,
    Box: gn,
    Checkbox: Fn
  },
  themedClasses: {
    inputBackgroundDisabledStyle: An,
    inputBackgroundEmptyStyle: Dn,
    inputBackgroundGradientStyle: _n,
    inputBackgroundInvalidStyle: zn,
    inputBorderDisabledStyle: In,
    inputBorderEmptyStyle: En,
    inputBorderGradientStyle: kn,
    inputBorderInvalidStyle: wn,
    inputBorderStyle: Bn,
    inputBoxShadowGradientStyle: Hn
  },
  colors: {
    brand: {
      yellow: "#FFA908",
      green: "#A1FB86",
      fushia: "#EDBFFB"
    },
    fullBlack: {
      50: "#F0F0F0",
      500: "#DEDCDC",
      900: "#BEBBB4"
    },
    buttonBlack: {
      50: "#888888",
      500: "#F0F0F0",
      900: "#000000"
    },
    yellowScheme: {
      50: "#FFD587",
      500: "#FFD587",
      900: "#FFA908"
    },
    gray: {
      601: "#F7F7F7",
      602: "#E0E0E0",
      603: "#888888",
      700: "#BEBBB4",
      701: "#555555",
      801: "#000000"
    },
    danger: {
      main: "#EE5829",
      text: "#C74931"
    },
    focus: {
      main: "#BEBBB4",
      error: "#EE5829"
    },
    // Theme-specific semantic colors
    background: {
      primary: "#DEDCDC",
      secondary: "#F0F0F0",
      card: "#FFFFFF"
    },
    text: {
      primary: "#000000",
      secondary: "#555555",
      muted: "#888888"
    }
  },
  styles: {
    global: {
      body: {
        bg: "#DEDCDC",
        color: "#000000"
      }
    }
  }
}), Ln = ["aurora", "black", "glassy", "soft", "classic", "custom"], gt = "aurora", Wt = {
  aurora: Ot,
  black: go,
  glassy: pn,
  soft: Gn,
  classic: It,
  custom: It
}, jt = {
  aurora: {
    "--bg": "#ffffff",
    "--bg-secondary": "#F7F7F7",
    "--text": "#1C1C1C",
    "--text-secondary": "#585858",
    "--text-muted": "#8F8F8F",
    "--tooltip-text": "#1C1C1C",
    "--tooltip-bg": "var(--success, #63DD51)",
    "--border": "#E0E0E0",
    "--input-bg": "#ffffff",
    "--input-border": "#E0E0E0",
    "--input-focus-border": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--border-gradient": "linear-gradient(90deg, rgb(141, 230, 144) 2.08%, rgb(165, 240, 163) 18.23%, rgb(166, 236, 215) 33.33%, rgb(151, 218, 218) 51.56%, rgb(179, 218, 231) 67.71%, rgb(182, 201, 236) 83.33%, rgb(135, 154, 203) 100%)",
    "--badge-border-bg": "var(--chakra-colors-gray-100)",
    "--card-bg": "#FFF",
    "--card-bg-gradient": "linear-gradient(90deg, rgba(141, 230, 144, 0.10) 2.08%, rgba(165, 240, 163, 0.10) 18.23%, rgba(166, 236, 215, 0.10) 33.33%, rgba(151, 218, 218, 0.10) 51.56%, rgba(179, 218, 231, 0.10) 67.71%, rgba(182, 201, 236, 0.10) 83.33%, rgba(135, 154, 203, 0.10) 100%), #ffffff",
    "--button-primary-bg": "#1C1C1C",
    "--button-primary-text": "#ffffff",
    "--danger": "#EE5829",
    "--success": "#63DD51",
    "--badge-text": "#1C1C1C",
    "--badge-border": "none",
    "--badge-success-bg-solid": "var(--success)",
    "--badge-success-bg-tint": "rgba(99, 221, 81, 0.18)",
    "--badge-success-bg-gradient": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--badge-quantity-bg": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--badge-quantity-text": "#1C1C1C",
    "--accent-border": "#F6BCFF",
    "--offset-shadow": "-1px",
    // Pay button
    "--pay-button-text-enabled": "var(--button-primary-text)",
    "--pay-button-text-disabled": "#000",
    // Upsell carousel
    "--upsell-card-bg": "#ffffff",
    "--upsell-card-bg-active": "linear-gradient(90deg, rgba(141, 230, 144, 0.05) 2.08%, rgba(165, 240, 163, 0.05) 18.23%, rgba(166, 236, 215, 0.05) 33.33%, rgba(151, 218, 218, 0.05) 51.56%, rgba(179, 218, 231, 0.05) 67.71%, rgba(182, 201, 236, 0.05) 83.33%, rgba(135, 154, 203, 0.05) 100%), #FFF",
    "--upsell-border-active": "#8DE690",
    "--upsell-border-default": "var(--border, #E0E0E0)",
    "--upsell-btn-bg-active": "linear-gradient(90deg, #8DE690 0%, #A5F0A3 20%, #A6ECD7 40%, #97DADA 60%, #B3DAE7 80%, #879ACB 100%)",
    "--upsell-btn-bg-delete": "var(--card-bg, #fff)",
    "--upsell-btn-text-active": "#1C1C1C",
    "--upsell-text": "var(--text, #1C1C1C)",
    "--upsell-icon": "var(--text, #1C1C1C)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.60)",
    "--toast-bg": "#ffffff",
    "--toast-border": "var(--border, #E0E0E0)",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.10)",
    // Placeholder dropdown / Input field states
    "--input-border-filled": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--input-border-empty": "var(--chakra-colors-gray-602)",
    "--input-border-disabled": "var(--chakra-colors-gray-602)",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-filled": "linear-gradient(90deg, rgba(141, 230, 144, 0.10) 2.08%, rgba(165, 240, 163, 0.10) 18.23%, rgba(166, 236, 215, 0.10) 33.33%, rgba(151, 218, 218, 0.10) 51.56%, rgba(179, 218, 231, 0.10) 67.71%, rgba(182, 201, 236, 0.10) 83.33%, rgba(135, 154, 203, 0.10) 100%), #ffffff",
    "--input-bg-empty": "#ffffff",
    "--input-bg-error-message": "#fff",
    "--input-bg-disabled": "#ffffff",
    "--input-bg-invalid": "#ffffff",
    "--input-disabled-bg-variant": "#F7F7F7",
    "--input-focus-blur": "blur(4px)",
    "--input-focus-shadow-bg": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--loading-skeleton-color": "rgba(255, 255, 255, 0.10)",
    // Shipping section
    "--shipping-radio-unchecked": "var(--border)",
    "--shipping-radio-checked": "var(--border-gradient)",
    "--shipping-radio-inner": "var(--bg)",
    "--shipping-expanded-bg": "var(--bg)",
    "--shipping-badge-cheapest": "var(--border-gradient)",
    "--shipping-border-selected": "var(--border-gradient)"
  },
  black: {
    "--bg": "#1C1C1C",
    "--bg-secondary": "#262323",
    "--text": "#FFFFFF",
    "--tooltip-text": "#1C1C1C",
    "--tooltip-bg": "var(--success, #88F878)",
    "--text-secondary": "#B0B0B0",
    "--text-muted": "#8F8F8F",
    "--badge-border-bg": "#1C1C1C",
    "--card-bg": "#262323",
    "--border": "#585858",
    "--input-bg": "#262323",
    "--input-border": "#585858",
    "--input-focus-border": "#FFFFFF",
    "--border-gradient": "#B0B0B0",
    "--card-bg-gradient": "#262323",
    "--button-primary-bg": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--button-primary-text": "#1C1C1C",
    "--danger": "#FF6B6B",
    "--success": "#88F878",
    "--badge-text": "#1C1C1C",
    "--badge-border": "none",
    "--badge-success-bg-solid": "var(--success)",
    "--badge-success-bg-tint": "#88F878",
    "--badge-success-bg-gradient": "var(--button-primary-bg)",
    "--badge-quantity-bg": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--badge-quantity-text": "#1C1C1C",
    "--accent-border": "#FFFFFF",
    "--offset-shadow": "2px",
    // Pay button
    "--pay-button-text-enabled": "var(--button-primary-text)",
    "--pay-button-text-disabled": "var(--text-muted)",
    // Upsell carousel
    "--upsell-card-bg": "var(--card-bg, #262323)",
    "--upsell-card-bg-active": "linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.05) 100%), #262323",
    "--upsell-border-active": "var(--border, #585858)",
    "--upsell-border-default": "#3D3D3D",
    "--upsell-btn-bg-active": "var(--border, #585858)",
    "--upsell-btn-bg-delete": "var(--card-bg, #262323)",
    "--upsell-btn-text-active": "#FFFFFF",
    "--upsell-text": "var(--text, #FFFFFF)",
    "--upsell-icon": "var(--text, #FFFFFF)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.75)",
    "--toast-bg": "var(--card-bg, #262323)",
    "--toast-border": "var(--border, #585858)",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.30)",
    // Placeholder dropdown / Input field states
    "--input-border-filled": "#585858",
    "--input-border-empty": "#585858",
    "--input-border-disabled": "#3D3D3D",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-error-message": "#1C1C1C",
    "--input-bg-filled": "#262323",
    "--input-bg-empty": "#262323",
    "--input-bg-disabled": "#1C1C1C",
    "--input-bg-invalid": "#262323",
    "--input-disabled-bg-variant": "#1C1C1C",
    "--input-focus-blur": "blur(4px)",
    "--input-focus-shadow-bg": "rgba(255, 255, 255, 0.3)",
    "--loading-skeleton-color": "transparent",
    // Shipping section
    "--shipping-radio-unchecked": "var(--border)",
    "--shipping-radio-checked": "var(--border-gradient)",
    "--shipping-radio-inner": "var(--bg)",
    "--shipping-expanded-bg": "var(--bg)",
    "--shipping-badge-cheapest": "var(--border-gradient)",
    "--shipping-border-selected": "var(--border-gradient)"
  },
  glassy: {
    "--bg": "transparent",
    "--bg-secondary": "rgba(255, 255, 255, 0.7)",
    "--text": "#111111",
    "--tooltip-text": "#111111",
    "--tooltip-bg": "var(--success, #63DD51)",
    "--text-secondary": "#2F2F2F",
    "--text-muted": "#5F5F5F",
    "--card-bg": "rgba(255, 255, 255, 0.8)",
    "--badge-border-bg": "rgba(255, 255, 255, 0.8)",
    "--border": "rgba(224, 224, 224, 0.6)",
    "--input-bg": "rgba(255, 255, 255, 0.7)",
    "--input-border": "rgba(224, 224, 224, 0.6)",
    "--input-focus-border": "rgba(255, 255, 255, 0.9)",
    "--border-gradient": "rgba(0, 0, 0, 0.12)",
    "--card-bg-gradient": "transparent",
    "--button-primary-bg": "rgba(28, 28, 28, 0.9)",
    "--button-primary-text": "#ffffff",
    "--danger": "#EE5829",
    "--success": "#63DD51",
    "--badge-text": "#111111",
    "--badge-border": "1px solid var(--border)",
    "--badge-success-bg-solid": "rgba(99, 221, 81, 0.18)",
    "--badge-success-bg-tint": "rgba(99, 221, 81, 0.18)",
    "--badge-success-bg-gradient": "none",
    "--badge-quantity-bg": "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)",
    "--badge-quantity-text": "#1C1C1C",
    "--accent-border": "rgba(255, 255, 255, 0.5)",
    "--offset-shadow": "2px",
    // Pay button
    "--pay-button-text-enabled": "var(--button-primary-text)",
    "--pay-button-text-disabled": "#000",
    // Upsell carousel
    "--upsell-card-bg": "var(--card-bg, rgba(255, 255, 255, 0.7))",
    "--upsell-card-bg-active": "var(--card-bg, rgba(255, 255, 255, 0.7))",
    "--upsell-border-active": "var(--border, #E0E0E0)",
    "--upsell-border-default": "var(--border, #E0E0E0)",
    "--upsell-btn-bg-active": "rgba(255, 255, 255, 0.65)",
    "--upsell-btn-bg-delete": "var(--card-bg, #fff)",
    "--upsell-btn-text-active": "#1C1C1C",
    "--upsell-text": "var(--text, #1C1C1C)",
    "--upsell-icon": "var(--text, #1C1C1C)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.60)",
    "--toast-bg": "var(--bg-secondary, rgba(255, 255, 255, 0.7))",
    "--toast-border": "var(--border, rgba(224, 224, 224, 0.6))",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.10)",
    // Placeholder dropdown / Input field states
    "--input-border-filled": "rgba(224, 224, 224, 0.6)",
    "--input-border-empty": "rgba(224, 224, 224, 0.6)",
    "--input-border-disabled": "rgba(224, 224, 224, 0.4)",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-filled": "rgba(255, 255, 255, 0.85)",
    "--input-bg-empty": "rgba(255, 255, 255, 0.7)",
    "--input-bg-disabled": "rgba(255, 255, 255, 0.5)",
    "--input-bg-error-message": "#fff",
    "--input-bg-invalid": "rgba(255, 255, 255, 0.7)",
    "--input-disabled-bg-variant": "rgba(255, 255, 255, 0.5)",
    // Glassy-specific effects
    "--input-backdrop-filter": "blur(18px)",
    "--input-box-shadow-filled": "inset 0 1px 0 rgba(255, 255, 255, 0.55)",
    "--input-focus-blur": "blur(8px)",
    "--input-focus-shadow-bg": "rgba(255, 255, 255, 0.4)",
    "--loading-skeleton-color": "transparent",
    // Shipping section
    "--shipping-radio-unchecked": "rgba(0, 0, 0, 0.15)",
    "--shipping-radio-checked": "rgba(0, 0, 0, 0.55)",
    "--shipping-radio-inner": "rgba(255, 255, 255, 0.9)",
    "--shipping-expanded-bg": "var(--bg-secondary)",
    "--shipping-badge-cheapest": "var(--bg-secondary)",
    "--shipping-border-selected": "rgba(0, 0, 0, 0.08)"
  },
  soft: {
    "--bg": "#DEDCDC",
    "--bg-secondary": "#F0F0F0",
    "--bg-tertiary": "#BEBBB4",
    "--text": "#000000",
    "--tooltip-text": "#FFFFFF",
    "--tooltip-bg": "#000000",
    "--text-secondary": "#555555",
    "--text-muted": "#888888",
    "--card-bg": "#FFFFFF",
    "--badge-border-bg": "#BEBBB4",
    "--border": "#E0E0E0",
    "--input-bg": "#F0F0F0",
    "--input-border": "#E0E0E0",
    "--input-focus-border": "#BEBBB4",
    "--border-gradient": "#BEBBB4",
    "--card-bg-gradient": "#FFFFFF",
    "--button-primary-bg": "#F0F0F0",
    "--button-primary-text": "#888888",
    "--button-active-bg": "#000000",
    "--button-active-text": "#FFFFFF",
    "--danger": "#EE5829",
    "--success": "#63DD51",
    "--badge-text": "#000000",
    "--badge-border": "none",
    "--badge-success-bg-solid": "var(--success)",
    "--badge-success-bg-tint": "rgba(99, 221, 81, 0.18)",
    "--badge-success-bg-gradient": "#BEBBB4",
    "--badge-quantity-bg": "#BEBBB4",
    "--badge-quantity-text": "#000000",
    "--accent-border": "#BEBBB4",
    "--offset-shadow": "-1px",
    // Pay button
    "--pay-button-text-disabled": "#888888",
    "--pay-button-bg-disabled": "#BEBBB4",
    "--pay-button-text-enabled": "#FFFFFF",
    "--pay-button-bg-enabled": "#000000",
    // Upsell carousel
    "--upsell-card-bg": "#FFFFFF",
    "--upsell-card-bg-active": "#FFFFFF",
    "--upsell-border-active": "#BEBBB4",
    "--upsell-border-default": "var(--border, #E0E0E0)",
    "--upsell-btn-bg-active": "#BEBBB4",
    "--upsell-btn-bg-delete": "var(--card-bg, #fff)",
    "--upsell-btn-text-active": "#000000",
    "--upsell-text": "var(--text, #000000)",
    "--upsell-icon": "var(--text, #000000)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.60)",
    "--toast-bg": "#FFFFFF",
    "--toast-border": "var(--border, #E0E0E0)",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.10)",
    // Placeholder dropdown / Input field states
    "--input-border-filled": "#BEBBB4",
    "--input-border-empty": "#E0E0E0",
    "--input-border-disabled": "#E0E0E0",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-filled": "#F0F0F0",
    "--input-bg-empty": "#F0F0F0",
    "--input-bg-disabled": "#F7F7F7",
    "--input-bg-error-message": "#fff",
    "--input-bg-invalid": "#F0F0F0",
    "--input-disabled-bg-variant": "#F7F7F7",
    "--input-focus-blur": "blur(4px)",
    "--input-focus-shadow-bg": "rgba(190, 187, 180, 0.3)",
    "--loading-skeleton-color": "rgba(255, 255, 255, 0.10)",
    // Shipping section
    "--shipping-radio-unchecked": "var(--border)",
    "--shipping-radio-checked": "var(--border-gradient)",
    "--shipping-radio-inner": "var(--card-bg)",
    "--shipping-expanded-bg": "var(--card-bg)",
    "--shipping-badge-cheapest": "var(--border-gradient)",
    "--shipping-border-selected": "var(--border-gradient)",
    // Input with icon
    "--input-icon-color": "#888888"
  },
  classic: {
    "--bg": "#FFFFFF",
    "--bg-secondary": "#F5F5F5",
    "--bg-tertiary": "#E0E0E0",
    "--text": "#000000",
    "--tooltip-text": "#FFFFFF",
    "--tooltip-bg": "#000000",
    "--text-secondary": "#666666",
    "--text-muted": "#999999",
    "--card-bg": "#FFFFFF",
    "--badge-border-bg": "#FFFFFF",
    "--border": "#E0E0E0",
    "--input-bg": "#FFFFFF",
    "--input-border": "#E0E0E0",
    "--input-focus-border": "#000000",
    "--border-gradient": "#000000",
    "--card-bg-gradient": "#FFFFFF",
    "--button-primary-bg": "#E0E0E0",
    "--button-primary-text": "#555555",
    "--button-active-bg": "#000000",
    "--button-active-text": "#FFFFFF",
    "--danger": "#EE5829",
    "--success": "#63DD51",
    "--badge-text": "#FFFFFF",
    "--badge-border": "none",
    "--badge-success-bg-solid": "#000000",
    "--badge-success-bg-tint": "rgba(0, 0, 0, 0.18)",
    "--badge-success-bg-gradient": "#000000",
    "--badge-quantity-bg": "#000000",
    "--badge-quantity-text": "#FFFFFF",
    "--accent-border": "#000000",
    "--offset-shadow": "-1px",
    // Pay button
    "--pay-button-text-disabled": "#555555",
    "--pay-button-bg-disabled": "#E0E0E0",
    "--pay-button-text-enabled": "#FFFFFF",
    "--pay-button-bg-enabled": "#000000",
    // Upsell carousel
    "--upsell-card-bg": "#FFFFFF",
    "--upsell-card-bg-active": "#FFFFFF",
    "--upsell-border-active": "#000000",
    "--upsell-border-default": "var(--border, #E0E0E0)",
    "--upsell-btn-bg-active": "#000000",
    "--upsell-btn-bg-delete": "var(--card-bg, #fff)",
    "--upsell-btn-text-active": "#FFFFFF",
    "--upsell-text": "var(--text, #000000)",
    "--upsell-icon": "var(--text, #000000)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.60)",
    "--toast-bg": "#FFFFFF",
    "--toast-border": "var(--border, #E0E0E0)",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.10)",
    // Placeholder dropdown / Input field states
    "--input-border-filled": "#000000",
    "--input-border-empty": "#E0E0E0",
    "--input-border-disabled": "#E0E0E0",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-filled": "#FFFFFF",
    "--input-bg-empty": "#FFFFFF",
    "--input-bg-disabled": "#F5F5F5",
    "--input-bg-error-message": "#fff",
    "--input-bg-invalid": "#FFFFFF",
    "--input-disabled-bg-variant": "#F5F5F5",
    "--input-focus-blur": "blur(4px)",
    "--input-focus-shadow-bg": "rgba(0, 0, 0, 0.15)",
    "--loading-skeleton-color": "rgba(0, 0, 0, 0.05)",
    // Shipping section
    "--shipping-radio-unchecked": "var(--border)",
    "--shipping-radio-checked": "#000000",
    "--shipping-radio-inner": "var(--card-bg)",
    "--shipping-expanded-bg": "var(--card-bg)",
    "--shipping-badge-cheapest": "#000000",
    "--shipping-border-selected": "#000000",
    "--shipping-border-selected-p": "1px",
    // Input with icon
    "--input-icon-color": "#000000"
  },
  custom: {
    "--bg": "#FFFFFF",
    "--bg-secondary": "#FFFFFF",
    "--bg-tertiary": "#E0E0E0",
    "--text": "#000000",
    "--tooltip-text": "#FFFFFF",
    "--tooltip-bg": "#000000",
    "--text-secondary": "#666666",
    "--text-muted": "#999999",
    "--card-bg": "#FFFFFF",
    "--badge-border-bg": "#FFFFFF",
    "--border": "#E0E0E0",
    "--input-bg": "#FFFFFF",
    "--input-border": "#E0E0E0",
    "--button-primary-bg": "#E0E0E0",
    "--button-primary-text": "#555555",
    "--danger": "#EE5829",
    "--success": "#63DD51",
    "--badge-border": "none",
    "--badge-success-bg-tint": "rgba(0, 0, 0, 0.18)",
    "--offset-shadow": "-1px",
    // Pay button
    "--pay-button-text-disabled": "#555555",
    "--pay-button-bg-disabled": "#E0E0E0",
    // Upsell carousel
    "--upsell-card-bg": "#FFFFFF",
    "--upsell-card-bg-active": "#FFFFFF",
    "--upsell-border-default": "var(--border, #E0E0E0)",
    "--upsell-btn-bg-delete": "var(--card-bg, #fff)",
    "--upsell-text": "var(--text, #000000)",
    "--upsell-icon": "var(--text, #000000)",
    // Toast
    "--toast-overlay-bg": "rgba(0, 0, 0, 0.60)",
    "--toast-bg": "#FFFFFF",
    "--toast-border": "var(--border, #E0E0E0)",
    "--toast-shadow": "0px 0px 10px rgba(0, 0, 0, 0.10)",
    // Input field states
    "--input-border-empty": "#E0E0E0",
    "--input-border-disabled": "#E0E0E0",
    "--input-border-invalid": "var(--danger)",
    "--input-bg-filled": "#FFFFFF",
    "--input-bg-empty": "#FFFFFF",
    "--input-bg-disabled": "#F5F5F5",
    "--input-bg-error-message": "#fff",
    "--input-bg-invalid": "#FFFFFF",
    "--input-disabled-bg-variant": "#F5F5F5",
    "--input-focus-blur": "blur(4px)",
    "--loading-skeleton-color": "rgba(0, 0, 0, 0.05)",
    // Shipping section
    "--shipping-radio-unchecked": "var(--border)",
    "--shipping-radio-inner": "var(--card-bg)",
    "--shipping-expanded-bg": "var(--card-bg)",
    "--shipping-border-selected-p": "1px",
    "--card-bg-gradient": "#FFFFFF",
    // Brand-dynamic: accent variables use var(--brand-primary-color)
    "--brand-primary-color": "#000000",
    "--border-gradient": "var(--brand-primary-color)",
    "--input-icon-color": "var(--brand-primary-color)",
    "--input-focus-border": "var(--brand-primary-color)",
    "--input-border-filled": "var(--brand-primary-color)",
    "--input-focus-shadow-bg": "var(--brand-primary-color)",
    "--accent-border": "var(--brand-primary-color)",
    "--button-active-bg": "var(--brand-primary-color)",
    "--button-active-text": "#FFFFFF",
    "--pay-button-bg-enabled": "var(--brand-primary-color)",
    "--pay-button-text-enabled": "#FFFFFF",
    "--upsell-btn-bg-active": "var(--brand-primary-color)",
    "--upsell-border-active": "var(--brand-primary-color)",
    "--upsell-btn-text-active": "#FFFFFF",
    "--badge-success-bg-solid": "var(--brand-primary-color)",
    "--badge-success-bg-gradient": "var(--brand-primary-color)",
    "--badge-quantity-bg": "var(--brand-primary-color)",
    "--badge-text": "#FFFFFF",
    "--badge-quantity-text": "#FFFFFF",
    "--shipping-radio-checked": "var(--brand-primary-color)",
    "--shipping-badge-cheapest": "var(--brand-primary-color)",
    "--shipping-border-selected": "var(--brand-primary-color)"
  }
};
function Ea(t) {
  return Wt[t] ?? Wt[gt];
}
function Ia(t) {
  return jt[t] ?? jt[gt];
}
function _a(t) {
  return Ln.includes(t);
}
function Aa(t) {
  const r = {};
  t.brandColorPrimary && (r["--brand-primary-color"] = t.brandColorPrimary), t.background === "transparent" && (r["--bg"] = "transparent", r["--bg-secondary"] = "rgba(255, 255, 255, 0.7)", r["--card-bg"] = "rgba(255, 255, 255, 0.8)");
  const a = t.buttonTextColor ?? "#FFFFFF";
  r["--button-active-text"] = a, r["--pay-button-text-enabled"] = a, r["--badge-text"] = a, r["--badge-quantity-text"] = a, r["--upsell-btn-text-active"] = a;
  const o = a.replace("#", ""), n = parseInt(o.substring(0, 2), 16), d = parseInt(o.substring(2, 4), 16), s = parseInt(o.substring(4, 6), 16), c = (n * 299 + d * 587 + s * 114) / 1e3;
  return r["--pay-button-icon-filter"] = c < 128 ? "invert(1)" : "none", r;
}
const Vt = Fr({
  themeName: gt
}), de = () => yr(Vt), Da = ({
  themeName: t,
  children: r
}) => /* @__PURE__ */ e(Vt.Provider, { value: { themeName: t }, children: r }), Mn = {
  borderRadius: "1.875rem",
  filter: "blur(4px)",
  content: '""',
  position: "absolute",
  top: "-px",
  right: "-px",
  bottom: "-px",
  left: "-px",
  bgImage: "var(--input-focus-border)",
  bgClip: "border-box",
  zIndex: -1
}, Ge = ({
  variant: t,
  children: r,
  borderRadius: a = "1.125rem",
  borderBottomRadius: o,
  borderTopRadius: n,
  borderTop: d,
  borderBottom: s,
  ...c
}) => {
  const { themeName: b } = de(), S = b === "glassy";
  return /* @__PURE__ */ e(
    u,
    {
      borderRadius: a,
      borderBottomRadius: o,
      borderTopRadius: n,
      padding: ["gradient", "typing", "error"].includes(t) ? "1px" : "",
      pb: s,
      pt: d,
      width: "100%",
      display: "flex",
      bgImage: ["gradient", "typing"].includes(t) ? "var(--input-focus-border)" : "",
      border: ["primary", "typing", "gradient"].includes(t) ? "1px solid var(--border, #E0E0E0)" : "",
      bg: t === "error" ? "#EE5829" : S ? "rgba(255, 255, 255, 0.85)" : "",
      _before: t === "typing" ? { ...Mn } : {},
      position: "relative",
      children: /* @__PURE__ */ e(
        u,
        {
          bg: ["gradient", "typing", "error"].includes(t) ? "var(--card-bg, #FFF)" : "transparent",
          borderRadius: a,
          borderBottomRadius: o,
          borderTopRadius: n,
          width: "100%",
          display: "flex",
          children: /* @__PURE__ */ e(
            u,
            {
              bgGradient: t === "gradient" ? "var(--card-bg, #FFF)" : "#FFF",
              borderRadius: a,
              borderBottomRadius: o,
              borderTopRadius: n,
              width: "100%",
              display: "flex",
              ...c,
              children: r
            }
          )
        }
      )
    }
  );
};
Ge.defaultProps = {
  border: "md",
  variant: "primary"
};
const za = ({ title: t, subtitle: r, children: a, hasBorder: o, uppercaseTitle: n, ...d }) => /* @__PURE__ */ l(
  u,
  {
    className: "leaf-card__container",
    w: "full",
    borderWidth: o ? "1px" : "inherit",
    borderRadius: o ? "lg" : "none",
    ...d,
    children: [
      /* @__PURE__ */ l(u, { children: [
        /* @__PURE__ */ e(
          p,
          {
            textTransform: n ? "uppercase" : "none",
            className: "leaf-card__title",
            fontSize: "lg",
            fontWeight: "500",
            lineHeight: "6",
            children: t
          }
        ),
        r ? /* @__PURE__ */ e(
          p,
          {
            className: "leaf-card__subtitle",
            color: "var(--text-muted, #8F8F8F)",
            fontSize: "sm",
            fontWeight: "350",
            lineHeight: "5",
            dangerouslySetInnerHTML: { __html: r }
          }
        ) : null
      ] }),
      a ? /* @__PURE__ */ e(se, { className: "leaf-card__content", spacing: 2, pt: 4, children: a }) : null
    ]
  }
), Tn = ({
  isOpen: t,
  closedLabel: r,
  title: a,
  openIcon: o,
  drawerPosition: n,
  titleTextProps: d,
  hideCloseIcon: s,
  isFixFooter: c,
  ...b
}) => /* @__PURE__ */ l(
  U,
  {
    "aria-description": "DrawerHeader",
    w: "full",
    position: "absolute",
    cursor: "pointer",
    top: "0",
    zIndex: 1001,
    pt: 1.5,
    px: 4,
    pb: 0,
    justifyContent: "center",
    gap: 2,
    borderTopRadius: "3xl",
    bgColor: "var(--card-bg, #FFF)",
    ...b,
    children: [
      n === "bottom" && /* @__PURE__ */ e(
        u,
        {
          w: "3rem",
          h: "0.25rem",
          bg: "var(--border, #D9D9D9)",
          borderRadius: "0.125rem",
          className: "dash",
          left: "50%",
          transform: "translateX(-50%)",
          position: "absolute"
        }
      ),
      /* @__PURE__ */ e(u, { display: t ? "none" : "flex", mt: 3, children: r }),
      /* @__PURE__ */ l(
        U,
        {
          mt: 2,
          flex: "1",
          alignSelf: "center",
          alignItems: "center",
          alignContent: "center",
          pt: n === "bottom" ? "" : "2",
          justifyContent: n === "bottom" ? "space-between" : "center",
          children: [
            /* @__PURE__ */ e(
              p,
              {
                color: "var(--text, #1C1C1C)",
                textAlign: "center",
                fontWeight: "medium",
                lineHeight: "6",
                fontSize: "md",
                display: t ? "flex" : "none",
                ...d,
                ...n !== "bottom" ? { flex: 1, justifyContent: "center" } : {},
                children: a
              }
            ),
            t && !s && (n === "bottom" && c ? /* @__PURE__ */ e(
              u,
              {
                "aria-description": "justDrawerCloseIcon",
                h: "1.5rem",
                w: "1.5rem",
                rounded: "full",
                bgColor: "var(--bg-secondary, #F7F7F7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                children: /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ e(
                  "path",
                  {
                    d: "M7.19995 9.60001L12 14.4L16.8 9.60001",
                    stroke: "var(--text-secondary, #585858)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                ) })
              }
            ) : /* @__PURE__ */ e(
              Ve,
              {
                boxSize: "0.8rem",
                "aria-description": "justDrawerCloseIcon",
                top: n === "bottom" ? "4" : "8",
                right: n === "bottom" ? "8" : "12",
                color: "var(--text-secondary, #585858)"
              }
            ))
          ]
        }
      ),
      !t && o ? /* @__PURE__ */ e(u, { mt: 3, children: o }) : null
    ]
  }
), Pn = (t, r) => {
  const [a, o] = P(!1);
  return X(() => {
    let n;
    return t && !a ? o(!0) : !t && a && (n = window.setTimeout(() => o(!1), r)), () => {
      clearTimeout(n);
    };
  }, [r, t, a]), a;
};
function Nn() {
  const t = document.createElement("div");
  return t.setAttribute("id", Xt), t;
}
const Xt = "justdrawer-root", Yn = 300, qn = 8, On = () => {
  const [t, r] = P(!1), a = M(() => {
    r(!t);
  }, [t]), o = M(() => {
    r(!0);
  }, []), n = M(() => {
    r(!1);
  }, []);
  return { isOpen: t, onToggle: a, onClose: n, onOpen: o };
}, he = (t, r) => t === "bottom" ? `rgba(255, 255, 255, ${r})` : `rgba(0, 0, 0, ${r - 0.3})`, Vn = ({
  children: t,
  onClose: r,
  onOpen: a,
  isOpen: o,
  position: n = "bottom",
  title: d,
  removeWhenClosed: s = !0,
  isFullHeight: c = !1,
  size: b = "unset",
  width: S,
  containerRef: F,
  closedLabel: g,
  fixFooter: _,
  onSwipeOpened: f,
  onClickOpened: m,
  onSwipeClosed: y,
  onClickClosed: C,
  openIcon: E,
  titleTextProps: x,
  hideCloseIcon: $,
  lockScrollZones: j = [],
  isMainDrawer: H,
  closeOnOverlayClick: D = !0,
  closedBgColor: k
}) => {
  const A = Q(null), h = Q(null), G = Q(null), [z, R] = P(he(n, 0.8)), [V, O] = P(0), ee = Z(() => !o && s ? "0" : !o && !g ? "12px" : "46px", [o, s, g]);
  X(() => {
    A.current = document.getElementById(Xt) ?? Nn();
  }, []);
  const i = Pn(o, Yn);
  X(() => {
    (() => {
      F != null && F.current && (o ? F.current.style.overflow = "hidden" : F.current.style.overflow = "");
    })();
  }, [F, o]);
  const v = M(
    (T) => {
      T.key === "Escape" && o && r();
    },
    [o, r]
  ), w = M(() => {
    o ? (r(), C == null || C()) : (a(), m == null || m());
  }, [o, C, m, r, a]), B = M(
    (T) => {
      D && T.target instanceof HTMLElement && T.target.classList.contains("justdrawer-overlay-wrapper") && r();
    },
    [r]
  ), [W, N] = P(0), [I, te] = P({
    start: 0,
    newHeight: 0,
    startHeight: 0,
    swipeUpLocked: !1,
    swipeDownLocked: !1,
    lastActionAborted: !1
  }), ae = M(
    (T) => {
      var Ie, _e, ye, ie, Ae;
      if (!T.touches[0] || !(G != null && G.current)) return;
      const K = T.target, ce = j.some((Pe) => !!(K != null && K.closest(Pe))), Ee = ((Ie = G.current) == null ? void 0 : Ie.scrollTop) + ((_e = G.current) == null ? void 0 : _e.clientHeight) === ((ye = G.current) == null ? void 0 : ye.scrollHeight), Te = ((ie = G.current) == null ? void 0 : ie.scrollTop) == 0;
      N(window.innerHeight), te({
        lastActionAborted: !1,
        swipeUpLocked: o && (!Ee || ce),
        swipeDownLocked: o && (!Te || ce),
        start: T.touches[0].clientY,
        newHeight: 0,
        startHeight: ((Ae = G == null ? void 0 : G.current) == null ? void 0 : Ae.clientHeight) ?? 0
      });
    },
    [o, j]
  ), re = M(() => {
    if (I.newHeight !== 0) {
      if (!I.lastActionAborted) {
        const T = qn * (W / 100);
        I.newHeight - I.startHeight > T ? (R(he(n, 0.8)), O(1), a(), f == null || f()) : I.startHeight - I.newHeight > T && (R(he(n, 0)), O(0), r(), y == null || y());
      }
      te({
        start: 0,
        newHeight: 0,
        startHeight: 0,
        swipeDownLocked: !1,
        swipeUpLocked: !1,
        lastActionAborted: !1
      });
    }
  }, [
    r,
    a,
    y,
    f,
    I.lastActionAborted,
    I.newHeight,
    W
  ]), we = M(
    (T) => {
      if (!T.touches[0]) return;
      if (I.swipeDownLocked && T.touches[0].clientY - I.start > 0 || I.swipeUpLocked && T.touches[0].clientY - I.start < 0) {
        te({
          ...I,
          lastActionAborted: !0
        });
        return;
      }
      let K = T.touches[0].clientY - I.start < 0 ? Math.abs(T.touches[0].clientY - I.start) + I.startHeight : I.startHeight - Math.abs(T.touches[0].clientY - I.start);
      return K = K < 0 ? 1 : K, te({
        ...I,
        newHeight: K
      }), !1;
    },
    [I]
  );
  return X(() => {
    if (I.newHeight) {
      const T = I.newHeight / (W / 2), K = Math.abs(T < 0.8 ? T : 0.8);
      R(he(n, K)), O(K);
    } else o ? (R(he(n, 0.8)), O(1)) : (R(he(n, 0)), O(0));
  }, [I.newHeight, o, W, n]), X(() => (document.addEventListener("keydown", v, !1), () => document.removeEventListener("keydown", v, !1)), [v]), X(() => {
    if (!(F != null && F.current) || !(A != null && A.current)) return;
    F.current.appendChild(A.current);
    const T = F.current;
    return () => {
      T.style.overflow = "";
    };
  }, [F, A]), !i && s && !o || !A.current ? null : Pt(
    /* @__PURE__ */ e(
      "div",
      {
        "aria-hidden": o ? "false" : "true",
        className: `justdrawer-container ${o || I.newHeight ? "open" : ""} ${i || I.newHeight ? "in" : ""} ${I.newHeight ? "swiping" : ""}`,
        children: /* @__PURE__ */ e(
          u,
          {
            className: "justdrawer-overlay-wrapper",
            backgroundColor: z,
            onClick: (T) => o && B(T),
            children: /* @__PURE__ */ l(
              u,
              {
                onTouchStart: ae,
                onTouchEnd: re,
                onTouchMove: we,
                roundedTop: c && n === "bottom" ? "none" : "3xl",
                roundedBottom: n === "bottom" ? "none" : "3xl",
                boxShadow: "0px -2px 12px 0px rgba(0, 0, 0, 0.15)",
                className: `justdrawer ${n}${_ ? " has-fix-footer" : ""}`,
                width: S && o && ["left", "right"].includes(n) ? `${S} !important` : "",
                role: "dialog",
                ref: h,
                pt: ee,
                height: !o && !_ && n === "bottom" ? 0 : c && o && !I.newHeight ? "full" : "unset",
                zIndex: H ? "900 !important" : void 0,
                bgColor: o ? "" : k,
                children: [
                  /* @__PURE__ */ e(
                    Tn,
                    {
                      drawerPosition: n,
                      isOpen: o,
                      title: d,
                      closedLabel: g,
                      onClick: w,
                      openIcon: E,
                      titleTextProps: x,
                      hideCloseIcon: $,
                      isFixFooter: !!_,
                      bgColor: o ? "" : k
                    }
                  ),
                  /* @__PURE__ */ e(
                    u,
                    {
                      className: "justdrawer-content",
                      overflowY: "scroll",
                      alignItems: "center",
                      mt: n === "bottom" ? "0" : "7",
                      ref: G,
                      opacity: V,
                      height: I.newHeight ? `${I.newHeight}px` : o ? c ? "full" : b : 0,
                      children: t
                    }
                  ),
                  /* @__PURE__ */ e(u, { px: 4, mt: 2, children: _ })
                ]
              }
            )
          }
        )
      }
    ),
    A.current
  );
}, et = (t) => t.replace(
  new RegExp("\\p{Emoji}", "gu"),
  ""
).trim();
function Kt(t, r) {
  return t.length > r ? t.slice(0, r) + "..." : t;
}
const ut = (t) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...t,
    children: [
      /* @__PURE__ */ e("path", { d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" }),
      /* @__PURE__ */ e("circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" })
    ]
  }
), Xn = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%3e%3ccircle%20opacity='0.1'%20cx='16'%20cy='16'%20r='16'%20fill='url(%23paint0_linear_1166_84650)'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1166_84650'%20x1='0'%20y1='16'%20x2='32'%20y2='16'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.0208333'%20stop-color='%238DE690'/%3e%3cstop%20offset='0.182292'%20stop-color='%23A5F0A3'/%3e%3cstop%20offset='0.333333'%20stop-color='%23A6ECD7'/%3e%3cstop%20offset='0.515625'%20stop-color='%2397DADA'/%3e%3cstop%20offset='0.677083'%20stop-color='%23B3DAE7'/%3e%3cstop%20offset='0.833333'%20stop-color='%23B6C9EC'/%3e%3cstop%20offset='1'%20stop-color='%23879ACB'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", Ht = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%3e%3ccircle%20opacity='0.3'%20cx='16'%20cy='16'%20r='16'%20fill='%23E0E0E0'/%3e%3c/svg%3e", Kn = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%3e%3ccircle%20opacity='0.05'%20cx='16'%20cy='16'%20r='16'%20fill='%23EE5829'/%3e%3c/svg%3e", Jt = $e(
  ({
    label: t,
    helper: r,
    error: a,
    isInvalid: o,
    isDisabled: n,
    isRequired: d = !0,
    value: s,
    onChange: c,
    onFocus: b,
    onBlur: S,
    Icon: F,
    variantError: g,
    trackingId: _,
    wrapperRadius: f,
    ...m
  }, y) => {
    const [C, E] = P(!1), [x, $] = P(!!a), j = tt(), { themeName: H } = de(), D = H === "black", k = H === "classic", A = H === "custom", h = Z(() => {
      const i = j == null ? void 0 : j.themedClasses;
      return {
        inputBorderStyle: (i == null ? void 0 : i.inputBorderStyle) ?? ot,
        inputBorderGradientStyle: (i == null ? void 0 : i.inputBorderGradientStyle) ?? nt,
        inputBorderDisabledStyle: (i == null ? void 0 : i.inputBorderDisabledStyle) ?? lt,
        inputBorderInvalidStyle: (i == null ? void 0 : i.inputBorderInvalidStyle) ?? at,
        inputBorderEmptyStyle: (i == null ? void 0 : i.inputBorderEmptyStyle) ?? it,
        inputBackgroundGradientStyle: (i == null ? void 0 : i.inputBackgroundGradientStyle) ?? st,
        inputBackgroundDisabledStyle: (i == null ? void 0 : i.inputBackgroundDisabledStyle) ?? dt,
        inputBackgroundEmptyStyle: (i == null ? void 0 : i.inputBackgroundEmptyStyle) ?? ct,
        inputBackgroundInvalidStyle: (i == null ? void 0 : i.inputBackgroundInvalidStyle) ?? bt,
        inputBoxShadowGradientStyle: (i == null ? void 0 : i.inputBoxShadowGradientStyle) ?? pt
      };
    }, [j]), G = M(
      (i) => {
        c == null || c(i), $(!1);
      },
      [c, $]
    );
    X(() => {
      $(!!a);
    }, [a, $]);
    const z = {
      bgGradient: "",
      bg: "var(--input-focus-border, #BEBBB4)",
      p: "1px"
    }, R = `var(--input-icon-color, ${D ? "#FFFFFF" : A ? "#888888" : "#63DD51"})`;
    return /* @__PURE__ */ l(
      je,
      {
        variant: "floatingWithIcon",
        isRequired: d,
        isInvalid: !!o,
        isDisabled: !!n,
        width: "full",
        children: [
          /* @__PURE__ */ e(
            u,
            {
              _before: (C && !x || !s && !x && m.type === "email") && !k && !A ? { ...h.inputBoxShadowGradientStyle } : {},
              children: /* @__PURE__ */ e(
                u,
                {
                  ...h.inputBorderStyle,
                  ...h.inputBorderGradientStyle,
                  ...A && z,
                  ...n ? h.inputBorderDisabledStyle : {},
                  ...x || x ? h.inputBorderInvalidStyle : {},
                  ...!s && !C && !x && !A ? h.inputBorderEmptyStyle : {},
                  ...f !== void 0 ? { borderRadius: f } : {},
                  children: /* @__PURE__ */ l(
                    xe,
                    {
                      alignItems: "center",
                      justifyContent: "space-between",
                      alignContent: "center",
                      alignSelf: "center",
                      children: [
                        /* @__PURE__ */ l(Lt, { boxSize: "2rem", display: "flex", mt: 3, ml: 4, children: [
                          /* @__PURE__ */ e(
                            Fe,
                            {
                              src: !x && !n && C || !s && !x && !n && m.type === "email" ? D ? Ht : Xn : x && !n ? Kn : Ht,
                              alt: "Input Ellipse",
                              position: "absolute",
                              top: "0",
                              left: "0",
                              boxSize: "2rem"
                            }
                          ),
                          /* @__PURE__ */ e(
                            F,
                            {
                              fill: s && !x && !n && C || !s && !x && C || !s && !x && !n && m.type === "email" ? R : s && !x && !n ? "var(--text, #1C1C1C)" : x && !n ? "#EE5829" : "#8F8F8F"
                            }
                          )
                        ] }),
                        /* @__PURE__ */ l(xe, { children: [
                          /* @__PURE__ */ e(
                            He,
                            {
                              zIndex: "10",
                              w: "full",
                              variant: "just",
                              placeholder: " ",
                              pl: "3.35rem",
                              pt: 3,
                              fontSize: "md",
                              textAlign: "left",
                              errorBorderColor: "danger.main",
                              ...h.inputBackgroundGradientStyle,
                              ...n ? h.inputBackgroundDisabledStyle : {},
                              ...x ? h.inputBackgroundInvalidStyle : {},
                              ...s ? {} : h.inputBackgroundEmptyStyle,
                              ...f !== void 0 ? { borderRadius: f } : {},
                              borderColor: "transparent",
                              pr: 12,
                              sx: {
                                "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active": {
                                  WebkitBoxShadow: "0 0 0 30px var(--input-bg, #FFF) inset !important",
                                  boxShadow: "0 0 0 30px var(--input-bg, #FFF) inset !important",
                                  WebkitTextFillColor: "var(--text, #1C1C1C) !important",
                                  caretColor: "var(--text, #1C1C1C)",
                                  transition: "background-color 99999s ease-out 0s, color 99999s ease-out 0s"
                                }
                              },
                              value: s,
                              onChange: G,
                              onError: () => {
                                $(!0);
                              },
                              onFocus: (i) => {
                                E(!0), b == null || b(i);
                              },
                              onBlur: (i) => {
                                E(!1), S == null || S(i);
                              },
                              ref: y,
                              ...m,
                              _disabled: { cursor: "default" },
                              "data-ph-capture-attribute-tracking-id": _
                            }
                          ),
                          t && /* @__PURE__ */ e(
                            rt,
                            {
                              requiredIndicator: /* @__PURE__ */ e("abbr", { children: " *" }),
                              fontSize: "md",
                              ml: "3.5",
                              px: "2px",
                              bg: "transparent",
                              style: {
                                backgroundColor: "transparent",
                                zIndex: "20"
                              },
                              children: t
                            }
                          )
                        ] })
                      ]
                    }
                  )
                }
              )
            }
          ),
          r && /* @__PURE__ */ e(Mt, { pl: "4", fontSize: "xs", children: r }),
          x && /* @__PURE__ */ e(
            Ue,
            {
              fontSize: "0.75rem",
              fontWeight: "350",
              zIndex: "5",
              w: "fit-content",
              borderRadius: "0.25rem",
              sx: g === "discount" ? {
                position: "relative",
                color: "#FFF",
                bg: "danger.main",
                borderRadius: "1.875rem",
                py: "0.375rem",
                px: "0.75rem",
                alignItems: "center",
                gap: "1"
              } : {
                position: "absolute",
                color: "danger.main",
                bg: "var(--input-bg-error-message, #FFF)",
                bottom: "-2",
                right: "5",
                px: "1",
                mb: "0.5"
              },
              children: a
            }
          )
        ]
      }
    );
  }
), Wa = ({ name: t, control: r, onChange: a, onBlur: o, ...n }) => /* @__PURE__ */ e(
  Yt,
  {
    control: r,
    name: t,
    render: ({ field: d }) => /* @__PURE__ */ e(
      Jt,
      {
        ...n,
        ...d,
        value: d.value ?? "",
        onChange: (s) => {
          d.onChange(s), a == null || a(s);
        },
        onBlur: () => {
          d.onBlur(), o == null || o();
        }
      }
    )
  }
), Jn = "linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%)", Le = {
  gradient: Jn,
  text: "#1C1C1C",
  icon: "#1C1C1C",
  useBgProp: !1,
  useCustomButtonStyle: !1
}, Ye = {
  gradient: "var(--accent-border, #000000)",
  text: "#FFFFFF",
  icon: "#FFFFFF",
  useBgProp: !0,
  appliedTextColor: "#FFFFFF",
  useCustomButtonStyle: !0
}, Me = {
  black: {
    gradient: "linear-gradient(90deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.15) 100%)",
    text: "#FFFFFF",
    icon: "#FFFFFF",
    useBgProp: !0,
    appliedTextColor: "#1C1C1C",
    useCustomButtonStyle: !1
  },
  soft: Ye,
  classic: Ye,
  custom: Ye
}, Zn = ({
  discount: t,
  onDiscountRemove: r,
  currency: a
}) => {
  var b;
  const [o, n] = P(!1), { themeName: d } = de(), s = Me[d] ?? Le, c = M(async () => {
    t.code && (n(!0), await r(t.code), n(!1));
  }, []);
  return /* @__PURE__ */ l(U, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ l(
      J,
      {
        ...s.useBgProp ? { bg: s.gradient } : { bgGradient: s.gradient },
        opacity: o ? 0.5 : 1,
        borderRadius: "base",
        spacing: 1,
        display: "flex",
        pt: 1.5,
        pr: 1.5,
        pb: 1.5,
        pl: 3,
        alignItems: "center",
        gap: 1,
        children: [
          /* @__PURE__ */ e(ut, { width: "12px", height: "12px", "aria-hidden": "true", focusable: "false", stroke: s.icon }),
          /* @__PURE__ */ e(p, { color: s.text, fontSize: "xs", fontWeight: "medium", lineHeight: "5", children: Kt(((b = t.code) == null ? void 0 : b.toUpperCase()) ?? "", 24) }),
          /* @__PURE__ */ l(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: 20,
              height: 20,
              fill: "none",
              onClick: c,
              cursor: "pointer",
              "data-ph-capture-attribute-tracking-id": "discount-remove-button",
              children: [
                /* @__PURE__ */ e("title", { children: "Remove" }),
                /* @__PURE__ */ e("g", { stroke: s.icon, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, children: /* @__PURE__ */ e("path", { d: "M15 5 5 15M5 5l10 10" }) })
              ]
            }
          )
        ]
      }
    ),
    !!t.amount && /* @__PURE__ */ e(p, { fontSize: "xs", color: "var(--savings, #15803D)", fontWeight: "normal", children: oe(t.amount, { currency: a }) }),
    t.title && ((t == null ? void 0 : t.target) !== "SHIPPING_LINE" || !t.target) && /* @__PURE__ */ l(p, { lineHeight: "5", color: "var(--savings, #15803D)", textAlign: "right", fontSize: "xs", children: [
      "−",
      t.title
    ] })
  ] });
}, Qn = ({
  giftCard: t,
  onGiftCardRemove: r
}) => {
  var c;
  const [a, o] = P(!1), { themeName: n } = de(), d = Me[n] ?? Le, s = M(async () => {
    t.code && (o(!0), await r(), o(!1));
  }, [o, r, t]);
  return /* @__PURE__ */ e(U, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ l(
    J,
    {
      ...d.useBgProp ? { bg: d.gradient } : { bgGradient: d.gradient },
      opacity: a ? 0.5 : 1,
      borderRadius: "base",
      spacing: 1,
      display: "flex",
      pt: 1.5,
      pr: 1.5,
      pb: 1.5,
      pl: 3,
      alignItems: "center",
      gap: 1,
      children: [
        /* @__PURE__ */ e(ut, { width: "12px", height: "12px", "aria-hidden": "true", focusable: "false", stroke: d.icon }),
        /* @__PURE__ */ e(p, { color: d.text, fontSize: "xs", fontWeight: "medium", lineHeight: "5", children: Kt(((c = t.code) == null ? void 0 : c.toUpperCase()) ?? "", 24) }),
        /* @__PURE__ */ l(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: 20,
            height: 20,
            fill: "none",
            onClick: s,
            cursor: "pointer",
            children: [
              /* @__PURE__ */ e("title", { children: "Remove" }),
              /* @__PURE__ */ e("g", { stroke: d.icon, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, children: /* @__PURE__ */ e("path", { d: "M15 5 5 15M5 5l10 10" }) })
            ]
          }
        )
      ]
    }
  ) });
}, ea = ({
  discount: t,
  onDiscountRemove: r,
  onDiscountAddClick: a,
  appliedDiscounts: o,
  currency: n,
  discountApplyLabel: d
}) => {
  const [s, c] = P(!1), { themeName: b } = de(), S = Me[b] ?? Le, F = t.code, g = o.find((m) => (m == null ? void 0 : m.code) == F), _ = M(async () => {
    c(!0);
    try {
      g != null && g.code ? await r(g == null ? void 0 : g.code) : await a(F, !0);
    } catch {
    }
    c(!1);
  }, [g]), f = g != null && g.amount ? oe(g.amount, { currency: n }) : t.saveLabel;
  return /* @__PURE__ */ l(U, { justifyContent: "space-between", alignItems: "center", gap: 2, children: [
    /* @__PURE__ */ l(J, { spacing: 2, minW: 0, children: [
      /* @__PURE__ */ e(
        u,
        {
          flexShrink: 0,
          px: 2,
          py: 1,
          borderRadius: "0.5rem",
          border: "1px solid",
          bg: g ? "rgba(21, 128, 61, 0.08)" : "var(--bg-secondary, #F7F7F7)",
          borderColor: g ? "rgba(21, 128, 61, 0.25)" : "var(--border, #E0E0E0)",
          children: /* @__PURE__ */ e(
            p,
            {
              fontSize: "xs",
              fontWeight: "600",
              lineHeight: "1.3",
              color: g ? "var(--savings, #15803D)" : "var(--text, #1C1C1C)",
              children: F == null ? void 0 : F.toUpperCase()
            }
          )
        }
      ),
      f ? /* @__PURE__ */ e(p, { fontSize: "xs", fontWeight: "medium", color: "var(--savings, #15803D)", noOfLines: 1, children: f }) : null
    ] }),
    g ? /* @__PURE__ */ e(
      U,
      {
        as: "button",
        type: "button",
        onClick: _,
        "aria-label": "Remove",
        flexShrink: 0,
        alignItems: "center",
        justifyContent: "center",
        p: 1,
        opacity: s ? 0.5 : 1,
        color: "var(--text-muted, #8F8F8F)",
        children: /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, fill: "none", children: [
          /* @__PURE__ */ e("title", { children: "Remove" }),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M13.5 4.5 4.5 13.5M4.5 4.5l9 9",
              stroke: "currentColor",
              strokeWidth: 1.5,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        ] })
      }
    ) : /* @__PURE__ */ e(
      Re,
      {
        trackingId: "recommended-discount-item-apply-button",
        size: "xs",
        type: "submit",
        isLoading: s,
        width: "auto",
        h: "8",
        label: d,
        display: "flex",
        py: 2,
        px: 5,
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        gap: 2,
        ml: 1.5,
        onClick: _,
        sx: {
          ...S.useCustomButtonStyle ? {
            background: "var(--button-active-bg)",
            color: "var(--button-active-text)"
          } : {},
          "&:hover, &:disabled": {
            bgImage: "none",
            border: "1px solid var(--border, #E0E0E0)",
            background: "var(--bg-secondary, #F7F7F7)",
            color: "var(--text, #1C1C1C)"
          },
          "&:disable": {
            cursor: "default"
          },
          border: "1px solid transparent",
          fontWeight: "medium",
          lineHeight: "6",
          fontSize: "xs"
        }
      }
    )
  ] });
}, Ut = ({
  discountApplyLabel: t,
  discountInputLabel: r,
  isDiscountDisabled: a = !1,
  isDiscountHidden: o = !1,
  onDiscountAddClick: n,
  discountErrorLabel: d,
  onDiscountRemove: s,
  onGiftCardRemove: c,
  discounts: b,
  giftCards: S,
  currency: F,
  shouldFocusField: g,
  discountFinderLabel: _,
  recommendedDiscounts: f = [],
  Icon: m,
  setDiscountValue: y
}) => {
  var G;
  const [C, E] = P(""), x = Q(null), [$, j] = P(!1), { themeName: H } = de(), D = Me[H] ?? Le, k = M(async () => {
    y == null || y(x.current.value), j(!0);
    try {
      await n(x.current.value), E(""), y == null || y("");
    } finally {
      j(!1);
    }
  }, [j, n, x]), A = M(
    (z) => {
      z.key === "Enter" && k();
    },
    [k]
  );
  X(() => {
    var z;
    g && ((z = x.current) == null || z.focus());
  }, [g]);
  const h = f.find(
    (z) => (b ?? []).some((R) => (R == null ? void 0 : R.code) === z.code)
  );
  return /* @__PURE__ */ l(le, { children: [
    o === !0 ? null : /* @__PURE__ */ l(
      xe,
      {
        size: "md",
        display: "flex",
        flexDirection: "row",
        alignItems: "flexStart",
        justifyContent: "center",
        children: [
          /* @__PURE__ */ e(
            Jt,
            {
              trackingId: "discount-input",
              autoComplete: "text",
              ref: x,
              isInvalid: !!d,
              isDisabled: a,
              label: r,
              isRequired: !1,
              flex: "1 0 0",
              h: "10",
              fontSize: "xs",
              value: C,
              variantError: "discount",
              onChange: (z) => {
                E(z.currentTarget.value);
              },
              gap: 4,
              Icon: m,
              onKeyDown: A
            }
          ),
          /* @__PURE__ */ e(
            Re,
            {
              size: "sm",
              type: "submit",
              isLoading: $,
              isDisabled: ((G = C == null ? void 0 : C.trim()) == null ? void 0 : G.length) === 0,
              width: "auto",
              h: "10",
              label: t,
              display: "flex",
              py: 2,
              px: 5,
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              gap: 2,
              ml: 1.5,
              onClick: k,
              sx: {
                ...D.useCustomButtonStyle ? {
                  background: "var(--button-active-bg)",
                  color: "var(--button-active-text)"
                } : {},
                "&:hover, &:disabled": {
                  bgImage: "none",
                  border: "1px solid var(--border, #E0E0E0)",
                  background: "var(--bg-secondary, #F7F7F7)",
                  color: "var(--text, #1C1C1C)"
                },
                "&:disable": {
                  cursor: "default"
                },
                border: "1px solid transparent",
                fontWeight: "medium",
                lineHeight: "6",
                fontSize: "xs"
              },
              trackingId: "discount-apply-button"
            }
          )
        ]
      }
    ),
    d && /* @__PURE__ */ e(
      p,
      {
        fontSize: "xs",
        fontWeight: "normal",
        zIndex: "5",
        w: "full",
        sx: {
          position: "relative",
          color: "#FFF",
          bg: "danger.main",
          borderRadius: "1.875rem",
          py: "0.375rem",
          px: "0.75rem",
          alignItems: "center",
          gap: "1"
        },
        children: d
      }
    ),
    /* @__PURE__ */ l(se, { pt: 2, children: [
      S != null && S.length ? S.map((z) => /* @__PURE__ */ e(
        Qn,
        {
          giftCard: z,
          onGiftCardRemove: c,
          currency: F
        },
        z.id || z.code
      )) : null,
      b != null && b.length ? b.filter((z) => !f.some(
        (R) => z.code == R.code
      )).filter((z) => {
        var R, V, O;
        return !((O = (V = (R = z.code) == null ? void 0 : R.toLowerCase) == null ? void 0 : V.call(R)) != null && O.includes(" discount "));
      }).map((z) => /* @__PURE__ */ e(
        Zn,
        {
          discount: z,
          onDiscountRemove: s,
          currency: F
        },
        z.id || z.code
      )) : null
    ] }),
    f != null && f.length ? /* @__PURE__ */ e(
      u,
      {
        mt: 2,
        px: 3,
        py: 3,
        bg: "var(--bg, #FFFFFF)",
        border: "1px solid var(--border, #E0E0E0)",
        borderRadius: "0.75rem",
        children: h ? /* @__PURE__ */ l(U, { alignItems: "center", gap: 2.5, children: [
          /* @__PURE__ */ e(
            U,
            {
              flexShrink: 0,
              w: "20px",
              h: "20px",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "full",
              bg: "var(--savings, #15803D)",
              children: /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, fill: "none", children: /* @__PURE__ */ e(
                "path",
                {
                  d: "M2.5 6.5 5 9l4.5-5",
                  stroke: "#FFFFFF",
                  strokeWidth: 1.6,
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }
              ) })
            }
          ),
          /* @__PURE__ */ e(
            p,
            {
              flex: "1",
              fontSize: "xs",
              fontWeight: "500",
              lineHeight: "1.4",
              color: "var(--text, #1C1C1C)",
              children: h.appliedLabel
            }
          ),
          /* @__PURE__ */ e(
            U,
            {
              as: "button",
              type: "button",
              onClick: () => s(h.code),
              "aria-label": "Remove",
              flexShrink: 0,
              alignItems: "center",
              justifyContent: "center",
              p: 1,
              color: "var(--text-muted, #8F8F8F)",
              children: /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", children: [
                /* @__PURE__ */ e("title", { children: "Remove" }),
                /* @__PURE__ */ e(
                  "path",
                  {
                    d: "M12 4 4 12M4 4l8 8",
                    stroke: "currentColor",
                    strokeWidth: 1.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                  }
                )
              ] })
            }
          )
        ] }) : /* @__PURE__ */ l(le, { children: [
          /* @__PURE__ */ e(
            p,
            {
              className: "leaf-card__title",
              fontSize: "xs",
              fontWeight: "600",
              lineHeight: "1.4",
              color: "var(--text, #1C1C1C)",
              children: _
            }
          ),
          /* @__PURE__ */ e(se, { pt: 2.5, spacing: 2.5, children: f.map((z) => /* @__PURE__ */ e(
            ea,
            {
              appliedDiscounts: b ?? [],
              discountApplyLabel: t,
              discount: z,
              onDiscountRemove: s,
              onDiscountAddClick: n,
              currency: F
            },
            z.code
          )) })
        ] })
      }
    ) : null
  ] });
}, mt = ({ boxSize: t = "4.5rem", borderRadius: r = "md", background: a, ...o }) => {
  const [n, d] = P(!0);
  return /* @__PURE__ */ l(u, { boxSize: t, borderRadius: r, background: a, flexShrink: 0, children: [
    /* @__PURE__ */ e(
      Oe,
      {
        width: "full",
        height: "full",
        borderRadius: r,
        display: n ? "block" : "none",
        visibility: n ? "visible" : "hidden"
      }
    ),
    /* @__PURE__ */ e(
      Fe,
      {
        ...o,
        w: "full",
        h: "full",
        loading: "lazy",
        borderRadius: r,
        opacity: n ? 0 : 1,
        onLoad: () => d(!1),
        transition: "opacity 0.3s ease-in-out",
        visibility: n ? "hidden" : "visible"
      }
    )
  ] });
}, ta = ({ components: t, showItemsLabel: r, hideItemsLabel: a }) => {
  const [o, n] = P(!1);
  if (t.length === 0)
    return null;
  const d = t.length;
  return /* @__PURE__ */ l(u, { w: "full", children: [
    /* @__PURE__ */ l(
      J,
      {
        as: "button",
        type: "button",
        onClick: () => n((s) => !s),
        "aria-expanded": o,
        spacing: 1,
        bg: "transparent",
        border: "none",
        p: 0,
        cursor: "pointer",
        children: [
          /* @__PURE__ */ e(p, { fontSize: "0.6875rem", color: "var(--text-secondary, #585858)", children: o ? a(d) : r(d) }),
          /* @__PURE__ */ e(
            u,
            {
              as: "svg",
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              transform: o ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 300ms cubic-bezier(0.32, 0.72, 0, 1)",
              children: /* @__PURE__ */ e(
                "path",
                {
                  d: "M2.5 4.5L6 8L9.5 4.5",
                  stroke: "var(--text-secondary, #585858)",
                  strokeWidth: "1.5",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e(We, { initial: !1, children: o && /* @__PURE__ */ e(
      Se.div,
      {
        initial: { height: 0, opacity: 0 },
        animate: { height: "auto", opacity: 1 },
        exit: { height: 0, opacity: 0 },
        transition: { duration: 0.3, ease: [0.32, 0.72, 0, 1] },
        style: { overflow: "hidden" },
        children: /* @__PURE__ */ e(ne, { align: "start", spacing: 2, pl: 2, pt: 2, children: t.map((s, c) => /* @__PURE__ */ l(J, { align: "center", spacing: 3, w: "full", children: [
          /* @__PURE__ */ e(
            u,
            {
              w: "2rem",
              h: "2rem",
              borderRadius: "0.375rem",
              overflow: "hidden",
              bg: "var(--bg-secondary, #F7F7F7)",
              flexShrink: 0,
              children: s.imageUrl && /* @__PURE__ */ e(
                Fe,
                {
                  src: s.imageUrl,
                  alt: s.name,
                  w: "full",
                  h: "full",
                  objectFit: "cover"
                }
              )
            }
          ),
          /* @__PURE__ */ l(ne, { align: "start", spacing: 0, children: [
            /* @__PURE__ */ e(p, { fontSize: "0.6875rem", color: "var(--text-secondary, #585858)", children: `${s.quantity} × ${s.name}` }),
            s.variants.length > 0 && /* @__PURE__ */ e(p, { fontSize: "0.625rem", color: "var(--text-muted, #8F8F8F)", children: s.variants.join(" / ") })
          ] })
        ] }, `${s.name}-${c}`)) })
      }
    ) })
  ] });
}, $t = ({
  customAttributes: t,
  discountAmount: r,
  imageUrl: a,
  name: o,
  quantity: n,
  quantityAvailable: d,
  variant: s,
  isAvailable: c,
  isQuantityDisabled: b,
  isStockDisabled: S,
  currency: F,
  originalAmount: g,
  leftQuantityTitle: _,
  leftQuantityShortTitle: f,
  quantityLabel: m,
  onEditQuantity: y,
  isMobile: C,
  unitAmount: E,
  totalAmount: x,
  isLoading: $ = !1,
  components: j,
  showBundleItemsLabel: H,
  hideBundleItemsLabel: D,
  dense: k = !1
}) => {
  const A = Z(
    () => ({
      // Match the surrounding surface so the badge looks “cut out” regardless of theme.
      badgeBorderColor: "var(--badge-border-bg, #E0E0E0)",
      badgeBg: "var(--badge-quantity-bg, linear-gradient(90deg, #8DE690 2.08%, #A5F0A3 18.23%, #A6ECD7 33.33%, #97DADA 51.56%, #B3DAE7 67.71%, #B6C9EC 83.33%, #879ACB 100%))",
      badgeTextColor: "var(--badge-quantity-text, #1C1C1C)",
      primaryTextColor: "var(--text, #1C1C1C)",
      textColor: "var(--text-secondary, #585858)",
      mutedTextColor: "var(--text-muted, #8F8F8F)",
      savingsColor: "var(--savings, #15803D)"
    }),
    []
  ), h = !S && d !== void 0 && d >= 0 && d < 11, G = h && (d ?? 0) >= 1, z = C && G && f ? /* @__PURE__ */ e(
    ht,
    {
      position: "absolute",
      bottom: 0,
      left: "50%",
      transform: "translate(-50%, 50%)",
      zIndex: 2,
      variant: "solid",
      textTransform: "none",
      fontSize: "2xs",
      fontWeight: "semibold",
      letterSpacing: "0",
      lineHeight: "1.2",
      px: 2,
      py: 0.5,
      borderRadius: "full",
      color: "white",
      bg: "var(--danger, #EE5829)",
      boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)",
      whiteSpace: "nowrap",
      "aria-description": "lowStock",
      children: f
    }
  ) : null, R = g && g !== 0 && g !== E, V = R ? vt(g).multiply(n).value : x, O = r ? vt(x).subtract(Math.abs(r)).value : x, i = O !== x || R, v = Z(() => {
    const w = new RegExp(
      /https?:\/\/(www.)?[-a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
    );
    return (t == null ? void 0 : t.map(({ key: B, value: W }) => {
      let N = W ?? "";
      return N.match(w) && (N = "Uploaded"), {
        key: B,
        value: N
      };
    })) ?? [];
  }, [t]);
  return /* @__PURE__ */ l(
    J,
    {
      align: C ? "flex-start" : "center",
      justifyContent: "space-between",
      spacing: 2,
      opacity: c ? 1 : 0.4,
      w: "full",
      position: "relative",
      pb: z ? 2.5 : 0,
      children: [
        b && /* @__PURE__ */ e(
          ht,
          {
            position: "absolute",
            top: "-0.5rem",
            left: "0",
            ml: "4rem",
            width: "1.3rem",
            height: "1.3rem",
            borderRadius: "full",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid",
            zIndex: 10,
            borderColor: A.badgeBorderColor,
            bg: A.badgeBg,
            children: /* @__PURE__ */ e(
              p,
              {
                "aria-description": "badgeProductQuantity",
                color: A.badgeTextColor,
                textAlign: "center",
                fontFamily: "IBM Plex Mono",
                fontSize: "xs",
                fontStyle: "normal",
                fontWeight: "bold",
                lineHeight: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                w: "full",
                h: "full",
                opacity: $ ? 0.7 : 1,
                transition: "opacity 0.15s ease",
                children: n
              }
            )
          }
        ),
        /* @__PURE__ */ l(J, { flex: 1, minW: 0, gap: 3, align: "center", children: [
          /* @__PURE__ */ l(u, { position: "relative", flexShrink: 0, children: [
            /* @__PURE__ */ e(
              mt,
              {
                boxSize: k ? "3.75rem" : "4rem",
                borderRadius: "lg",
                src: a,
                alt: o,
                objectFit: "cover",
                background: "lightgray 50% / cover no-repeat",
                boxShadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.05)"
              }
            ),
            z
          ] }),
          /* @__PURE__ */ l(ne, { align: "start", spacing: 1, flex: 1, minW: 0, children: [
            /* @__PURE__ */ e(
              p,
              {
                fontWeight: "medium",
                fontSize: C || k ? "xs" : "sm",
                lineHeight: "short",
                letterSpacing: "-0.01em",
                color: A.primaryTextColor,
                "aria-description": "productName",
                children: o
              }
            ),
            !!(s != null && s.length) && // Full variant text on a single wrapping line — wraps naturally with
            // the same line-height as the name, so the spacing between wrapped
            // lines matches (a flex-wrap row added an extra row-gap before).
            /* @__PURE__ */ e(
              p,
              {
                w: "full",
                color: A.textColor,
                textAlign: "left",
                fontSize: "0.6875rem",
                fontWeight: "normal",
                lineHeight: "short",
                "aria-description": "variantNames",
                children: s == null ? void 0 : s.join(" · ")
              }
            ),
            h && !(C && G) && /* @__PURE__ */ e(
              p,
              {
                color: "danger.main",
                textAlign: "left",
                fontSize: "sm",
                fontWeight: "normal",
                lineHeight: "4",
                "aria-description": "lowStock",
                children: _
              }
            ),
            v != null && v.length ? v == null ? void 0 : v.map((w) => /* @__PURE__ */ l(
              p,
              {
                fontWeight: "normal",
                color: A.mutedTextColor,
                fontSize: "sm",
                lineHeight: "4",
                w: "full",
                overflow: "hidden",
                textOverflow: "ellipsis",
                style: {
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical"
                },
                children: [
                  w.key,
                  " - ",
                  w.value
                ]
              },
              w.key
            )) : null,
            j != null && j.length && H && D ? /* @__PURE__ */ e(
              ta,
              {
                components: j,
                showItemsLabel: H,
                hideItemsLabel: D
              }
            ) : null
          ] })
        ] }),
        /* @__PURE__ */ l(ne, { align: "flex-end", spacing: 0.5, flexShrink: 0, "aria-description": "lineItemPrice", children: [
          /* @__PURE__ */ e(
            p,
            {
              lineHeight: i ? "4" : "short",
              letterSpacing: "-0.01em",
              fontSize: i || C || k ? "xs" : "sm",
              color: i ? A.mutedTextColor : A.primaryTextColor,
              fontWeight: i ? "normal" : "medium",
              textDecorationLine: i ? "line-through" : "",
              "aria-description": "originalProductAmount",
              opacity: $ ? 0.7 : 1,
              transition: "opacity 0.15s ease",
              whiteSpace: "nowrap",
              children: oe(V, { currency: F ?? "EUR" })
            }
          ),
          i && /* @__PURE__ */ e(
            p,
            {
              color: A.savingsColor,
              lineHeight: "4",
              fontSize: C || k ? "xs" : "sm",
              fontWeight: "medium",
              "aria-description": "discountedProductAmount",
              opacity: $ ? 0.7 : 1,
              transition: "opacity 0.15s ease",
              whiteSpace: "nowrap",
              children: oe(O, { currency: F ?? "EUR" })
            }
          ),
          !b && y && /* @__PURE__ */ l(
            J,
            {
              as: "button",
              type: "button",
              onClick: y,
              mt: 2,
              spacing: 0.5,
              bg: "var(--bg-secondary, #F7F7F7)",
              borderRadius: "md",
              pl: 2,
              pr: 1,
              py: 1,
              color: "var(--text, #1C1C1C)",
              transition: "opacity 150ms ease",
              _active: { opacity: 0.7 },
              "aria-haspopup": "dialog",
              "data-ph-capture-attribute-tracking-id": "cart-line-quantity",
              children: [
                /* @__PURE__ */ l(p, { fontSize: "0.6875rem", fontWeight: 500, lineHeight: 1, whiteSpace: "nowrap", children: [
                  m,
                  " ",
                  n
                ] }),
                /* @__PURE__ */ e(Nt, { boxSize: 3, color: "var(--text-muted, #8F8F8F)" })
              ]
            }
          )
        ] })
      ]
    }
  );
}, ra = ({ showQuantity: t = !0, loadingColor: r }) => /* @__PURE__ */ l(J, { spacing: 4, align: "start", w: "full", pb: 1, children: [
  /* @__PURE__ */ e(
    Oe,
    {
      width: "4.5rem",
      height: "4.5rem",
      borderRadius: "md",
      flexShrink: 0,
      startColor: r,
      endColor: "var(--border, #E0E0E0)"
    }
  ),
  /* @__PURE__ */ e(u, { flex: "1", py: "0.125rem", children: /* @__PURE__ */ e(
    Oe,
    {
      height: t ? "4.25rem" : "2.5rem",
      width: "100%",
      borderRadius: "md",
      startColor: r,
      endColor: "var(--border, #E0E0E0)"
    }
  ) })
] }), oa = ({
  totalDiscount: t,
  subTotal: r,
  shipping: a,
  tax: o,
  giftWrapping: n,
  totalGiftCard: d,
  totalDuties: s,
  totalSale: c,
  discounts: b,
  currency: S,
  isMobile: F,
  isLoading: g,
  dense: _ = !1
}) => {
  const f = g ? 0.7 : 1, m = "opacity 0.15s ease", y = "var(--text-secondary, #585858)", C = "var(--text, #1C1C1C)", E = "var(--savings, #15803D)", x = F ? 1 : _ ? 0.375 : 0.5, $ = F ? "sm" : _ ? "xs" : "sm", j = (b ?? []).filter((H) => !!H.code);
  return /* @__PURE__ */ l(u, { fontSize: $, children: [
    /* @__PURE__ */ l(
      U,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: x,
        "aria-description": "subtotalDiv",
        children: [
          /* @__PURE__ */ e(p, { fontWeight: "normal", lineHeight: "6", color: y, children: r.label }),
          /* @__PURE__ */ e(p, { lineHeight: "6", color: C, opacity: f, transition: m, children: r.value })
        ]
      }
    ),
    (a == null ? void 0 : a.value) && /* @__PURE__ */ l(
      U,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: x,
        "aria-description": "shippingDiv",
        children: [
          /* @__PURE__ */ e(p, { lineHeight: "6", color: y, children: a.label }),
          /* @__PURE__ */ e(p, { lineHeight: "6", color: C, opacity: f, transition: m, children: a.value })
        ]
      }
    ),
    (c == null ? void 0 : c.value) && /* @__PURE__ */ l(
      U,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: x,
        "aria-description": "totalSaleDiv",
        children: [
          /* @__PURE__ */ e(p, { lineHeight: "6", color: y, children: c.label }),
          /* @__PURE__ */ l(p, { lineHeight: "6", color: E, opacity: f, transition: m, children: [
            "-",
            c.value
          ] })
        ]
      }
    ),
    (t == null ? void 0 : t.value) && (j.length > 0 ? (
      // Shopify-style breakdown: label as a header, one row per code with
      // its own amount.
      /* @__PURE__ */ l(u, { py: x, "aria-description": "totalDiscountDiv", children: [
        /* @__PURE__ */ e(p, { lineHeight: "6", color: y, children: t.label }),
        j.map((H) => {
          const D = j.length === 1 && t.value ? `-${t.value}` : H.amount ? `-${oe(H.amount, { currency: S ?? "EUR" })}` : H.title ? `−${H.title}` : null;
          return /* @__PURE__ */ l(U, { justifyContent: "space-between", alignItems: "center", children: [
            /* @__PURE__ */ l(J, { spacing: 1, color: E, minW: 0, children: [
              /* @__PURE__ */ e(u, { as: "span", display: "inline-flex", flexShrink: 0, children: /* @__PURE__ */ e(ut, { width: 14, height: 14 }) }),
              /* @__PURE__ */ e(p, { lineHeight: "6", noOfLines: 1, children: H.code })
            ] }),
            D ? /* @__PURE__ */ e(
              p,
              {
                lineHeight: "6",
                color: E,
                opacity: f,
                transition: m,
                flexShrink: 0,
                children: D
              }
            ) : null
          ] }, H.code);
        })
      ] })
    ) : /* @__PURE__ */ l(
      U,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: x,
        "aria-description": "totalDiscountDiv",
        children: [
          /* @__PURE__ */ e(p, { lineHeight: "6", color: y, children: t.label }),
          /* @__PURE__ */ l(p, { lineHeight: "6", color: E, opacity: f, transition: m, children: [
            "-",
            t.value
          ] })
        ]
      }
    )),
    (n == null ? void 0 : n.value) && /* @__PURE__ */ l(
      U,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: x,
        "aria-description": "giftWrappingDiv",
        children: [
          /* @__PURE__ */ e(p, { lineHeight: "6", color: y, children: n.label ?? "" }),
          /* @__PURE__ */ l(p, { lineHeight: "6", color: C, opacity: f, transition: m, children: [
            "-",
            n.value
          ] })
        ]
      }
    ),
    (o == null ? void 0 : o.value) && /* @__PURE__ */ l(U, { justifyContent: "space-between", alignItems: "center", py: x, "aria-description": "taxDiv", children: [
      /* @__PURE__ */ e(p, { lineHeight: "6", color: y, children: o.label }),
      /* @__PURE__ */ e(p, { lineHeight: "6", color: C, opacity: f, transition: m, children: o.value })
    ] }),
    (s == null ? void 0 : s.value) && /* @__PURE__ */ l(
      U,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: x,
        "aria-description": "totalDutiesDiv",
        children: [
          /* @__PURE__ */ e(p, { lineHeight: "6", color: y, children: s.label }),
          /* @__PURE__ */ e(p, { lineHeight: "6", color: C, opacity: f, transition: m, children: s.value })
        ]
      }
    ),
    (d == null ? void 0 : d.value) && /* @__PURE__ */ l(
      U,
      {
        justifyContent: "space-between",
        alignItems: "center",
        py: x,
        "aria-description": "totalGiftCardDiv",
        children: [
          /* @__PURE__ */ e(p, { lineHeight: "6", color: y, children: d.label }),
          /* @__PURE__ */ l(p, { lineHeight: "6", color: E, opacity: f, transition: m, children: [
            "-",
            d.value
          ] })
        ]
      }
    )
  ] });
}, na = ({ label: t, value: r, taxIncludedTitle: a, isMobile: o, flexOrder: n, isLoading: d, dense: s = !1 }) => {
  const c = o ? "md" : s ? "sm" : "md";
  return /* @__PURE__ */ l(u, { order: n, mt: s ? 1.5 : 2, children: [
    /* @__PURE__ */ l(U, { justifyContent: "space-between", alignItems: "center", "aria-description": "totalDiv", children: [
      /* @__PURE__ */ e(
        p,
        {
          color: "var(--text, #1C1C1C)",
          fontSize: c,
          fontWeight: "semibold",
          lineHeight: "6",
          letterSpacing: "-0.02em",
          children: t
        }
      ),
      /* @__PURE__ */ e(
        p,
        {
          color: "var(--text, #1C1C1C)",
          fontSize: c,
          fontWeight: "semibold",
          lineHeight: "6",
          letterSpacing: "-0.02em",
          opacity: d ? 0.7 : 1,
          transition: "opacity 0.15s ease",
          children: r
        }
      )
    ] }),
    a && /* @__PURE__ */ e(U, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ e(p, { color: "var(--text-muted, #8F8F8F)", fontSize: "xs", children: `(${a})` }) })
  ] });
}, ja = ({
  showEmailOnly: t = !1,
  discountCodeQuestion: r,
  addDiscountLabel: a,
  discountCodeDrawerTitle: o,
  products: n,
  currency: d,
  totalDiscount: s,
  totalDuties: c,
  totalSale: b,
  giftWrapping: S,
  subTotal: F,
  shipping: g,
  total: _,
  tax: f,
  discountApplyLabel: m,
  discountFinderLabel: y,
  discountInputLabel: C,
  totalGiftCard: E,
  isDiscountDisabled: x,
  isDiscountHidden: $,
  isQuantityDisabled: j,
  isStockDisabled: H = !1,
  onDiscountAddClick: D,
  onDiscountRemove: k,
  onGiftCardRemove: A,
  discountErrorLabel: h,
  discounts: G,
  giftCards: z,
  shouldFocusDiscountField: R,
  updateQuantity: V,
  taxIncludedTitle: O,
  leftQuantityTitles: ee,
  leftQuantityShortTitles: i,
  quantityLabel: v,
  onEditQuantity: w,
  Icon: B,
  availabilityMessage: W,
  outOfStockMessage: N = "",
  updatedCartInformation: I,
  corrections: te,
  isMobile: ae,
  setDiscountValue: re,
  recommendedDiscounts: we,
  renderBeforeDiscounts: T,
  isItemLoading: K,
  isAnyItemLoading: ce,
  renderAfterProducts: Ee,
  pendingProducts: Te,
  showBundleItemsLabel: Ie,
  hideBundleItemsLabel: _e,
  hideProducts: ye = !1,
  dense: ie = !1,
  ...Ae
}) => {
  const { isOpen: Pe, onOpen: Ne, onClose: Qt } = On(), er = ie ? "0.5rem" : "0.625rem", tr = ie ? "0.5rem" : "0.625rem";
  return /* @__PURE__ */ l(se, { ...Ae, w: "full", children: [
    !ye && /* @__PURE__ */ l(
      ne,
      {
        order: t ? 1 : void 0,
        gap: 0,
        align: "start",
        className: "cart__product-list",
        pt: "2",
        children: [
          /* @__PURE__ */ l(We, { initial: !1, mode: "sync", children: [
            Array.from({ length: Te ?? 0 }, (q, De) => /* @__PURE__ */ e(
              Se.div,
              {
                initial: { opacity: 0, height: 0, paddingTop: 0, marginBottom: 0 },
                animate: {
                  opacity: 1,
                  height: "auto",
                  paddingTop: "0.5rem",
                  marginBottom: "0.75rem"
                },
                exit: { opacity: 0, height: 0, paddingTop: 0, marginBottom: 0, transition: { duration: 0 } },
                transition: {
                  height: { duration: 0.3, ease: "easeInOut" },
                  paddingTop: { duration: 0.3, ease: "easeInOut" },
                  marginBottom: { duration: 0.3, ease: "easeInOut" },
                  opacity: { duration: 0.2, delay: 0.15, ease: "easeOut" }
                },
                style: { overflow: "hidden", width: "100%" },
                children: /* @__PURE__ */ e(ra, {})
              },
              `pending-${De}`
            )),
            n.map((q, De) => /* @__PURE__ */ e(
              Se.div,
              {
                initial: { opacity: 0 },
                animate: { opacity: 1 },
                exit: { opacity: 0, height: 0, paddingTop: 0, marginBottom: 0 },
                transition: {
                  opacity: { duration: 0.2, ease: "easeOut" },
                  height: { duration: 0.3, delay: 0.15, ease: "easeInOut" },
                  paddingTop: { duration: 0.3, delay: 0.15, ease: "easeInOut" },
                  marginBottom: { duration: 0.3, delay: 0.15, ease: "easeInOut" }
                },
                style: {
                  overflow: "hidden",
                  width: "100%",
                  paddingTop: er,
                  marginBottom: tr
                },
                children: /* @__PURE__ */ e(
                  $t,
                  {
                    ...q,
                    showBundleItemsLabel: Ie,
                    hideBundleItemsLabel: _e,
                    currency: (q == null ? void 0 : q.currency) ?? d ?? "EUR",
                    isQuantityDisabled: j,
                    isStockDisabled: H,
                    isLoading: K == null ? void 0 : K(q.id),
                    isCartBusy: ce,
                    updateQuantity: V,
                    totalAmount: q.totalAmount,
                    unitAmount: q.unitAmount,
                    discountAmount: q.discountAmount,
                    leftQuantityTitle: ee[De] || "",
                    leftQuantityShortTitle: (i == null ? void 0 : i[De]) || "",
                    quantityLabel: v,
                    onEditQuantity: () => w == null ? void 0 : w(q.id),
                    quantityAvailable: q.quantityAvailable ?? 99,
                    onlyOneLineItemInCart: n.length === 1,
                    isMobile: ae,
                    dense: ie
                  }
                )
              },
              q.id
            ))
          ] }),
          Ee && /* @__PURE__ */ e("div", { style: { marginBottom: "0.75rem", width: "100%" }, children: Ee }),
          te == null ? void 0 : te.map(
            (q) => q.reason === "outOfStock" && /* @__PURE__ */ e("div", { style: { marginBottom: "0.75rem", width: "100%" }, children: /* @__PURE__ */ e(
              $t,
              {
                name: q.name,
                id: "",
                imageUrl: q.imageUrl,
                productId: q.productId,
                quantity: q.quantity,
                currency: q.currency ?? d ?? "EUR",
                totalAmount: q.totalAmount,
                isQuantityDisabled: !1,
                isQuantityUpdateDisabled: !0,
                updateQuantity: V,
                discountAmount: 0,
                totalDiscount: s,
                leftQuantityTitle: N,
                quantityAvailable: 0,
                unitAmount: q.unitAmount,
                isMobile: ae,
                dense: ie
              }
            ) }, q.productId)
          )
        ]
      }
    ),
    I && /* @__PURE__ */ e(p, { order: t ? 6 : void 0, color: "danger.main", fontSize: "md", children: I }),
    W && /* @__PURE__ */ e(p, { order: t ? 7 : void 0, color: "danger.main", fontSize: "sm", children: W }),
    !ye && /* @__PURE__ */ e(
      ve,
      {
        order: t ? 2 : void 0,
        variant: "solid",
        py: "0",
        my: t ? "6" : "0"
      }
    ),
    /* @__PURE__ */ e(se, { order: t ? 3 : void 0, w: "full", py: "0", children: /* @__PURE__ */ e(
      oa,
      {
        giftWrapping: S,
        tax: f,
        totalGiftCard: E,
        totalDiscount: s,
        totalDuties: c,
        subTotal: F,
        shipping: g,
        isMobile: ae,
        totalSale: b,
        discounts: G,
        currency: d,
        isLoading: ce,
        dense: ie
      }
    ) }),
    /* @__PURE__ */ e(
      na,
      {
        flexOrder: t ? 4 : void 0,
        value: _.value,
        label: _.label,
        isMobile: ae,
        taxIncludedTitle: O,
        isLoading: ce,
        dense: ie
      }
    ),
    T,
    t ? /* @__PURE__ */ l(ne, { order: 5, children: [
      /* @__PURE__ */ e(ve, { mt: "2" }),
      /* @__PURE__ */ l(J, { mt: "1.5", justify: "space-between", align: "center", w: "full", onClick: Ne, children: [
        /* @__PURE__ */ e(p, { fontSize: "md", color: "var(--text-secondary)", children: r }),
        /* @__PURE__ */ e(fe, { onClick: Ne, "data-ph-capture-attribute-tracking-id": "discount-code-add-button", children: a })
      ] })
    ] }) : /* @__PURE__ */ e(
      Ut,
      {
        discountApplyLabel: m,
        discountFinderLabel: y,
        discountInputLabel: C,
        discountErrorLabel: h,
        recommendedDiscounts: we,
        discounts: G,
        giftCards: z,
        onDiscountAddClick: D,
        onDiscountRemove: k,
        onGiftCardRemove: A,
        isDiscountDisabled: !!x,
        isDiscountHidden: !!$,
        shouldFocusField: !!R,
        currency: d,
        Icon: B,
        setDiscountValue: re
      }
    ),
    t && /* @__PURE__ */ e(
      Vn,
      {
        isOpen: Pe,
        onOpen: Ne,
        onClose: Qt,
        title: o,
        position: "bottom",
        containerRef: void 0,
        size: "unset",
        children: /* @__PURE__ */ e(se, { my: "2", px: "4", children: /* @__PURE__ */ e(
          Ut,
          {
            discountApplyLabel: m,
            discountFinderLabel: y,
            discountInputLabel: C,
            discountErrorLabel: h,
            recommendedDiscounts: we,
            discounts: G,
            giftCards: z,
            onDiscountAddClick: D,
            onDiscountRemove: k,
            onGiftCardRemove: A,
            isDiscountDisabled: !!x,
            isDiscountHidden: !!$,
            shouldFocusField: !!R,
            currency: d,
            Icon: B,
            setDiscountValue: re
          }
        ) })
      }
    )
  ] });
}, Zt = $e(
  ({
    label: t,
    helper: r,
    error: a,
    isInvalid: o,
    isDisabled: n,
    isRequired: d = !0,
    value: s,
    trackingId: c,
    onChange: b,
    onFocus: S,
    variant: F,
    onBlur: g,
    ..._
  }, f) => {
    const [m, y] = P(!1), [C, E] = P(!!a), x = tt(), { themeName: $ } = de(), j = $ === "classic", H = $ === "custom", D = {
      bgGradient: "",
      bg: "var(--input-focus-border, #BEBBB4)",
      p: "1px"
    }, k = Z(() => {
      const h = x == null ? void 0 : x.themedClasses;
      return {
        inputBorderStyle: (h == null ? void 0 : h.inputBorderStyle) ?? ot,
        inputBorderGradientStyle: (h == null ? void 0 : h.inputBorderGradientStyle) ?? nt,
        inputBorderDisabledStyle: (h == null ? void 0 : h.inputBorderDisabledStyle) ?? lt,
        inputBorderInvalidStyle: (h == null ? void 0 : h.inputBorderInvalidStyle) ?? at,
        inputBorderEmptyStyle: (h == null ? void 0 : h.inputBorderEmptyStyle) ?? it,
        inputBackgroundGradientStyle: (h == null ? void 0 : h.inputBackgroundGradientStyle) ?? st,
        inputBackgroundDisabledStyle: (h == null ? void 0 : h.inputBackgroundDisabledStyle) ?? dt,
        inputBackgroundEmptyStyle: (h == null ? void 0 : h.inputBackgroundEmptyStyle) ?? ct,
        inputBackgroundInvalidStyle: (h == null ? void 0 : h.inputBackgroundInvalidStyle) ?? bt,
        inputBoxShadowGradientStyle: (h == null ? void 0 : h.inputBoxShadowGradientStyle) ?? pt
      };
    }, [x]), A = M(
      (h) => {
        b == null || b(h), E(!1);
      },
      [b, E]
    );
    return X(() => {
      E(!!a);
    }, [a, E]), /* @__PURE__ */ l(
      je,
      {
        variant: "floating",
        isRequired: d,
        isInvalid: !!o,
        isDisabled: !!n,
        width: "full",
        children: [
          /* @__PURE__ */ e(
            u,
            {
              _before: F !== "justUnstyled" && m && !C && !j && !H ? k.inputBoxShadowGradientStyle : {},
              children: /* @__PURE__ */ e(
                u,
                {
                  ...F !== "justUnstyled" ? {
                    ...k.inputBorderStyle,
                    ...k.inputBorderGradientStyle,
                    ...H ? D : {},
                    ...n ? k.inputBorderDisabledStyle : {},
                    ...!s && !m && !H ? k.inputBorderEmptyStyle : {},
                    ...C ? k.inputBorderInvalidStyle : {}
                  } : {},
                  children: /* @__PURE__ */ l(xe, { justifyContent: "center", alignItems: "center", alignContent: "center", alignSelf: "center", children: [
                    /* @__PURE__ */ e(
                      He,
                      {
                        w: "full",
                        variant: "just",
                        placeholder: " ",
                        height: 14,
                        fontSize: "md",
                        textAlign: "left",
                        borderLeftRadius: F === "justUnstyled" ? "0" : "",
                        borderRightRadius: F === "justUnstyled" ? "1.875rem" : "",
                        errorBorderColor: "danger.main",
                        ...k.inputBackgroundGradientStyle,
                        ...n ? k.inputBackgroundDisabledStyle : {},
                        ...s ? {} : k.inputBackgroundEmptyStyle,
                        ...C || o ? k.inputBackgroundInvalidStyle : {},
                        borderColor: n ? "gray.602" : "transparent",
                        border: "",
                        pr: 12,
                        pl: "5",
                        value: s,
                        onChange: A,
                        onFocus: (h) => {
                          y(!0), S == null || S(h);
                        },
                        onBlur: (h) => {
                          y(!1), g == null || g(h);
                        },
                        ..._,
                        ref: f,
                        _disabled: { cursor: "default" },
                        "data-ph-capture-attribute-tracking-id": c
                      }
                    ),
                    t && /* @__PURE__ */ e(
                      rt,
                      {
                        requiredIndicator: /* @__PURE__ */ e("abbr", { children: " *" }),
                        fontSize: "md",
                        bg: "transparent",
                        style: {
                          backgroundColor: "transparent",
                          zIndex: "20"
                        },
                        children: t
                      }
                    )
                  ] })
                }
              )
            }
          ),
          r && /* @__PURE__ */ e(Mt, { pl: "4", pb: "2", fontSize: "xs", children: r }),
          C && /* @__PURE__ */ e(
            Ue,
            {
              position: "absolute",
              fontSize: "0.75rem",
              fontWeight: "350",
              zIndex: "5",
              w: "fit-content",
              color: "danger.main",
              bg: "var(--input-bg-error-message, #FFF)",
              borderRadius: "0.25rem",
              bottom: "-2",
              right: "5",
              px: "1",
              mb: "0.5",
              children: a
            }
          )
        ]
      }
    );
  }
), Ha = ({ name: t, control: r, onChange: a, onBlur: o, ...n }) => /* @__PURE__ */ e(
  Yt,
  {
    control: r,
    name: t,
    render: ({ field: d }) => /* @__PURE__ */ e(
      Zt,
      {
        ...n,
        ...d,
        value: d.value ?? "",
        onChange: (s) => {
          d.onChange(s), a == null || a(s);
        },
        onBlur: () => {
          d.onBlur(), o == null || o();
        }
      }
    )
  }
), Ua = ({ isDisabled: t, children: r, ...a }) => /* @__PURE__ */ e(ze, { cursor: "pointer", size: "lg", colorScheme: "fullBlack", isDisabled: !!t, ...a, children: r }), aa = ({
  value: t,
  onChange: r,
  iconComponent: a,
  options: o,
  ...n
}) => /* @__PURE__ */ l(
  u,
  {
    position: "relative",
    width: 24,
    className: "countrySelect",
    "data-ph-capture-attribute-tracking-id": "phone-number-country-select",
    children: [
      /* @__PURE__ */ e(u, { display: "flex", alignItems: "center", height: "100%", ml: 4, children: /* @__PURE__ */ e(a, { country: t ?? "", label: t ?? "" }) }),
      /* @__PURE__ */ e(
        rr,
        {
          variant: "unstyled",
          position: "absolute",
          p: 0,
          top: 0,
          right: "0",
          display: "block",
          zIndex: 1,
          opacity: 0,
          _disabled: { opacity: 0, cursor: "not-allowed" },
          cursor: "pointer",
          value: t,
          mt: 4,
          onChange: (d) => r(d.target.value || void 0),
          "aria-label": "Phone number country",
          ...n,
          children: o.map(({ label: d, value: s }) => /* @__PURE__ */ e("option", { value: s, children: d }, s ?? "ZZ"))
        }
      )
    ]
  }
), ia = {
  // apply Input Theme style
  ".isDisabled": {
    borderColor: "gray.602",
    color: "gray.603 !important",
    bg: "var(--input-bg-disabled, #FFF) !important"
  },
  ".isInvalid": {
    borderColor: "danger.main !important",
    background: "var(--input-bg-invalid, #FFF)"
  },
  ".PhoneInput:hover:not(.isDisabled) .countrySelect": {
    borderTop: 0,
    borderBottom: 0,
    borderLeft: 0
  },
  ".chakra-select__wrapper": {
    top: "-3px"
  }
}, $a = $e(
  ({
    label: t,
    error: r,
    value: a,
    onChange: o,
    onFocus: n,
    defaultCountry: d,
    isRequired: s = !1,
    autoComplete: c = "on",
    ...b
  }, S) => {
    const F = (x) => {
      o == null || o(x);
    }, [g, _] = P(!1), { themeName: f } = de(), m = f === "classic", y = Z(
      () => ({
        // Base border style
        inputBorderStyle: {
          p: "1px",
          borderRadius: "1.875rem"
        },
        // Border states
        inputBorderGradientStyle: {
          background: "var(--input-border-filled)"
        },
        inputBorderInvalidStyle: {
          background: "var(--input-border-invalid) !important"
        },
        inputBorderEmptyStyle: {
          background: "var(--input-border-empty) !important"
        },
        inputBorderDisabledStyle: {
          background: "var(--input-border-disabled) !important"
        },
        // Background states
        inputBackgroundGradientStyle: {
          background: "var(--input-bg-filled) !important",
          backdropFilter: "var(--input-backdrop-filter, none)",
          WebkitBackdropFilter: "var(--input-backdrop-filter, none)",
          boxShadow: "var(--input-box-shadow-filled, none)"
        },
        inputBackgroundDisabledStyle: {
          background: "var(--input-bg-disabled) !important"
        },
        inputBackgroundEmptyStyle: {
          background: "var(--input-bg-empty)"
        },
        inputBackgroundInvalidStyle: {
          background: "var(--input-bg-invalid)"
        },
        // Focus box shadow
        inputBoxShadowGradientStyle: {
          borderRadius: "1.875rem",
          filter: "var(--input-focus-blur, blur(4px))",
          content: '""',
          position: "absolute",
          top: "-1px",
          right: "-1px",
          bottom: "-1px",
          left: "-1px",
          background: "var(--input-focus-shadow-bg, var(--input-border-filled))",
          bgClip: "border-box"
        }
      }),
      []
    );
    return /* @__PURE__ */ l(u, { position: "relative", children: [
      /* @__PURE__ */ e(u, { _before: { ...g && !m ? y.inputBoxShadowGradientStyle : {} }, children: /* @__PURE__ */ e(
        u,
        {
          ...y.inputBorderStyle,
          ...y.inputBorderGradientStyle,
          ...b.isDisabled ? y.inputBorderDisabledStyle : {},
          ...!a && !g ? y.inputBorderEmptyStyle : {},
          ...r ? y.inputBorderInvalidStyle : {},
          children: /* @__PURE__ */ e(u, { bg: "var(--input-bg, #FFF)", borderRadius: "1.875rem", children: /* @__PURE__ */ e(
            u,
            {
              __css: {
                ...ia,
                ".PhoneInput": {
                  borderRadius: "1.875rem",
                  ...y.inputBackgroundGradientStyle,
                  ...b.isDisabled ? y.inputBackgroundDisabledStyle : {},
                  ...!a && !g ? y.inputBackgroundEmptyStyle : {},
                  ...r ? y.inputBackgroundInvalidStyle : {},
                  ...g ? y.inputBackgroundInvalidStyle : {}
                },
                // custom flag icon
                ".PhoneInputCountryIcon--border": {
                  ...y.inputBackgroundGradientStyle,
                  ...b.isDisabled ? y.inputBackgroundDisabledStyle : {},
                  ...!a && !g ? y.inputBackgroundEmptyStyle : {},
                  ...r ? y.inputBackgroundInvalidStyle : {},
                  ...g ? y.inputBackgroundInvalidStyle : {},
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "none",
                  borderRadius: "2px",
                  overflow: "hidden"
                },
                // custom country select
                ".PhoneInput .countrySelect": {
                  borderLeftRadius: "1.875rem",
                  background: g ? "var(--input-bg, #FFF)" : "",
                  color: "var(--text, #1C1C1C)"
                }
              },
              children: /* @__PURE__ */ e(
                kr,
                {
                  className: `${b.isInvalid ? "isInvalid" : ""} ${b.isDisabled ? "isDisabled" : ""}`,
                  style: {
                    alignItems: "stretch",
                    backgroundColor: r || b.isInvalid ? "danger.main !important" : b.isDisabled || !a ? "var(--input-bg-disabled, #FFF) !important" : ""
                  },
                  defaultCountry: d ?? "FR",
                  value: a ?? "",
                  ref: S ?? void 0,
                  onChange: F,
                  onFocus: (x) => {
                    _(!0), n == null || n(x);
                  },
                  onBlur: () => {
                    _(!1);
                  },
                  label: t,
                  isRequired: s,
                  variant: "justUnstyled",
                  inputComponent: Zt,
                  disabled: !!b.isDisabled,
                  autoComplete: c,
                  countrySelectComponent: aa,
                  ...b
                }
              )
            }
          ) })
        }
      ) }),
      r && /* @__PURE__ */ e(je, { isInvalid: !!b.isInvalid, children: /* @__PURE__ */ e(
        Ue,
        {
          position: "absolute",
          fontSize: "0.625rem",
          fontWeight: "350",
          color: "danger.main",
          borderRadius: "0.25rem",
          bg: "var(--input-bg-error-message, #FFF)",
          bottom: "-2",
          right: "5",
          px: "1",
          mb: "0.5",
          zIndex: "5",
          children: r
        }
      ) })
    ] });
  }
), Ra = ({
  trackingId: t,
  placeholder: r,
  label: a,
  isDisabled: o,
  subtitle: n,
  onClick: d,
  reverse: s,
  isInvalid: c = !1,
  error: b,
  Icon: S,
  variant: F,
  PlaceholderDropdownAriaDescription: g,
  id: _
}) => {
  const f = Z(
    () => ({
      // Base border style
      inputBorderStyle: {
        p: "1px",
        borderRadius: "1.875rem"
      },
      // Border states
      inputBorderGradientStyle: {
        background: "var(--input-border-filled)"
      },
      inputBorderInvalidStyle: {
        background: "var(--input-border-invalid) !important"
      },
      inputBorderEmptyStyle: {
        background: "var(--input-border-empty) !important"
      },
      inputBorderDisabledStyle: {
        background: "var(--input-border-disabled) !important"
      },
      // Background states
      inputBackgroundGradientStyle: {
        background: "var(--input-bg-filled) !important",
        backdropFilter: "var(--input-backdrop-filter, none)",
        WebkitBackdropFilter: "var(--input-backdrop-filter, none)",
        boxShadow: "var(--input-box-shadow-filled, none)"
      },
      inputBackgroundDisabledStyle: {
        background: "var(--input-bg-disabled) !important"
      },
      inputBackgroundEmptyStyle: {
        background: "var(--input-bg-empty)"
      },
      inputBackgroundInvalidStyle: {
        background: "var(--input-bg-invalid)"
      }
    }),
    []
  ), m = "var(--input-disabled-bg-variant, #F7F7F7)", y = "var(--text, #1C1C1C)";
  return /* @__PURE__ */ e(
    u,
    {
      ...f.inputBorderStyle,
      ...a ? f.inputBorderGradientStyle : {},
      ...o ? f.inputBorderDisabledStyle : {},
      ...a ? {} : f.inputBorderEmptyStyle,
      ...b || c ? f.inputBorderInvalidStyle : {},
      onClick: () => !o && (d == null ? void 0 : d()),
      id: _,
      "aria-description": g,
      "data-ph-capture-attribute-tracking-id": t,
      children: /* @__PURE__ */ l(
        u,
        {
          w: "full",
          height: 14,
          display: "flex",
          px: 4,
          fontSize: "md",
          borderRadius: "1.875rem",
          cursor: o ? "default" : "pointer",
          ...f.inputBackgroundGradientStyle,
          ...o ? f.inputBackgroundDisabledStyle : {},
          ...!a && !o ? f.inputBackgroundEmptyStyle : {},
          ...b || c ? f.inputBackgroundInvalidStyle : {},
          borderColor: o ? "gray.602" : "transparent",
          bgColor: o ? "var(--input-bg-disabled, #ffffff)" : "var(--input-bg, white)",
          position: "relative",
          alignItems: "center",
          sx: F === "disabledAddresses" ? {
            background: `${m} !important`
          } : {},
          children: [
            /* @__PURE__ */ e(u, { mr: "2", boxSize: "2rem", children: S && /* @__PURE__ */ e(
              S,
              {
                fill: F === "disabledAddresses" ? "#8F8F8F" : a ? y : "var(--text-secondary, #585858)",
                alt: "placeholderDropdown icon"
              }
            ) }),
            r && !a && /* @__PURE__ */ e(p, { fontSize: "md", fontWeight: "normal", color: "gray.603", children: r }),
            a && /* @__PURE__ */ l(U, { direction: s ? "column-reverse" : "column", ml: "2", children: [
              /* @__PURE__ */ e(p, { noOfLines: 1, fontSize: "md", fontWeight: "normal", lineHeight: "24px", color: y, children: a }),
              n && /* @__PURE__ */ e(p, { noOfLines: 1, fontSize: "11px", fontWeight: "normal", lineHeight: "16px", color: y, children: n })
            ] })
          ]
        }
      )
    }
  );
}, la = (t) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...t,
    children: [
      /* @__PURE__ */ e("path", { d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" }),
      /* @__PURE__ */ e("path", { d: "m15 5 4 4" })
    ]
  }
), Ga = ({
  placeholder: t,
  label: r,
  isDisabled: a,
  subtitle: o,
  onClick: n,
  reverse: d,
  Icon: s,
  cardBrand: c
}) => /* @__PURE__ */ l(
  Ge,
  {
    onClick: () => !a && (n == null ? void 0 : n()),
    w: "full",
    height: "3.5rem",
    display: "flex",
    px: 4,
    py: 3,
    fontSize: "md",
    borderRadius: "0.875rem",
    cursor: a ? "not-allowed" : "pointer",
    position: "relative",
    alignItems: "center",
    variant: "gradient",
    children: [
      c && s && /* @__PURE__ */ l(J, { spacing: "4", children: [
        /* @__PURE__ */ e(s, { brand: c }),
        /* @__PURE__ */ l(ne, { align: "baseline", spacing: -4, children: [
          r && /* @__PURE__ */ e(
            p,
            {
              color: "var(--text, #1C1C1C)",
              fontSize: "md",
              fontStyle: "normal",
              fontWeight: "350",
              lineHeight: "6",
              children: r
            }
          ),
          o && /* @__PURE__ */ e(
            p,
            {
              fontWeight: "medium",
              color: "var(--text-secondary, #585858)",
              fontSize: "xs",
              fontStyle: "normal",
              lineHeight: "4",
              children: o
            }
          )
        ] }),
        /* @__PURE__ */ e(
          u,
          {
            position: "absolute",
            top: "50%",
            right: "4",
            transform: "translateY(-50%)",
            color: "var(--text-secondary, #585858)",
            "aria-hidden": "true",
            children: /* @__PURE__ */ e(la, { width: "16", height: "16", color: "var(--text-secondary, #585858)" })
          }
        )
      ] }),
      t && !r && !c && !s && /* @__PURE__ */ e(p, { fontSize: "1rem", fontWeight: "350", color: "gray.603", children: t }),
      r && !c && !s && /* @__PURE__ */ l(U, { direction: d ? "column-reverse" : "column", children: [
        /* @__PURE__ */ e(
          p,
          {
            noOfLines: 1,
            fontSize: "1rem",
            fontWeight: "350",
            lineHeight: "24px",
            color: a ? "gray.300" : "var(--text, #1C1C1C)",
            children: r
          }
        ),
        o && /* @__PURE__ */ e(
          p,
          {
            noOfLines: 1,
            fontSize: "12px",
            fontWeight: "350",
            lineHeight: "16px",
            color: a ? "gray.300" : "var(--text-secondary, #585858)",
            children: o
          }
        )
      ] })
    ]
  }
), La = ({ passwordSize: t, onComplete: r, onChange: a, onError: o, error: n, ...d }) => {
  const s = Q(null), [c, b] = P(""), [S, F] = P("typing"), [g, _] = P(), f = M(
    async (E) => {
      try {
        F("gradient"), _(void 0), await (r == null ? void 0 : r(E));
      } catch {
        F("error"), _("wrong");
      }
    },
    [r]
  ), m = M(
    (E) => {
      (E.key === "Enter" || E.keyCode === 13) && c.length < t && (_("incomplete"), F("error"));
    },
    [c.length, t]
  ), y = M(
    (E) => {
      E.currentTarget.value.length > t || (b(E.currentTarget.value), a == null || a(E.currentTarget.value), _(void 0), F("typing"), E.currentTarget.value.length === t && f(E.currentTarget.value));
    },
    [t, a, f]
  );
  return X(() => {
    o == null || o(g);
  }, [g, o]), X(() => {
    c.length > 0 && F("gradient");
  }, [c.length, F]), /* @__PURE__ */ l(le, { children: [
    /* @__PURE__ */ e(
      Ge,
      {
        height: "3.5rem",
        variant: S,
        ...{
          borderRadius: "1.875rem",
          justifyContent: "center",
          alignItems: "center",
          padding: "1rem 2rem",
          gap: "4"
        },
        w: "full",
        alignItems: "center",
        onClick: () => {
          var E;
          return (E = s.current) == null ? void 0 : E.focus();
        },
        children: /* @__PURE__ */ e(
          He,
          {
            "data-ph-capture-attribute-tracking-id": "pin-input",
            onKeyDown: m,
            onChange: y,
            value: c,
            ref: s,
            variant: "unstyled",
            placeholder: "✦✦✦✦✦✦",
            letterSpacing: "1.8rem",
            type: "text",
            inputMode: "numeric",
            pattern: "[0-9]*",
            autoComplete: "one-time-code",
            maxLength: t,
            m: "auto",
            w: "220px",
            ...d
          }
        )
      }
    ),
    /* @__PURE__ */ e(
      p,
      {
        py: "1.5",
        pl: "1.5",
        pr: "3",
        m: "auto",
        alignItems: "center",
        gap: "1",
        borderRadius: "1.25rem",
        bg: "danger.main",
        color: "white",
        fontSize: "sm",
        fontWeight: "350",
        lineHeight: "5",
        display: g ? "block" : "none",
        children: n
      }
    )
  ] });
}, sa = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.54093%200.00444388C6.03138%200.0269591%205.58306%200.0916887%205.12653%200.208668C3.76217%200.558261%202.55796%201.30757%201.63548%202.38094C0.7225%203.44327%200.156087%204.77825%200.0292969%206.16654C-0.00638949%206.55731%20-0.00872549%206.99172%200.0227817%207.37614C0.132657%208.71657%200.639697%209.99377%201.48116%2011.0497C1.75224%2011.3899%202.08093%2011.7275%202.42576%2012.02C3.20056%2012.677%204.15341%2013.1642%205.15533%2013.4155C6.12313%2013.6582%207.16946%2013.6823%208.1558%2013.4846C9.13938%2013.2874%2010.0862%2012.863%2010.8907%2012.2587C10.9488%2012.2151%2010.9982%2012.1793%2011.0005%2012.1793C11.0029%2012.1793%2011.8241%2012.9982%2012.8256%2013.9991C13.9925%2015.1652%2014.6661%2015.8338%2014.7009%2015.8605C14.7658%2015.9103%2014.8331%2015.954%2014.886%2015.9807L14.9246%2016.0001H15.1713H15.418L15.463%2015.9775C15.6635%2015.8766%2015.8765%2015.6635%2015.9775%2015.463L16.0001%2015.4181V15.1713V14.9246L15.9807%2014.886C15.954%2014.8331%2015.9102%2014.7658%2015.8605%2014.7009C15.8338%2014.6661%2015.1652%2013.9925%2013.9991%2012.8257C12.9982%2011.8242%2012.1793%2011.0029%2012.1793%2011.0006C12.1793%2010.9983%2012.215%2010.9488%2012.2587%2010.8907C12.7674%2010.2135%2013.1516%209.43003%2013.3765%208.61134C13.66%207.57898%2013.6937%206.45987%2013.473%205.40494C13.2785%204.4753%2012.8721%203.56239%2012.3127%202.799C12.0907%202.49598%2011.8961%202.26987%2011.6197%201.99348C11.4056%201.77953%2011.2611%201.6496%2011.0497%201.48118C10.3533%200.926249%209.55561%200.513519%208.70093%200.265941C8.18423%200.116271%207.6737%200.0326999%207.11693%200.00665188C6.99414%200.000904676%206.6508%20-0.000407324%206.54093%200.00444388ZM6.56333%201.66187C6.54925%201.66296%206.48877%201.66702%206.42893%201.6709C5.44838%201.73442%204.45692%202.1129%203.66413%202.72633C3.22196%203.06846%202.82226%203.49694%202.51603%203.95714C2.06999%204.62742%201.78667%205.39731%201.69318%206.1931C1.66525%206.43084%201.66091%206.51623%201.66132%206.81934C1.66172%207.11987%201.66775%207.22925%201.69648%207.45738C1.79583%208.24627%202.076%208.99733%202.52088%209.66734C2.80343%2010.0929%203.19346%2010.5163%203.60427%2010.8434C4.09778%2011.2364%204.6566%2011.5329%205.26733%2011.726C6.0863%2011.9849%206.99655%2012.0307%207.84741%2011.8558C8.64251%2011.6924%209.39508%2011.3391%2010.0257%2010.833C10.1694%2010.7177%2010.2622%2010.6343%2010.4215%2010.4773C10.6895%2010.2131%2010.8909%209.97183%2011.0845%209.68334C11.748%208.69477%2012.0469%207.5233%2011.9391%206.33448C11.8489%205.33981%2011.4661%204.38607%2010.8434%203.60429C10.6842%203.40442%2010.4354%203.13957%2010.2573%202.98053C9.79239%202.56512%209.2932%202.25381%208.72653%202.0259C8.20294%201.81531%207.66968%201.69708%207.09542%201.66427C6.99326%201.65844%206.62904%201.6568%206.56333%201.66187Z'%20fill='%238F8F8F'/%3e%3c/svg%3e", da = ({
  trackingId: t,
  isDisabled: r,
  onClick: a,
  label: o,
  placeholder: n,
  error: d = "",
  isRequired: s = !0
}) => {
  var F, g, _;
  const c = xr(), b = tt(), S = (_ = (g = (F = b == null ? void 0 : b.components) == null ? void 0 : F.Input) == null ? void 0 : g.variants) != null && _.just ? b : Ot;
  return /* @__PURE__ */ l(je, { variant: "mobileSelect", isInvalid: !!d, isDisabled: !!r, isRequired: s, children: [
    /* @__PURE__ */ l(
      Ge,
      {
        "data-ph-capture-attribute-tracking-id": t,
        borderRadius: "1.875rem",
        variant: "gradient",
        position: "relative",
        cursor: r ? "not-allowed" : "pointer",
        height: 14,
        fontSize: "md",
        onClick: () => !r && a(),
        pr: 12,
        pl: 4,
        pt: "25px",
        className: `${d ? " errored" : ""}${o === "" ? " empty" : ""}${r ? " disabled" : ""}`,
        __css: {
          "&.focused": {
            ...S.components.Input.variants.just.field._active
          },
          "&.errored": {
            ...S.components.Input.variants.just.field._invalid
          },
          "&.focused + label, &:not(.empty) + label": {
            ...S.components.Form.variants.floating.container._focusWithin.label,
            ...S.components.Form.variants.floating.container._hover.label
          },
          "&.disabled": {
            ...S.components.Input.variants.just.field._disabled
          },
          ...S.components.Input.variants.just.field
        },
        children: [
          o && /* @__PURE__ */ e(
            p,
            {
              noOfLines: 1,
              fontSize: "1rem",
              color: r ? qt.color : "var(--text, #1C1C1C)",
              bg: "transparent",
              children: o
            }
          ),
          /* @__PURE__ */ e(
            Nt,
            {
              right: "10px",
              top: "15px",
              color: r ? "gray.100" : "inherit",
              position: "absolute",
              fontSize: "2xl"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e(
      rt,
      {
        requiredIndicator: /* @__PURE__ */ e("abbr", { children: " *" }),
        htmlFor: c,
        bg: "transparent",
        style: {
          backgroundColor: "transparent"
        },
        children: n
      }
    ),
    d && /* @__PURE__ */ e(Ue, { pl: "4", fontSize: "xs", color: "danger.text", children: d })
  ] });
}, ca = 10, ba = 500, qe = (t, r) => {
  const a = et(t.label).toLowerCase(), o = et(r.label).toLowerCase();
  return a < o ? -1 : a > o ? 1 : 0;
}, Ma = $e(
  ({
    trackingId: t,
    searchTrackingId: r,
    optionTrackingId: a,
    options: o,
    favoriteOptions: n,
    label: d,
    searchLabel: s,
    onChange: c,
    value: b = "",
    error: S,
    name: F,
    isSearchable: g = !0,
    isRequired: _ = !0,
    isDisabled: f = !1,
    dataAutocomplete: m
  }, y) => {
    const { isOpen: C, onClose: E, onToggle: x } = or(), [$, j] = P(""), [H, D] = P(""), k = Q(null), A = () => {
      j(""), E();
    };
    X(() => {
      if (k.current && !H) {
        const i = k.current.getBoundingClientRect(), v = window.scrollY + window.innerHeight, w = i.top + window.scrollY;
        D(`${v - w - ca}px`);
      }
    }, [C, H]);
    const h = Z(
      () => n != null && n.length ? n.filter((i) => i.value !== b).sort(qe) : [],
      [n, b]
    ), G = Z(() => {
      if (!$) return o.filter((w) => !(n != null && n.includes(w))).sort(qe);
      const v = $.toLowerCase().split(" ");
      return o.filter((w) => et(w.label).toLowerCase().split(" ").some((N) => v.some((I) => N.startsWith(I))) && !(n != null && n.includes(w))).sort(qe);
    }, [o, $, n]), R = wr((i) => {
      var v;
      j(((v = i.target.value) == null ? void 0 : v.trim()) ?? "");
    }, ba);
    X(() => () => {
      R.cancel();
    }, []);
    const V = Z(
      () => {
        var i;
        return ((i = o.find((v) => v.value === b)) == null ? void 0 : i.label) ?? "";
      },
      [o, b]
    ), O = M((i) => {
      var w, B;
      const v = document.querySelector(`[name="${F}"]`);
      v && ((B = (w = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")) == null ? void 0 : w.set) == null || B.call(
        v,
        i
      ), v.dispatchEvent(new Event("change", { bubbles: !0 })));
    }, []), ee = M((i) => {
      const v = o.find((w) => w.value === i.target.value);
      c == null || c(v == null ? void 0 : v.value), A();
    }, []);
    return /* @__PURE__ */ l(u, { position: "relative", children: [
      /* @__PURE__ */ e(
        da,
        {
          trackingId: t,
          label: V,
          placeholder: d,
          onClick: x,
          isRequired: _,
          isDisabled: f,
          error: S
        }
      ),
      /* @__PURE__ */ e(
        "input",
        {
          type: "text",
          style: { display: "none" },
          name: F,
          "data-autocomplete": m,
          value: b,
          onChange: ee
        }
      ),
      C && /* @__PURE__ */ e(
        u,
        {
          overflow: "hidden",
          position: "absolute",
          top: "63px",
          left: "0",
          width: "full",
          height: H,
          maxH: "500px",
          backgroundColor: "var(--card-bg, white)",
          zIndex: 5,
          ref: k,
          padding: 4,
          borderRadius: "24px",
          border: "1px solid",
          borderColor: "gray.602",
          boxShadow: "2px 2px 10px 0px rgba(0, 0, 0, 0.05), -2px -2px 12px 0px rgba(0, 0, 0, 0.05);",
          children: /* @__PURE__ */ l(se, { spacing: 4, overflow: "hidden", maxH: "100%", children: [
            g && /* @__PURE__ */ l(xe, { position: "relative", rounded: "md", children: [
              /* @__PURE__ */ e(
                He,
                {
                  "data-ph-capture-attribute-tracking-id": r,
                  onChange: R,
                  bg: "var(--card-bg, #FFF)",
                  placeholder: s,
                  padding: "8px 12px 8px 44px"
                }
              ),
              /* @__PURE__ */ e(Lt, { children: /* @__PURE__ */ e(Fe, { src: sa, alt: "search icon", width: "16px", height: "16px", mt: "4", ml: "1" }) })
            ] }),
            b && /* @__PURE__ */ e(ze, { size: "lg", isReadOnly: !0, colorScheme: "fullBlack", isChecked: !0, mb: 2.5, children: V }),
            /* @__PURE__ */ l(nr, { onChange: O, value: b, ref: y, overflow: "scroll", children: [
              h.length ? /* @__PURE__ */ e(ne, { spacing: 6, alignItems: "start", mb: 3, children: h == null ? void 0 : h.map(({ value: i, label: v }) => /* @__PURE__ */ e(
                ze,
                {
                  variant: "nofloating",
                  display: i === b ? "none" : "flex",
                  size: "lg",
                  w: "full",
                  isChecked: i === b,
                  colorScheme: "fullBlack",
                  value: i,
                  "data-ph-capture-attribute-tracking-id": a,
                  children: /* @__PURE__ */ e("span", { "data-ph-capture-attribute-tracking-id": a, children: v })
                },
                i
              )) }) : /* @__PURE__ */ e(le, {}),
              /* @__PURE__ */ e(ve, { borderStyle: "dashed" }),
              /* @__PURE__ */ e(ne, { spacing: 6, mt: 3, alignItems: "start", children: G.map(({ value: i, label: v }) => /* @__PURE__ */ e(
                ze,
                {
                  variant: "nofloating",
                  display: i === b ? "none" : "flex",
                  size: "lg",
                  w: "full",
                  isChecked: i === b,
                  colorScheme: "fullBlack",
                  value: i,
                  "data-ph-capture-attribute-tracking-id": a,
                  children: /* @__PURE__ */ e("span", { "data-ph-capture-attribute-tracking-id": a, children: v })
                },
                i
              )) })
            ] })
          ] })
        }
      )
    ] });
  }
), Ta = ({
  icon: t,
  title: r,
  sentence: a,
  accept: o,
  decline: n,
  acceptColor: d,
  containerRef: s,
  onDecline: c,
  onAccept: b,
  isOpen: S
}) => {
  const F = Q(null);
  return /* @__PURE__ */ l(
    ar,
    {
      portalProps: {
        containerRef: s
      },
      motionPreset: "slideInBottom",
      leastDestructiveRef: F,
      onClose: c,
      isOpen: S,
      children: [
        /* @__PURE__ */ e(ir, {}),
        /* @__PURE__ */ l(
          lr,
          {
            maxW: "18rem",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "1.25rem",
            p: "6",
            bg: "var(--card-bg, #FFF)",
            color: "var(--text, #1C1C1C)",
            children: [
              /* @__PURE__ */ e(u, { display: "flex", justifyContent: "center", pb: "6", children: t }),
              /* @__PURE__ */ e(
                sr,
                {
                  pb: "2",
                  px: "0",
                  pt: "0",
                  color: "var(--text, #1C1C1C)",
                  textAlign: "center",
                  fontWeight: "medium",
                  lineHeight: "6",
                  children: r
                }
              ),
              /* @__PURE__ */ e(
                dr,
                {
                  fontSize: "0.8125rem",
                  color: "var(--text, #1C1C1C)",
                  textAlign: "center",
                  lineHeight: "5",
                  pb: "4",
                  px: "0",
                  pt: "0",
                  children: a
                }
              ),
              /* @__PURE__ */ e(cr, { p: "0", children: /* @__PURE__ */ l(se, { width: "100%", gap: "4", children: [
                /* @__PURE__ */ e(ve, { borderColor: "var(--border, #E0E0E0)" }),
                /* @__PURE__ */ e(
                  fe,
                  {
                    variant: "ghost",
                    color: d ?? "var(--text, #1C1C1C)",
                    onClick: b,
                    _hover: {
                      bg: "var(--border, #E0E0E0)"
                    },
                    children: o
                  }
                ),
                /* @__PURE__ */ e(ve, { borderColor: "var(--border, #E0E0E0)" }),
                /* @__PURE__ */ e(
                  fe,
                  {
                    onClick: c,
                    variant: "ghost",
                    color: "var(--text, #1C1C1C)",
                    _hover: {
                      bg: "var(--border, #E0E0E0)"
                    },
                    children: n
                  }
                )
              ] }) })
            ]
          }
        )
      ]
    }
  );
}, Pa = ({ children: t, ...r }) => /* @__PURE__ */ e(p, { lineHeight: "24px", fontSize: "1.125rem", className: "leaf__heading", ...r, children: t }), Na = ({ children: t, ...r }) => /* @__PURE__ */ e(p, { lineHeight: "6", fontSize: "md", fontStyle: "normal", fontWeight: "350", className: "leaf__body", ...r, children: t }), Ya = ({ children: t, ...r }) => /* @__PURE__ */ e(p, { fontSize: "md", fontWeight: "medium", lineHeight: "6", className: "leaf__caption", ...r, children: t }), qa = ({ children: t, ...r }) => /* @__PURE__ */ e(
  p,
  {
    color: "#1C1C1C",
    fontSize: "0.75rem",
    lineHeight: "20px",
    fontWeight: 600,
    className: "leaf__info",
    ...r,
    children: t
  }
), Oa = ({ components: t, show: r }) => /* @__PURE__ */ e(le, { children: t[r] }), Va = ({ back: t, onBack: r, isOpen: a, children: o, variantButton: n, ...d }) => a ? /* @__PURE__ */ e(
  u,
  {
    position: "absolute",
    top: "0",
    left: "0",
    as: "main",
    flex: "1 1 auto",
    overflow: "auto",
    p: "0",
    m: "0",
    height: "full",
    width: "full",
    display: "flex",
    backgroundColor: "var(--toast-overlay-bg) !important",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    alignSelf: "center",
    zIndex: "10000",
    children: /* @__PURE__ */ l(
      se,
      {
        display: "flex",
        alignItems: "flex-start",
        alignSelf: "center",
        backgroundColor: "var(--toast-bg)",
        w: "21.56rem",
        minH: "16rem",
        maxH: "80vh",
        borderRadius: "1.5rem",
        border: "1px solid",
        borderColor: "var(--toast-border)",
        boxShadow: "var(--toast-shadow)",
        pt: "8",
        px: "6",
        pb: "6",
        alignContent: "center",
        justifyContent: "space-between",
        ...d,
        children: [
          /* @__PURE__ */ e(u, { flex: "1", overflowY: "auto", w: "full", children: o }),
          /* @__PURE__ */ e(
            Re,
            {
              onClick: () => {
                r(void 0);
              },
              variant: n ?? "secondary",
              label: t,
              w: "full",
              h: "14",
              mt: "4"
            }
          )
        ]
      }
    )
  }
) : /* @__PURE__ */ e(le, {}), Xa = ({ loadingColor: t, delay: r, duration: a, ...o }) => /* @__PURE__ */ e(u, { className: "loading-container", ...o, children: /* @__PURE__ */ e(u, { className: "loading-bar", bgColor: t, animation: `loadingAnimation ${a ?? 1800}ms ${r ?? 0}ms infinite` }) }), pa = 15, Ka = ({
  labels: t,
  disabled: r,
  products: a,
  onOpenProduct: o,
  onQuickAdd: n,
  variantIdsInCart: d,
  onDisplay: s,
  cardWidth: c,
  maxProducts: b,
  pager: S,
  layout: F = "scroll"
}) => {
  const [g, _] = P(0), f = Q(null), m = Q([]), y = Tt({ base: !0, md: !1 }), [C, E] = P(!1), x = Q(0), $ = Q(0), j = Q(!1), { themeName: H } = de(), D = Z(
    () => ({
      cardBg: "var(--upsell-card-bg)",
      borderActive: "var(--upsell-border-active)",
      borderDefault: "var(--upsell-border-default)",
      iconColor: "var(--upsell-icon)"
    }),
    [H]
  ), k = Z(() => a.filter(
    ({ variants: i = [] }) => i.some((v) => d.includes(v.id)) === !1
  ).slice(0, b ?? pa), [a, d, b]);
  X(() => {
    s && k.length > 0 && s(k);
  }, [k, s]);
  const A = M((i) => {
    var v;
    !(f != null && f.current) || !(m != null && m.current[i]) || (v = m.current[i]) == null || v.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    });
  }, []), h = M(() => {
    const i = Math.max(0, g - 1);
    A(i);
  }, [g, A]), G = M(() => {
    const i = Math.min(k.length - 1, g + 1);
    A(i);
  }, [g, k.length, A]), z = M((i) => {
    f.current && (E(!0), j.current = !1, x.current = i.pageX, $.current = f.current.scrollLeft);
  }, []), R = M(
    (i) => {
      if (!C || !f.current) return;
      i.preventDefault();
      const v = i.pageX;
      Math.abs(v - x.current) > 5 && (j.current = !0);
      const w = (v - x.current) * 2;
      f.current.scrollLeft = $.current - w;
    },
    [C]
  ), V = M(() => {
    E(!1);
  }, []), O = M(() => {
    E(!1);
  }, []);
  if (X(() => {
    if (!f.current) return;
    m.current = m.current.slice(0, k.length);
    const i = {
      root: f.current,
      rootMargin: "0px",
      threshold: 0.7
      // Element is considered visible when 70% in view
    }, v = (B) => {
      const W = B.reduce((N, I) => I.intersectionRatio > N.intersectionRatio ? I : N, B[0]);
      if (W.isIntersecting) {
        const N = m.current.findIndex((I) => I === W.target);
        N !== -1 && N !== g && _(N);
      }
    }, w = new IntersectionObserver(v, i);
    return m.current.forEach((B) => {
      B && w.observe(B);
    }), () => w.disconnect();
  }, [k.length, g]), k.length === 0)
    return null;
  const ee = (i) => {
    var N;
    const v = i.variants.map((I) => I.price), w = Math.min(...v), B = v.every((I) => I === w), W = ((N = i.variants[0]) == null ? void 0 : N.currency) ?? "EUR";
    return B ? oe(w, { currency: W }) : t.fromPrice.replace("{{price}}", oe(w, { currency: W }));
  };
  if (F === "grid") {
    const i = k.slice(0, 5), v = "calc((100% - 1.5rem) / 3)";
    return /* @__PURE__ */ l(
      u,
      {
        mt: "4",
        width: "100%",
        pointerEvents: r ? "none" : "auto",
        cursor: r ? "not-allowed" : "auto",
        children: [
          /* @__PURE__ */ e(
            ft,
            {
              as: "h2",
              mb: 2.5,
              fontSize: "sm",
              fontWeight: "600",
              lineHeight: "1.4",
              color: "var(--text, #1C1C1C)",
              children: t.title
            }
          ),
          /* @__PURE__ */ e(
            U,
            {
              gap: 3,
              align: "stretch",
              w: "full",
              overflowX: "auto",
              overflowY: "hidden",
              css: {
                "&::-webkit-scrollbar": { display: "none" },
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                scrollSnapType: "x mandatory",
                WebkitOverflowScrolling: "touch"
              },
              children: i.map((w) => {
                var B;
                return /* @__PURE__ */ l(
                  u,
                  {
                    w: v,
                    flexShrink: 0,
                    css: { scrollSnapAlign: "start" },
                    p: 2,
                    position: "relative",
                    borderWidth: "1px",
                    borderRadius: "16px",
                    borderColor: D.borderDefault,
                    background: D.cardBg,
                    children: [
                      /* @__PURE__ */ l(u, { position: "relative", w: "full", sx: { aspectRatio: "1 / 1" }, children: [
                        /* @__PURE__ */ e(
                          Fe,
                          {
                            w: "full",
                            h: "full",
                            objectFit: "cover",
                            borderRadius: "10px",
                            draggable: !1,
                            alt: w.name,
                            loading: "lazy",
                            src: w.imageUrl ?? ((B = w.variants[0]) == null ? void 0 : B.imageUrl),
                            fallback: /* @__PURE__ */ e(u, { w: "full", h: "full", borderRadius: "10px", background: "lightgray" })
                          }
                        ),
                        n ? /* @__PURE__ */ e(
                          u,
                          {
                            as: "button",
                            type: "button",
                            zIndex: 2,
                            boxSize: "34px",
                            bottom: "8px",
                            right: "8px",
                            bg: "white",
                            color: "#1C1C1C",
                            display: "flex",
                            border: "1px solid",
                            position: "absolute",
                            borderRadius: "full",
                            alignItems: "center",
                            justifyContent: "center",
                            borderColor: "rgba(0, 0, 0, 0.08)",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.18)",
                            transition: "transform 0.12s ease",
                            _active: { transform: "scale(0.92)" },
                            "aria-label": t.addToCart ?? "Add",
                            onClick: (W) => {
                              W.stopPropagation(), n(w);
                            },
                            "data-ph-capture-attribute-tracking-id": "upsell-card-quick-add-button",
                            children: /* @__PURE__ */ e(vr, { boxSize: "14px" })
                          }
                        ) : null
                      ] }),
                      /* @__PURE__ */ e(
                        p,
                        {
                          mt: 2,
                          fontSize: "sm",
                          fontWeight: "medium",
                          lineHeight: "1.3",
                          color: "var(--text, #1C1C1C)",
                          css: {
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden"
                          },
                          children: w.name
                        }
                      ),
                      /* @__PURE__ */ e(p, { mt: 1, fontSize: "sm", color: "var(--text-secondary, #585858)", children: ee(w) }),
                      /* @__PURE__ */ e(
                        u,
                        {
                          as: "button",
                          type: "button",
                          zIndex: 1,
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          bg: "transparent",
                          cursor: "pointer",
                          position: "absolute",
                          borderRadius: "16px",
                          "aria-label": w.name,
                          onClick: () => o(w),
                          "data-ph-capture-attribute-tracking-id": "upsell-card-open-modal-button"
                        }
                      )
                    ]
                  },
                  w.id
                );
              })
            }
          )
        ]
      }
    );
  }
  return /* @__PURE__ */ l(
    u,
    {
      mt: "4",
      width: "100%",
      position: "relative",
      pointerEvents: r ? "none" : "auto",
      cursor: r ? "not-allowed" : "auto",
      children: [
        /* @__PURE__ */ e(
          ft,
          {
            as: "h2",
            fontWeight: "600",
            fontSize: "sm",
            lineHeight: "1.4",
            color: "var(--text, #1C1C1C)",
            mb: 2.5,
            children: t.title
          }
        ),
        /* @__PURE__ */ e(
          J,
          {
            spacing: 2,
            align: "stretch",
            ref: f,
            overflowX: "auto",
            overflowY: "hidden",
            position: "relative",
            onMouseUp: V,
            onMouseDown: z,
            onMouseMove: R,
            onMouseLeave: O,
            css: {
              "&::-webkit-scrollbar": {
                display: "none"
              },
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              scrollBehavior: "smooth",
              scrollSnapType: "x mandatory",
              WebkitOverflowScrolling: "touch",
              cursor: C ? "grabbing" : "grab"
            },
            children: k.map((i, v) => {
              var te, ae;
              const w = i.variants.map((re) => re.price), B = Math.min(...w), W = w.every((re) => re === B), N = ((te = i.variants[0]) == null ? void 0 : te.currency) ?? "EUR", I = W ? oe(B, { currency: N }) : t.fromPrice.replace("{{price}}", oe(B, { currency: N }));
              return /* @__PURE__ */ e(
                u,
                {
                  as: "button",
                  type: "button",
                  p: 3,
                  minW: c ?? "230px",
                  maxW: c ?? "300px",
                  flexShrink: 0,
                  textAlign: "left",
                  borderWidth: "1px",
                  borderRadius: "16px",
                  transition: "all 0.2s ease",
                  borderColor: D.borderDefault,
                  background: D.cardBg,
                  onClick: () => {
                    j.current || o(i);
                  },
                  ref: (re) => {
                    m.current[v] = re;
                  },
                  _hover: { borderColor: D.borderActive, transform: "translateY(-1px)" },
                  _active: { transform: "translateY(0)", opacity: 0.9 },
                  css: {
                    userSelect: "none",
                    scrollSnapAlign: "start",
                    cursor: "pointer"
                  },
                  "data-ph-capture-attribute-tracking-id": "upsell-card-open-modal-button",
                  children: /* @__PURE__ */ l(U, { gap: 2, alignItems: "center", children: [
                    /* @__PURE__ */ e(
                      mt,
                      {
                        boxSize: "80px",
                        flexShrink: 0,
                        objectFit: "cover",
                        borderRadius: "md",
                        draggable: !1,
                        alt: i.name,
                        src: i.imageUrl ?? ((ae = i.variants[0]) == null ? void 0 : ae.imageUrl),
                        background: "lightgray 50% / cover no-repeat"
                      }
                    ),
                    /* @__PURE__ */ l(ne, { align: "stretch", flex: 1, gap: 1, overflow: "hidden", children: [
                      /* @__PURE__ */ e(
                        p,
                        {
                          fontSize: "sm",
                          color: "var(--text, #1C1C1C)",
                          overflow: "hidden",
                          fontWeight: "medium",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          children: i.name
                        }
                      ),
                      /* @__PURE__ */ e(p, { color: "var(--text-secondary, #585858)", fontSize: "xs", children: I })
                    ] }),
                    /* @__PURE__ */ e(xt, { w: 5, h: 5, color: D.iconColor, flexShrink: 0 })
                  ] })
                },
                i.id
              );
            })
          }
        ),
        (S ? S === "dots" : y) ? /* @__PURE__ */ e(J, { justify: "center", mt: 4, spacing: 2, children: k.map((i, v) => /* @__PURE__ */ e(
          u,
          {
            w: "10px",
            h: "10px",
            cursor: "pointer",
            border: "1px solid",
            borderRadius: "full",
            borderColor: "gray.603",
            onClick: () => A(v),
            bg: g === v ? "gray.603" : "transparent"
          },
          v
        )) }) : /* @__PURE__ */ l(U, { flexDir: "row", w: "full", gap: 6, alignItems: "center", justifyContent: "center", mt: 4, children: [
          /* @__PURE__ */ e(
            Ft,
            {
              w: 6,
              h: 6,
              color: D.iconColor,
              bgColor: "transparent",
              onClick: h,
              icon: /* @__PURE__ */ e(Sr, {}),
              _disabled: { opacity: 0.5 },
              isDisabled: g === 0,
              "aria-label": t.previousProduct,
              _hover: { bgColor: "transparent" },
              _active: { bgColor: "transparent" },
              "data-ph-capture-attribute-tracking-id": "upsell-carousel-previous-button"
            }
          ),
          /* @__PURE__ */ l(p, { color: "var(--text-secondary, #585858)", fontSize: "xs", children: [
            g + 1,
            " / ",
            k.length
          ] }),
          /* @__PURE__ */ e(
            Ft,
            {
              w: 6,
              h: 6,
              color: D.iconColor,
              onClick: G,
              bgColor: "transparent",
              icon: /* @__PURE__ */ e(xt, {}),
              _disabled: { opacity: 0.5 },
              "aria-label": t.nextProduct,
              _hover: { bgColor: "transparent" },
              _active: { bgColor: "transparent" },
              isDisabled: g === k.length - 1,
              "data-ph-capture-attribute-tracking-id": "upsell-carousel-next-button"
            }
          )
        ] })
      ]
    }
  );
}, ga = (t) => !t.available || t.quantityAvailable === 0, ua = ({
  variants: t,
  selectedVariantId: r,
  variantIdsInCart: a,
  soldOutLabel: o,
  inCartLabel: n,
  onSelect: d,
  ariaLabelledBy: s
}) => t.length <= 1 ? null : /* @__PURE__ */ e(
  U,
  {
    className: "upsell-variant-chips",
    role: "radiogroup",
    "aria-labelledby": s,
    gap: 2,
    wrap: "wrap",
    maxH: "8.5rem",
    overflowY: "auto",
    children: t.map((c) => {
      const b = ga(c), S = c.id === r, F = a.includes(c.id), g = b ? ` · ${o}` : F ? ` · ${n}` : "";
      return /* @__PURE__ */ l(
        u,
        {
          as: "button",
          type: "button",
          role: "radio",
          "aria-checked": S,
          "aria-disabled": b,
          disabled: b,
          onClick: () => !b && d(c.id),
          px: 3,
          py: 2,
          fontSize: "sm",
          borderRadius: "12px",
          border: "1px solid",
          transition: "all 0.15s ease",
          borderColor: S ? "var(--upsell-border-active)" : "var(--border)",
          background: S ? "var(--upsell-card-bg-active)" : "var(--upsell-card-bg)",
          color: S ? "var(--upsell-text)" : "var(--text-secondary)",
          fontWeight: S ? 500 : 400,
          opacity: b ? 0.45 : 1,
          textDecoration: b ? "line-through" : "none",
          cursor: b ? "not-allowed" : "pointer",
          children: [
            c.name,
            g
          ]
        },
        c.id
      );
    })
  }
), Rt = [0.32, 0.72, 0, 1], Gt = (t) => !t.available || t.quantityAvailable === 0, Ja = ({
  isOpen: t,
  product: r,
  variantIdsInCart: a,
  showQuantityAvailable: o,
  isAdding: n,
  justAdded: d,
  errorMessage: s,
  labels: c,
  onClose: b,
  onAddToCart: S,
  onVariantSelected: F
}) => {
  const g = Tt({ base: !0, md: !1 }), [_, f] = P(void 0);
  X(() => {
    var B;
    if (!r) {
      f(void 0);
      return;
    }
    f((B = r.variants.find((W) => !Gt(W))) == null ? void 0 : B.id);
  }, [r]);
  const m = Z(
    () => r == null ? void 0 : r.variants.find((B) => B.id === _),
    [r, _]
  ), y = !!r && r.variants.every(Gt), C = (m == null ? void 0 : m.imageUrl) ?? (r == null ? void 0 : r.imageUrl), E = m ? oe(m.price, { currency: m.currency ?? "EUR" }) : "", x = r == null ? void 0 : r.description, $ = o && (m != null && m.available) && typeof m.quantityAvailable == "number" && m.quantityAvailable > 0 && m.quantityAvailable < 10 ? (m.quantityAvailable === 1 ? c.leftQuantity.singular : c.leftQuantity.plural).replace("{{count}}", String(m.quantityAvailable)) : null, j = (B) => {
    f(B);
    const W = r == null ? void 0 : r.variants.find((N) => N.id === B);
    r && W && (F == null || F(r, W));
  }, H = () => {
    !r || !m || n || S(r, m);
  }, D = Z(() => {
    if (!r) return [];
    const B = [r.imageUrl, ...r.variants.map((W) => W.imageUrl)].filter(
      (W) => !!W
    );
    return Array.from(new Set(B));
  }, [r]), [k, A] = P(!1), [h, G] = P(0), z = Q(null), R = M(() => {
    if (!D.length) return;
    const B = C ? D.indexOf(C) : 0;
    G(B < 0 ? 0 : B), A(!0);
  }, [D, C]);
  X(() => {
    if (!k) return;
    const B = z.current;
    B && (B.scrollLeft = h * B.clientWidth);
  }, [k]);
  const V = () => {
    const B = z.current;
    if (!B) return;
    const W = Math.round(B.scrollLeft / B.clientWidth);
    G((N) => N === W ? N : W);
  }, O = r ? /* @__PURE__ */ l(
    u,
    {
      as: "button",
      type: "button",
      display: "block",
      p: 0,
      border: "none",
      bg: "transparent",
      position: "relative",
      w: "full",
      h: { base: "14rem", md: "16rem" },
      onClick: D.length ? R : void 0,
      cursor: D.length ? "pointer" : "default",
      "aria-label": D.length ? "View image" : void 0,
      children: [
        /* @__PURE__ */ e(
          mt,
          {
            boxSize: "full",
            borderRadius: 0,
            objectFit: "cover",
            alt: r.name,
            src: C,
            background: "var(--bg-secondary)"
          },
          C
        ),
        D.length > 0 && /* @__PURE__ */ e(
          U,
          {
            position: "absolute",
            bottom: 2,
            right: 2,
            w: "1.75rem",
            h: "1.75rem",
            borderRadius: "full",
            align: "center",
            justify: "center",
            bg: "rgba(0, 0, 0, 0.5)",
            color: "#fff",
            pointerEvents: "none",
            children: /* @__PURE__ */ e(Cr, { boxSize: 3 })
          }
        )
      ]
    }
  ) : null, ee = r ? /* @__PURE__ */ l(le, { children: [
    /* @__PURE__ */ e(p, { fontSize: "xl", fontWeight: 700, color: "var(--text)", noOfLines: 2, mb: 1, children: r.name }),
    !y && /* @__PURE__ */ e(p, { fontSize: "lg", fontWeight: 600, color: "var(--text)", children: E }),
    /* @__PURE__ */ e(U, { align: "center", gap: 2, wrap: "wrap", mt: 2, mb: $ ? 2 : 4, children: /* @__PURE__ */ l(
      U,
      {
        align: "center",
        gap: 1,
        px: 2.5,
        py: 1,
        borderRadius: "full",
        bg: "var(--bg-secondary)",
        color: "var(--text-secondary)",
        fontSize: "xs",
        fontWeight: 600,
        children: [
          /* @__PURE__ */ e(Br, { boxSize: 2.5 }),
          /* @__PURE__ */ e(p, { as: "span", children: c.recommendedBadge })
        ]
      }
    ) }),
    $ && /* @__PURE__ */ e(p, { mb: 4, fontSize: "sm", fontWeight: 700, lineHeight: "1.35", color: "var(--danger)", children: $ }),
    x && /* @__PURE__ */ l(u, { mb: 5, pb: 5, borderBottom: "1px solid var(--border)", children: [
      /* @__PURE__ */ e(p, { fontSize: "xs", textTransform: "uppercase", color: "var(--text-muted)", mb: 1, children: c.description }),
      /* @__PURE__ */ e(p, { fontSize: "sm", lineHeight: "1.6", color: "var(--text-secondary)", children: x })
    ] }),
    r.variants.length > 1 && /* @__PURE__ */ l(u, { children: [
      /* @__PURE__ */ e(p, { id: "upsell-variant-label", fontSize: "sm", fontWeight: 500, color: "var(--text)", mb: 2, children: c.selectVariant }),
      /* @__PURE__ */ e(
        ua,
        {
          ariaLabelledBy: "upsell-variant-label",
          variants: r.variants,
          selectedVariantId: _,
          variantIdsInCart: a,
          soldOutLabel: c.soldOut,
          inCartLabel: c.inCart,
          onSelect: j
        }
      )
    ] })
  ] }) : null, i = /* @__PURE__ */ l(u, { w: "full", pb: "max(16px, env(safe-area-inset-bottom))", children: [
    s && /* @__PURE__ */ e(p, { mb: 2, fontSize: "sm", color: "var(--danger)", textAlign: "center", children: s }),
    y ? /* @__PURE__ */ e(
      fe,
      {
        isDisabled: !0,
        w: "full",
        h: "48px",
        borderRadius: "12px",
        background: "var(--input-bg-disabled)",
        color: "var(--text-muted)",
        _hover: { background: "var(--input-bg-disabled)" },
        children: c.soldOut
      }
    ) : /* @__PURE__ */ e(
      fe,
      {
        w: "full",
        h: "48px",
        borderRadius: "12px",
        onClick: H,
        isDisabled: n || !m,
        background: "var(--pay-button-bg-enabled, #1C1C1C)",
        color: "var(--pay-button-text-enabled, #FFFFFF)",
        _hover: { background: "var(--pay-button-bg-enabled, #1C1C1C)" },
        _active: { background: "var(--pay-button-bg-enabled, #1C1C1C)" },
        "data-ph-capture-attribute-tracking-id": "upsell-modal-add-to-cart-button",
        children: n ? /* @__PURE__ */ e(br, { size: "sm" }) : d ? c.added : c.addToCart
      }
    )
  ] }), v = /* @__PURE__ */ e(
    u,
    {
      as: "button",
      type: "button",
      onClick: b,
      "aria-label": "Close",
      position: "absolute",
      top: 3,
      right: 3,
      zIndex: 1,
      w: "2rem",
      h: "2rem",
      borderRadius: "full",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bg: "rgba(255, 255, 255, 0.92)",
      color: "#1C1C1C",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.18)",
      children: /* @__PURE__ */ e(Ve, { boxSize: 2.5 })
    }
  ), w = k && D.length > 0 ? Pt(
    /* @__PURE__ */ l(
      u,
      {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 3e3,
        bg: "rgba(0, 0, 0, 0.92)",
        display: "flex",
        flexDirection: "column",
        children: [
          /* @__PURE__ */ e(
            u,
            {
              as: "button",
              type: "button",
              onClick: () => A(!1),
              "aria-label": "Close",
              position: "absolute",
              top: 4,
              right: 4,
              zIndex: 1,
              w: "2.25rem",
              h: "2.25rem",
              borderRadius: "full",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bg: "rgba(255, 255, 255, 0.16)",
              color: "#fff",
              children: /* @__PURE__ */ e(Ve, { boxSize: 3 })
            }
          ),
          /* @__PURE__ */ e(
            U,
            {
              ref: z,
              flex: "1",
              minH: 0,
              overflowX: "auto",
              overflowY: "hidden",
              onScroll: V,
              sx: {
                scrollSnapType: "x mandatory",
                WebkitOverflowScrolling: "touch",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": { display: "none" }
              },
              children: D.map((B) => /* @__PURE__ */ e(
                U,
                {
                  minW: "100%",
                  h: "100%",
                  flexShrink: 0,
                  align: "center",
                  justify: "center",
                  px: 4,
                  sx: { scrollSnapAlign: "center" },
                  children: /* @__PURE__ */ e(Fe, { src: B, alt: r == null ? void 0 : r.name, maxW: "100%", maxH: "100%", objectFit: "contain" })
                },
                B
              ))
            }
          ),
          D.length > 1 && /* @__PURE__ */ e(U, { justify: "center", gap: 2, py: 5, children: D.map((B, W) => /* @__PURE__ */ e(
            u,
            {
              w: "8px",
              h: "8px",
              borderRadius: "full",
              bg: W === h ? "#fff" : "rgba(255, 255, 255, 0.4)"
            },
            B
          )) })
        ]
      }
    ),
    document.body
  ) : null;
  return g ? /* @__PURE__ */ l(le, { children: [
    /* @__PURE__ */ e(We, { children: t && /* @__PURE__ */ e(
      Se.div,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 0.25, ease: Rt },
        onClick: b,
        style: { position: "fixed", inset: 0, background: "rgba(0, 0, 0, 0.4)", zIndex: 2e3 }
      },
      "upsell-sheet-scrim"
    ) }),
    /* @__PURE__ */ e(We, { children: t && r && /* @__PURE__ */ l(
      Se.div,
      {
        role: "dialog",
        "aria-modal": "true",
        initial: { y: "100%" },
        animate: { y: 0 },
        exit: { y: "100%" },
        transition: { duration: 0.35, ease: Rt },
        style: {
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2001,
          display: "flex",
          flexDirection: "column",
          maxHeight: "88vh",
          overflow: "hidden",
          background: "var(--card-bg)",
          borderTopLeftRadius: "1.25rem",
          borderTopRightRadius: "1.25rem",
          boxShadow: "0 -8px 32px rgba(0, 0, 0, 0.18)"
        },
        children: [
          v,
          /* @__PURE__ */ l(u, { overflowY: "auto", flex: "1", minH: 0, children: [
            O,
            /* @__PURE__ */ e(u, { px: 4, pt: 4, pb: 4, children: ee })
          ] }),
          /* @__PURE__ */ e(u, { px: 4, pt: 2, children: i })
        ]
      },
      "upsell-sheet"
    ) }),
    w
  ] }) : /* @__PURE__ */ l(le, { children: [
    /* @__PURE__ */ l(pr, { isOpen: t, onClose: b, isCentered: !0, scrollBehavior: "inside", size: "md", children: [
      /* @__PURE__ */ e(gr, {}),
      /* @__PURE__ */ l(ur, { bg: "var(--card-bg)", color: "var(--text)", borderRadius: "2xl", mx: 4, overflow: "hidden", children: [
        /* @__PURE__ */ e(
          mr,
          {
            zIndex: 1,
            bg: "rgba(255, 255, 255, 0.92)",
            color: "#1C1C1C",
            borderRadius: "full",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.18)",
            _hover: { bg: "rgba(255, 255, 255, 1)" }
          }
        ),
        /* @__PURE__ */ l(hr, { p: 0, children: [
          O,
          /* @__PURE__ */ e(u, { px: 6, pt: 4, pb: 2, children: ee })
        ] }),
        /* @__PURE__ */ e(fr, { flexDirection: "column", alignItems: "stretch", pt: 2, children: i })
      ] })
    ] }),
    w
  ] });
};
export {
  Na as Body,
  Ge as BoxGradient,
  Re as Button,
  Ln as CHECKOUT_THEMES,
  Ya as Caption,
  za as Card,
  ja as Cart,
  Ta as Confirm,
  gt as DEFAULT_CHECKOUT_THEME,
  Oa as DisplaySwitcher,
  Pa as Heading,
  qa as Info,
  Zt as Input,
  Ha as InputRhf,
  Jt as InputWithIcon,
  Wa as InputWithIconRhf,
  Vn as JustDrawer,
  Xa as JustSkeleton,
  Va as JustToast,
  Da as LeafThemeProvider,
  Ma as MobileSelect,
  $a as PhoneInput,
  La as PinInput,
  Ra as PlaceholderDropdown,
  Ga as PlaceholderDropdownCard,
  ra as ProductSkeleton,
  Ua as Radio,
  Ka as UpsellCarousel,
  Ja as UpsellProductModal,
  Aa as getCustomThemeOverrides,
  Ea as getThemeByName,
  Ia as getThemeCssVariables,
  _a as isValidCheckoutTheme,
  Ot as theme,
  On as useJustDrawer,
  de as useLeafTheme
};
